define(['checkout_helper','addtocart','preauthchargesmodal'], function(checkout_helper, addtocart, preauthchargesmodal) {
  var OrderItems = {
    /**
     * Fires the OrderItemsLoaded event.
     */
    loaded: function() {
      COSTCO.Global.notify('OrderItemsLoaded');
    },
    
    /**
     * this variable will prevent
     * multiple calls to sms update command
     */
    smsPhoneUpdateStarted : false,
  /**
    * this variable will prevent
    * multiple calls to AjaxRefreshFreightSavingsCmdImpl
    */
    initalloadCompleted : false,
    notSoldUrl :undefined,
    globalCalendarMap : undefined,
    apiAlreadyCalled : undefined,
    /**
     * This function should be called from the including module.
     * @return {void}
     */
    init: function() {
      this.ltlMessages();
      this.tooltips();
      this.popovers();
      this.validationRules();
      COSTCO.EDDService.callEddService();
      COSTCO.OrderItems.updateShipModeToPickUp(false);
      if (!COSTCO.util.isBusinessDelivery()) {
        this.autoSelectDeliveryOption();
      }
      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_OPTIONS_FEATURE_ENABLED === true) {
    	  $('body').unbind('change').on('change', '#ShopCartForm select[id="cart-options"]', function (event) {
    		  COSTCO.OrderItems.cartOptionsHandler(event);
    	  });
      }
      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
          if (checkoutPage === 'review') {
              $('.resale_option').unbind('click').on('click', function(){
                  COSTCO.OrderItems.resaleOptionHandler(this,true);
              });
          }
      }
      if ($('#isBDAppVar').val() == 'BD') {
    	  if($('#delivery-zip-shipping') && $('#delivery-zip-shipping').length==1) {
    		  $('#delivery-zip-shipping').append(COSTCO.util.tmpl('template_shipping'));
    	  }
    	  if($('#delivery-zip-review') && $('#delivery-zip-review').length==1) {
    		  $('#delivery-zip-review').append(COSTCO.util.tmpl('template_review'));
    	  }
    	  if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_OPTIONS_FEATURE_ENABLED === false) {
    	  $("#ShopCartForm select[id='cart-options']").unbind('change').change(function (event) {
    		  COSTCO.OrderItems.cartOptionsHandler(event);
    	  }); 
    	  }
    	  //Resale radio and text view switch based on page
    	  COSTCO.OrderItems.setResaleOptionView();
    	  
    	  if (checkoutPage && costcoStoreFeatures.RESALE_FEATURE_ENABLED === true) {
    	    COSTCO.OrderItems.nonTaxableAllChecked();
    	  }
    	  
    	  COSTCO.OrderItems.setDeliveryDateView();
    	  
    	  COSTCO.OrderItems.updateShipmodeDetails();
    	  
    	  $('#delivery-date-block-change').unbind('click').on('click', COSTCO.OrderItems.showDatePickerFocus);

    	  if (checkoutPage === 'confirmation') {
    		  COSTCO.OrderItems.formatDateForOCP();
    	  }

    	  if (checkoutPage === 'cart') {
    		  console.log('cart');
        	  $('.resale_option').unbind('click').on('click', function(){
        		  COSTCO.OrderItems.resaleOptionHandler(this,true);
        	  });
          }
    	    
      }
      
      // binding events to quantity input which call update when input is changed (on blur and when ENTER is pressed)
      this.addQuantityEventHandlers();

      COSTCO.util.resetScreenReaderAnnouncement();
      COSTCO.util.announceSRGlobalErrorMessage();
		  
	// binding events to quantity input which call update when input is changed (on blur and when ENTER is pressed)
      COSTCO.util.resetScreenReaderAnnouncement();
      COSTCO.util.announceSRGlobalErrorMessage();
      // Start mutation observer for Narvar EDD, except on payment and confirmation (orderitems - init)
      if (checkoutPage !== 'payment') {
          if (checkoutPage !== 'confirmation') {
        	 COSTCO.Header.startEDDMutationObserver();
          }
      }
      
      this.maskInputs();
      this.maskTiresSmsInputField();
      
      //Anounce SR message that cart is empty
      if($('#empty-cart-id').length > 0){
          COSTCO.util.announceSRMessage(messages.CART_EMPTY_SHORT);
          if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true') {
        	  if (typeof adobeProductData != 'undefined' && typeof adobeAnalyticsCommonData != 'undefined' && typeof contextVariables != 'undefined') {
        		  contextVariables.priceTotal = 0;
        		  COSTCO.AdobeEvents.init('commerce.productListViews', adobeProductData, adobeAnalyticsCommonData, contextVariables);
        	  }
          }
      }
      if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
        COSTCO.OrderItems.removeRedudantMinibannerImport();
        COSTCO.OrderItems.checkSelectedRadioButton();
        $('[name="delivery-options-radio"]').each(function() {
          $(this).find('input[type=radio]').unbind('change').change( function () {
            COSTCO.OrderItems.checkSelectedRadioButton();
          });
       });
      }
      
      //Check for invalid ship mode for all the products in cart and display error message.
      //STRY0182081 changes starts
      if (checkoutPage === 'cart' && $('#isBDAppVar').val() == 'BC') {
    	  COSTCO.OrderItems.validateShipMode(true);
    	  if (COSTCO.util.isRunningOnMobileApp()) {
    		  $('#cart-back-to-top').addClass('sticky');
    	  }
      }

      //STRY0182081 changes ends
      
      if (checkoutPage === 'multi-shipping') {
    	  COSTCO.OrderItems.bindHeaderFooterLinksForLeavePageModal();
      }

      //SFSTRY0026170 SR announce order confirmation
      if($('#h1-thank-you-for-your-order').length > 0){
          $('#h1-thank-you-for-your-order').focus();
      }

    },

    /**
     * SFSTRY0038308: If an item has delivery option(s) and none is selected, auto-select the first available one.
     */
    autoSelectDeliveryOption: function() {
      const deliveryRadioSelector = 'div.selection-box-v3 input[type="radio"][id^="ship-mode-radio"]';
      $('.delivery-options.form-group[role="radiogroup"]').each(function() {
        let $radios = $(this).find(deliveryRadioSelector);
        if ($radios.filter(':checked').length === 0) {
          let $firstNonDisabledRadio = $radios.filter(':not(:disabled)').first();
          if ($firstNonDisabledRadio.length) {
            let onclickScript = $firstNonDisabledRadio.attr('onclick');
            if (onclickScript) {
              try {
                // Execute via eval() and not by triggering click event in order not to disrupt page CSS
                eval(onclickScript); // Safe as onclick script comes from JSP
              } catch (err) {
                console.error(err);
              }
            }
          }
        }
      });
    },

    /**
     * Display LTL messages only if there is more than one LTL item in cart/order.
     * LTL messages are by default hidden on page load.
     * (Cart: CartOrderItem_UI.jspf; Order Review: ReviewItemLine.jsp)
     */
    ltlMessages: function() {
      if ($('.ltl-container').length > 1) {
        $('.ltl-container').removeClass('hide');
      }
    },

    /** Display global pickup error for Bopiw and STW items on page load 
     * and ship mode change */ 
    displayGlobalPickUpAlerts: function(hasPickUpServiceError,isShipmodeSwitch) {
    	
    	COSTCO.Header.popovers();
    	var hasErrSet = false;
    	var isShipmodeSwitch = isShipmodeSwitch?isShipmodeSwitch:false;
    	if($('[id^=error_pickup_wio_disabled_]').length > 0) {
    		COSTCO.OrderItems.showErrors(messages.ERR_PICKUP_WIO_DISABLED_CART_HEADER,'#bopiwWIOError')
    		hasErrSet = true;
    	}
    	
    	if($('[id^=error_pickup_unavailable_]').length > 0) {
    		var hasError = false;
    		$('[id^=error_pickup_unavailable_]').each(function(){
	    		if (!hasError && !$(this).hasClass('hidden')) {
	    			hasError = true;
	    		}
    		});
    		if(hasError) {
    			COSTCO.OrderItems.showErrors(messages.ERR_PICKUP_UNAVAILABLE_CART_HEADER,'#bopiwUnavailableError');
    			if(checkoutPage === 'cart'){
            		digitalDataEvents.push( { uimsg:"ShoppingCart | Full | Pick-up is unavailable | Check Nearby Warehouses" } );
            	}
            	else if(checkoutPage === 'review'){
            		digitalDataEvents.push( { uimsg:"Checkout Flow | Pick-up is unavailable - check nearby warehouses" } );
            	}
        		hasErrSet = true;
    		}
    	}
    	
    	if($('[id^=mdo_error_pickup_unavailable_]').length > 0) {
    		var hasMdoError = false;
    		$('[id^=mdo_error_pickup_unavailable_]').each(function(){
	    		if (!hasMdoError && !$(this).hasClass('hidden')) {
	    			hasMdoError = true;
	    		}
    		});
    		if(hasMdoError) {
    			COSTCO.OrderItems.showErrors(messages.ERR_MDO_PICKUP_UNAVAILABLE_CART_HEADER,'#mdoUnavailableError');
    			//Analytics to be added for mdo 
    			if(checkoutPage === 'cart'){
            		digitalDataEvents.push( { uimsg:"Cart | Pick-Up | Pick-Up is Unavailable" } );
            	}
            	else if(checkoutPage === 'review'){
            		digitalDataEvents.push( { uimsg:"Checkout Flow | Pick-Up | Pick-Up is Unavailable" } );
            	}
        		hasErrSet = true;
    		}
    	}
    	
    	if(!hasErrSet && hasPickUpServiceError) {
			COSTCO.OrderItems.showErrors(messages.ERR_PICKUP_SERVICE,'#bopiwServiceError')
			hasErrSet = true;
		}
    	
    	if(!hasErrSet) {
			$('#bopiwWIOError').empty();
			$('#bopiwWIOError').removeClass('critical-notification order-error');
			$('#bopiwServiceError').empty();
			$('#bopiwServiceError').removeClass('critical-notification order-error');
			$('#bopiwUnavailableError').empty();
			$('#bopiwUnavailableError').removeClass('critical-notification order-error');
		} 
    	
    	var hasWarningSet = false;
    	if(!isShipmodeSwitch) {
        	if($('[id^=newSTWItem_]').length > 0) {
        		COSTCO.OrderItems.showWarnings(messages.PICKUP_WARNING_MESSAGE_NEW_STW_ITEM, '#bopiwNewStwItemAlert');
            	hasWarningSet = true;
    		}
        	if($('[id^=warehouseChanged_]').length > 0) {
        		COSTCO.util.announceSRMessage(messages.PICKUP_WARNING_MESSAGE_WAREHOUSE_CHANGED);
        	}
        	
        	if ($('[id^=orderDateChanged_]').length > 0 && !isShipmodeSwitch) {
        		var orderDateChanged = false;
        		$('[id^=orderDateChanged_]').each(function() {
        			if(!orderDateChanged && !$(this).hasClass('hidden')) {
        				orderDateChanged = true;
        			}
        		});
        		
        		if(orderDateChanged) {
        			COSTCO.OrderItems.showWarnings(messages.PICKUP_WARNING_MESSAGE_EDD_CHANGED_HEADER, '#bopiwEddChangeAlert')
	            	if(checkoutPage === 'cart'){
	            		digitalDataEvents.push( { uimsg:"ShoppingCart | Full | Estimated Pick-up Date has Changed" } );
	            	}
	            	else if(checkoutPage === 'review'){
	            		digitalDataEvents.push( { uimsg:"Checkout Flow | Estimated Pick-up Date has Changed" } );
	            	}
	    			hasWarningSet = true;
        		}
    		}
    	}
    	if(!hasWarningSet) {
			$('#bopiwNewStwItemAlert').empty();
			$('#bopiwEddChangeAlert').empty();
		}
    },
    
    showWarnings: function(warning, warningLoc){
		if(warning != '' && warning != undefined && $(warningLoc).children('p').length < 1) {
			$(warningLoc).append('<p>' + warning + '</p>').show();
			$('html, body').animate({ scrollTop: $('.warning').offset().top}, 'slow');
    		COSTCO.util.announceSRMessage(warning);
		}
    },
    
    showErrors: function(error, errLoc){
		if(error != '' && error != undefined && $(errLoc).children('p').length < 1) {
    	  	$(errLoc).addClass('critical-notification order-error');
    	  	$(errLoc).append('<p class="sr-only">' + messages.ERROR + '</p>').show();
        	$(errLoc).append('<p>' + error + '</p>').show();
        	$('html, body').animate({ scrollTop: $('.error').offset().top}, 'slow');
        	$('#hasPickUpError').val(true);
        	COSTCO.util.announceSRMessage(error);
		}
	},
	
    invokeWarehouseCartCheckoutSideBarBOPIW : function(pageName, partNumber, useWarehouseInventory, isShiptoWarehouseItem, orderItemId, warehouseNumber, zipCode){
    	var map = {'pageName' : pageName , 'itemNumber' : partNumber, 'useWarehouseInventory' : useWarehouseInventory, 'isShiptoWarehouseItem' : isShiptoWarehouseItem, 'orderItemId' : orderItemId, 'warehouseNumber' : warehouseNumber, 'zipCode' : zipCode};
    	window.wioEventBus.publish('changeMyWarehouseSideBar', map);
    },
    /**
     * onclick handler for the "Get Directions" link. Opens a new tab and redirects
     * to maps.google.com using Current Location as starting addr and warehouse
     * address as the destination address.
     * @param  {addressLine1, city, state, country} used to get the warehouse address
     * @return {void}
     */
    mdoCartDirectionLink : function(addressLine1, city, state, country) {
        addressLine1 = addressLine1;
        city = city;
        state = state;
        country = country;
        let warehouseAddress = encodeURIComponent(
            ['Costco']
            .concat(addressLine1.split(' '))
            .concat(city.split(' '))
            .concat(state.split(' '))
            .concat(country.split(' '))
            .join(' ')
        );
        let win = window.open(
            window.location.protocol + '//maps.google.com?saddr=Current+Location&daddr=' + warehouseAddress);
            win.focus();
	    },
        
    /**
     * method that determines if order should be sent to multiple or single address
     * based on users selected addresses
     */
    shipToMultiOrSingleAddress: function(redirectURL) {
    	if(COSTCO.OrderItems.allItemsHaveSameAddress()) {
    		if (redirectURL != undefined && redirectURL != '') {
	    		$('<input>').attr({
	    		    type: 'hidden',
	    		    name: 'redirect_url',
	    		    value: redirectURL
	    		}).appendTo('#ShipAsCompleteForm');
    		}	
    		COSTCO.OrderItems.submitSingleShippingForm();
    	} else {
    		if (redirectURL != undefined && redirectURL != '') {
    			$('<input>').attr({
        		    type: 'hidden',
        		    name: 'redirect_url',
        		    value: redirectURL
        		}).appendTo('#continue-multi-address-form');
    		}	
    		document.getElementById('continue-multi-address-form').submit();
    	}
    },
    
    /**
     * Canceling actions on Multiple Shipping address page. 
     * Reverts the address modifications to previously selected address
     */
    cancelMultiShipToddress: function(redirectURL) {
    	$('[name^="addressId_"]').each(function(index,element) {
    		$(element).val($(element).attr('data-orderitem-addressid'));
        });
    	COSTCO.OrderItems.shipToMultiOrSingleAddress(redirectURL);
    },
    
    /**
     * Binding header and footer links for initiating leave page modal
     * 
     */
    bindHeaderFooterLinksForLeavePageModal: function() {
        
        let headerAndFooterLinks = $('#header-checkout-widget, #footer-bottom').find("a");
        headerAndFooterLinks.click(function () {
            var addressValue = $(this).attr("href");
            if(addressValue != '#')
            	COSTCO.OrderItems.initiateLeavePageModal(addressValue);
            return false;
        });
             
    },
    
    /**
     * Showing leave page modal if user chooses to cancel shopping
     * @param {string} secondaryButtonHref	To set where primary button should redirect
     */
    initiateLeavePageModal: function(secondaryButtonHref) {
      
      COSTCO.dialog.createExtDialogBox({
        title: messages.LEAVE_PAGE_MODAL_TITLE,
        body: messages.LEAVE_PAGE_MODAL_BODY,
        primary: messages.LEAVE_PAGE_MODAL_LEAVE_PAGE_BUTTON,
        secondary: messages.LEAVE_PAGE_MODAL_STAY_ON_PAGE_BUTTON,
        dialogclasses: 'modalv2',
        secondary_button_style: 'tertiary',
        primary_event: function() {
        	COSTCO.OrderItems.cancelMultiShipToddress(secondaryButtonHref);
        },
        secondary_event: function() {
        	COSTCO.dialog.close();
        },
      });
    },
    
    /**
     * check if all order items have the same selected address
     */
    allItemsHaveSameAddress: function() {
    	let addressIds = $('[name^="addressId_"]').map(function() {
    	    return this.value;
    	}).get();
    	
    	return $('.warehouse-pickup-address').length === 0 && $('#tire-item-address-container').length === 0 && addressIds.every((val, i, arr) => val === arr[0]);
    },
    
    /**
     * method for submitting single address form on multi-shipping page 
     */
    submitSingleShippingForm: function() {
    	$('<input>').attr({
		    type: 'hidden',
		    name: 'shipAddressId',
		    value: $('[name^="addressId_"]').val()
		}).appendTo('#ShipAsCompleteForm');
		document.getElementById('ShipAsCompleteForm').submit();
    },

    /**
     *  Removing redudant minibanner from page which have display:none class
     * 
     */
    removeRedudantMinibannerImport: function(){
      $(".top-bar:hidden").remove();
    },

    /**
     * this method will be initiated when some of the addresses change
     * it will call command for updating sms on order items that have associated address
     * with which this method was called
     */
    updateSmsPhoneForOrderItems: function(address) {
    	
    	if(!OrderItems.smsPhoneUpdateStarted) {
    		OrderItems.smsPhoneUpdateStarted = true;
    		COSTCO.AjaxModular.ajax_update_state({
    			url: 'CostcoMultipleOrderItemsUpdateSmsPhoneCmd',
    			method: 'POST',
    			dataType: 'json',
    			data: address,
    			scrollToError: false,
    			done: function(data, textStatus, jqXHR, options) {
    				COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
    				COSTCO.OrderItems.tooltips();
    			},
    			always: function() {
    				OrderItems.smsPhoneUpdateStarted = false;
    			}
    		});
    	}
    	
    },
    
    addQuantityEventHandlers: function() {
        if ($('.quantity-selector-v2 input[name^=quantity_]').length > 0) {
      	  // saves old value of quantity to compare with newly entered value
      	  $('.quantity-selector-v2 input[name^=quantity_]').off('focusin').on('focusin', function(){
      		  $(this).data('val', $(this).val());
      	  });
  			
      	  $('.quantity-selector-v2 input[name^=quantity_]').off('keydown change').on('keydown change', function(e) {
      		  if (e.which == 13 || e.type == 'change') {
      			  e.preventDefault();
      			  if ($(this).val() !== $(this).data('val')) {
      				  COSTCO.OrderItems.changeQuantityValue(this);
      			  } else {
      				  $(this).next().focus();
      			  }
      		  }
      	  });
        }

    },
    getStringOfZerosByLength: function(length) {
    	var output = '';
    	while(length>0) {
    		output = output + '0';
    		length--;
    	}
    	return output;
    },
    maskInputs: function(){
    	$('input[name^=smsPhone]').unmask().mask('000-000-0000');
    	if(COSTCO.util.isBusinessDelivery()) {
    		$("input[id*='quantity_']").unmask().mask('0000');
    	} else {
    		if($('#cartTotalLimitBC').length) {
    			var qntyMaskBC = this.getStringOfZerosByLength($('#cartTotalLimitBC').val().length);
    			$("input[id*='quantity_']").unmask().mask(qntyMaskBC);
    		}
    	}
    	$('#edit-contact-information-phone input[id^=smsPhoneId_]').unmask().mask('000-000-0000');
    	$('.scheduled-delivery-widget-v2 input[id^=contactPhone_]').unmask().mask('000-000-0000');
  	    $('[id^=edit-contact-information-phone] input[id^=smsPhoneId_]').unmask().mask('000-000-0000');
    },
    maskTiresSmsInputField: function() {
    	$('#edit-tires-contact-information-phone input[id^=tiresSmsPhoneId_]').unmask().mask('000-000-0000');
    },
    setResaleOptionView: function(){
        var page = $('.resalesection').attr('page');
        if(page=='CART'){
        	 $('.resale_radio').removeClass('hide');
        }else{
        	$('.resale_text').removeClass('hide');
        }
    },
    cartOptionsHandler : function(event){
        var option = $('#ShopCartForm').find('select[id=cart-options]').val();
    	if(option == "AddAllToList"){
    		COSTCO.Shoppinglistshelper.redirect(event,COSTCO.Shoppinglistshelper.openCartListsModal(event));
    		window.digitalDataEvents = window.digitalDataEvents || [ ];
    		digitalDataEvents.push( {wishLoc:"Shopping Cart | Full"} )
    	}
    	else if(option == "RemoveAllFromCart"){
    		COSTCO.dialog.createExtDialogBox({
    	        title: messages.REMOVE_ITEMS_POPUP,
    	        body: COSTCO.util.tmpl('tmpl_cart_remove_item_popups'),
    	        primary: messages.CART_POPUP_REMOVE,
    			secondary: messages.CART_POPUP_CANCEL,
    			primary_event: function(){
    			  window.digitalDataEvents = window.digitalDataEvents || [];
                  var orderItemProducts = [];
                  var orderItems = $("#order-items .order-item");
                  $(orderItems).each(function(index,element) {
                    orderItemProducts.push( { pid: $("input[name=catalogEntryId_"+(index+1)+"]").val(), sku: $(element).find(".itemPartNumberPurchased").text() } );
                  });
                  digitalDataEvents.push({
                      cartRemove:"Shopping Cart | Full",
                      products: orderItemProducts,
                      element: event.target
                  });
    				location.href = $("#MultiItemsRemoveUrl").val();
    				$.cookie('deliveryDateCookie', '');
    			},
    			secondary_event: function(){
    				COSTCO.dialog.close();
    				$("select[id=cart-options]").each(function() { this.selectedIndex = 0 });
    			},
    			onclose: function(e){
    				$("select[id=cart-options]").each(function() { this.selectedIndex = 0 });
    				$("label[for='cart-options']").removeClass("active");
				}
    	      });
    	}
    	else if(option == "UseAllForResale"){
    	    let radio = $("#ShopCartForm input[name^='resaleChecked_']");
    		for (var i = 0; i < radio.length; i++) {
                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
                    let value = radio[i].checked;             
                    if (!value) {
                        $("#ShopCartForm input:checkbox[name^='resaleChecked_']")[i].checked = true;
                        COSTCO.OrderItems.resaleOptionHandler(radio[i],false);
                    }
                } else {
                    let value =  $(radio[i]).val();
    			if(value == "yes"){
                    $("#ShopCartForm input:checkbox[name^='resaleChecked_']")[i].checked = true;
    				COSTCO.OrderItems.resaleOptionHandler(radio[i],false);
    			}
    		}
    		}
    		OrderItems.resale_update(radio);
    		COSTCO.util.announceSRMessage(messages.ITEMS_SELECTED_RESALE);
    	}   
    	else if(option == "UseNoneForResale"){
            let radio = $("#ShopCartForm input[name^='resaleChecked_']");
    		for (var i = 0; i < radio.length; i++) {
               if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
                   let value =  radio[i].checked;
                   let isTobaccoProduct = radio[i].dataset.istobaccoproduct;
                   if (value && isTobaccoProduct !== "1"){
                       $("#ShopCartForm input:checkbox[name^='resaleChecked_']")[i].checked = false;
                       COSTCO.OrderItems.resaleOptionHandler(radio[i],false);
                   }
               } else {
                   let value =  $(radio[i]).val();
                   let id=radio[i].name;
                   let orderItem = id.split('_')[1];
                   let isTobacco = $("#tobaccoProduct_"+orderItem).val();
    			if((isTobacco != 1 && value == "no") || (isTobacco == 1 && value == "yes")){
    				$("#ShopCartForm input:radio[name^='resaleChecked_']")[i].checked = true;
    				COSTCO.OrderItems.resaleOptionHandler(radio[i],false);
    			}
    		}
            }
    		OrderItems.resale_update(radio);
            COSTCO.util.announceSRMessage(messages.ITEMS_DESELECTED_RESALE);
    	}
        $('#cart-options').focus();
    },
    resaleLicenseModal: function() {
    	var needResaleLicenseModal = $('#resaleLicenseModalNeeded').val();
    	if (needResaleLicenseModal) {
    		    		
    		COSTCO.dialog.createExtDialogBox({
    			title: messages.RESALE_LICENSE_MODAL_TITLE,
    			body: COSTCO.util.tmpl('tmpl_resale_license_modal',{
    				resaleLicenseModalBody: messages.RESALE_LICENSE_MODAL_BODY
    			}),
    			primary: messages.RESALE_OPTION_YES,
				secondary: messages.RESALE_OPTION_NO,
				primary_event: function(){
					COSTCO.CAddress.closeModal();
					window.location.href = $('#return-to-cart').attr('href');
				}
    			
    		});
    		
    	}
    },
    formatDateForOCP: function(){
      var orderPlacedTime = new Date($("#orderPlacedTime").val());  
      var schedDeliveryDate = new Date($("#schedDeliveryDate").val());
      $("#orderPlacedOn").html(OrderItems.formatDate(orderPlacedTime.getDay(), orderPlacedTime.getDate(), orderPlacedTime.getMonth(), orderPlacedTime.getFullYear(), wcs.langId));
      $("#deliveryDate").html(OrderItems.formatDate(schedDeliveryDate.getDay(), schedDeliveryDate.getDate(), schedDeliveryDate.getMonth(), schedDeliveryDate.getFullYear(), wcs.langId));
    },
    setDeliveryDateView: function() {
    	if(checkoutPage=='shipping'){
    		if(COSTCO.util.isNdEnabled()){
	    		$("#deldatepicker").prop('disabled', false);
    		}
	    	COSTCO.OrderItems.showDatePicker();
          }
    	else if(checkoutPage=='review'){
			let userChoice = false;
			if(COSTCO.util.isNdEnabled()){
				$("#deldatepicker").prop('disabled', false);
				if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE ? $('input[name="deliveryMethod"]').val().length > 1 : $('input[name="deliveryMethod"]').length > 1) {
					userChoice = true;
				}
			}
			
			if($('#isBDAppVar').val() == 'BD') {
				COSTCO.OrderItems.validateDeliveryDate();
			}
			
			if($('#isBDAppVar').val() == 'BD' && wcs.langId === '-1') {
				COSTCO.OrderItems.validateVendorHoliday();
			}
			
			COSTCO.OrderItems.delDatePicker();
            var cookieDate = COSTCO.OrderItems.getCookie("deliveryDateCookie");
            if (cookieDate && cookieDate!="" && cookieDate!=null && !userChoice && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
              $('#deldatepicker-div').addClass('hide');
              $('#delivery-date-block').removeClass('hide');
              let date_str = COSTCO.OrderItems.getDisplayDateFormatForReview(cookieDate);
              $("#delivery-date-block").find(".body-copy").html(date_str);
            } else {
              COSTCO.OrderItems.showDatePicker();
            }
		  }else if(checkoutPage=='cart' && (COSTCO.util.isNdEnabled() || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE)){
			  COSTCO.OrderItems.delDatePicker();
			  $("#deldatepicker").prop('disabled', false);
				  COSTCO.OrderItems.showDatePicker();
		  }
    },
    showDatePicker: function() {
    	$('#deldatepicker-div').removeClass('hide');
    	$('#delivery-date-block').addClass('hide');
    },
    showDatePickerFocus: function() {
        COSTCO.OrderItems.showDatePicker();
        $('#deldatepicker').focus();
    },
    validateDeliveryDate: function() {
    	let shipmodeId = 10101;
    	var isCaShipModeId = false;
    	if($('input[name="deliveryMethod"]').length>0){
    		var caShipModeId = $('input[name="deliveryMethod"]:checked').val();
    		isCaShipModeId = (caShipModeId == '11608' || caShipModeId == '11608_SP');
    	}
    	if((COSTCO.util.isNdEnabled() || isCaShipModeId) && $('input[name="deliveryMethod"]').length > 0){
    		shipmodeId = $('input[name="deliveryMethod"]:checked').val();
    	}
    	let datesEnabled = [];
    	let isSelectedDateAvailable = false;
    	let isSelectedDateEmpty = true;
    	let selectedDeliveryDate = $('input[name=selDeliveryDate]').val();
    	let preferredDates = $('#preferredDates').val();
    	if (preferredDates != undefined && preferredDates != '') {
            datesEnabled = preferredDates.split('|').filter(function(item){return item !== '';});
    	}
    	let getFormattedDate = function(encodedDate) {
    		let date = new Date(COSTCO.OrderItems.decode_utf8(encodedDate));
    		let day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    		let month = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
    		return month + '/' + day + '/' + date.getFullYear();
    	}
    	if (selectedDeliveryDate && selectedDeliveryDate != ''){
    		let deliveryDate = getFormattedDate(selectedDeliveryDate);
    		isSelectedDateAvailable = datesEnabled.includes(deliveryDate);
    		isSelectedDateEmpty = false;
    	} else {
    		let inputDate = $('input#deldatepicker').val() || $('input#deldatepicker').attr('value');
    		isSelectedDateAvailable = datesEnabled.includes(inputDate);
    	}
    	if (!isSelectedDateAvailable && (shipmodeId == '10101' || shipmodeId == '10101_SP' || shipmodeId == '11608' || shipmodeId == '11608_SP' )) {
    		$.cookie('deliveryDateCookie', '');

    		if (COSTCO.util.isNdEnabled() && isSelectedDateEmpty) {
    			$('#delivery-date-notification').removeClass('hide');
        		$('#delivery-date-notification').addClass('critical-notification');
    			$('#delivery-date-notification').text(messages.ERR_CHECKOUT_EMPTY_DELIVERY_DATE);
    		} else {
    			var foundin = $("*:contains('" + messages.ERR_CHECKOUT_DELIVERY_DATE + "')").length>0;
    			if(!foundin){
    				$('#delivery-date-notification').removeClass('hide');
    	    		$('#delivery-date-notification').addClass('critical-notification');
    				$('#delivery-date-notification').text(messages.ERR_CHECKOUT_DELIVERY_DATE);
        		}
    			
    		}
    		if (COSTCO.util.isNdEnabled()) {
    			COSTCO.OrderSummary.chooseDeliveryMethod(true);
    		} else {
    			COSTCO.OrderSummary.chooseDeliveryMethodNdOff();
    		}
        	$('#deldatepicker').val('');
    	} else {
    		// Remove delivery date error notification for Residential address flow
    		$('#delivery-date-notification').empty();
    		$('#delivery-date-notification').removeClass('critical-notification');
    		$('#delivery-date-notification').addClass('hide');
    	}
    },
    validateVendorHoliday: function() {
    	let $vendorHolidayInput = $('input#forceExpandCalendar');
    	if ($vendorHolidayInput.val()) {
    		COSTCO.OrderSummary.chooseDeliveryMethodNdOff();
    	}
    },
    getDisplayDateFormatForReview: function(cookieDate) {
      let formatedDate = '';
        if (checkoutPage && checkoutPage == 'review' && cookieDate && cookieDate != '' && cookieDate != null) {
          let date = new Date(COSTCO.OrderItems.decode_utf8(cookieDate));
          formatedDate = COSTCO.OrderItems.formatDate(date.getDay(), date.getDate(), date.getMonth(), date.getFullYear(), wcs.langId);
        }
      return formatedDate;
    },
    encode_utf8(s) {
      return encodeURIComponent(s);
    },
    decode_utf8(s) {
    	  return decodeURIComponent(s);
    },
    validateSelectedDeliveryDate: function(selectedDate) {
    	  
    	  var datesEnabled = [];
	      var isSelectedDateAvailable = false;
	      var selectedDeliveryDate = $('input[name=selDeliveryDate]').val();
	      if(selectedDate!=null && selectedDate != ''){
	    	  selectedDeliveryDate = selectedDate;
	      }
	      var preferredDates = $('#preferredDates').val();
	      if (preferredDates != undefined && preferredDates != '') {
	        datesEnabled = preferredDates.split('|').filter(function (item) {
	          return item !== '';
	        });
	      }
	      var getFormattedDate = function getFormattedDate(encodedDate) {
	        var date = new Date(COSTCO.OrderItems.decode_utf8(encodedDate));
	        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
	        var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
	        return month + '/' + day + '/' + date.getFullYear();
	      };
	      if (selectedDeliveryDate && selectedDeliveryDate != '') {
	        var deliveryDate = getFormattedDate(selectedDeliveryDate);
	        isSelectedDateAvailable = datesEnabled.includes(deliveryDate)
	      } 
	      return isSelectedDateAvailable;
    },

    /**
     * Calls the datepicker plugin (js/Widgets/ada-datepicker) on input#deldatepicker.
     * @return {void}
     */
    delDatePicker: function() {
      let datepickerElem = $('#deldatepicker');
      let preferredDatesElem = $('#preferredDates').val();
      if (preferredDatesElem != undefined && preferredDatesElem != '') {
        let datesEnabled = preferredDatesElem.split('|').filter(function(item){return item !== '';});
        datepickerElem.datepicker({
          format: wcs.langId === '-25' ? 'D. d M yyyy' : 'D, M dd, yyyy',
          autoclose: true,
          showOnFocus: false,
          orientation: 'auto right',
          todayHighlight: true,
          datesEnabled: datesEnabled,
          language: wcs.langId === '-25' ? 'fr' : 'en',
          // Previously 'beforeShowDay' was used to restrict dates: leaving it here in case of need for quick revert.
//          beforeShowDay: function(date) {
//            // Used to restrict dates
//            // If the date isn't part of the allowed date array, disable it.
//            return COSTCO.util.any(datesEnabled, function(allowed_date) {
//              allowed_date = new Date(allowed_date);
//              return allowed_date.getMonth() == date.getMonth() && allowed_date.getDate() == date.getDate() && allowed_date.getFullYear() == date.getFullYear()
//            });
//          },
        }).on('changeDate', function(e) {
          $('#deliveryDatePageError').hide();
          // Remove error message regarding wrong delivery date
          $('#delivery-date-notification').text('');
          $('#delivery-date-notification').removeClass('critical-notification');
          $('#delivery-date-notification').addClass('hide');
          
          
          // The change event needs the date string to pass to the server.
          let date_str = '',
          selected_date = e.date;
          if (selected_date !== undefined) {
	          for (let k = 0; k < this.allowed_objs.length; k++) {
	            let date_obj = new Date(this.allowed_objs[k]);
	            let dateVal = selected_date.getDate();
	            let month = selected_date.getMonth();
	            let year = selected_date.getFullYear();
	            let day = selected_date.getDay();
	            if (dateVal == date_obj.getDate() && month == date_obj.getMonth() && year == date_obj.getFullYear()) {
	              date_str = COSTCO.OrderItems.formatDate(day,dateVal,month,year);
	              break;
	            }
	          }
	          let encodedDate = COSTCO.OrderItems.encode_utf8(date_str);
	          if(COSTCO.OrderItems.validateSelectedDeliveryDate(encodedDate) && $('.order-error').find('p').text().trim() === messages.ERR_CHECKOUT_DELIVERY_DATE){
	        	  $('.order-error').removeClass('critical-notification');
				  $('.order-error').addClass('hide');
				}
	          $.cookie('deliveryDateCookie', date_str);
	          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	            datepickerElem.val(date_str);
	    		$("label[for='deldatepicker']").addClass('active').removeClass('error');
	          }
	          $('[name="selDeliveryDate"]').val(encodedDate);
	          
        	}
        }.bind({
          allowed_objs: datesEnabled,
        }));

        setTimeout(function() {
          //let cookieDate = COSTCO.OrderItems.getCookie('deliveryDateCookie');
    		var savedShipmode = 10101;
    		var isCaShipModeId = false;
        	if($('#savedShipmodeID').val() != undefined){
        		var caShipModeId = $('#savedShipmodeID').val();
        		isCaShipModeId = caShipModeId == 11608;
        	}
    		if($('#savedShipmodeID').val() != undefined && (COSTCO.util.isNdEnabled() || isCaShipModeId)){
    			savedShipmode = $('#savedShipmodeID').val();
    		}
    		if ((datepickerElem.val() === undefined || datepickerElem.val() === '') && (savedShipmode == 10101 || savedShipmode == 11608) ) {
            datepickerElem.val(COSTCO.OrderItems.getCookie('deliveryDateCookie'));
          }
          let cookieDate = datepickerElem.val();
          if (cookieDate && cookieDate != '' && cookieDate != null) {
            let date_string = COSTCO.OrderItems.decode_utf8(cookieDate);
            datepickerElem.datepicker('setDate', new Date(date_string));
          }
        });
      }
    },
    bindPoNotes: function() {
      $('form#po-notes-facade-form #po-notes-facade').unbind().bind('change', function() {
        //$('form#NewAddressSingleShippingForm input[name=poNotes]').val($(this).val());
    	$('input[name=poNotes]').val($(this).val());
    	globalPoNote = $(this).val();
      });
    },    
    bindDeliveryMethod: function() {
    	$('input[name="deliveryMethod"]').unbind().bind('change', function() {
	    var shipmodeId = $("input[name='deliveryMethod']:checked").val();
	    $('form#CheckoutReviewForm input[name="orderShipmodeId"]').val(shipmodeId);
    	 });
    },
    copyPoNotes: function(tmpvalue) {
		$('form#po-notes-facade-form #po-notes-facade').val(tmpvalue);
      	$('input[name=poNotes]').val($('form#po-notes-facade-form #po-notes-facade').val());
      	$('#ponote-block span').html(tmpvalue);
    },
    globalizePoNotes: function() {
    	if ($('input[name=poNotes]') != null){
    		globalPoNote = $('input[name=poNotes]').val();
    	}
    },
    /**
     * Formats date in 'EEE, MMM dd, yyy' format for English &
     * 'EEE. dd MMMM yyy' for French.
     * @param {string} langId - (optional) if omitted use English
     */
    formatDate: function(day, date, month, year, langId) {
      let monthNames = (langId === '-25')
          ? ["janv.", "févr.", "mars", "avril", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."]
          : ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
      let days = (langId === '-25')
          ? ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"]
          : ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

      let formatedDate = (langId === '-25')
          ? days[day] + '. ' + date + ' ' + monthNames[month] + ' ' + year
          : days[day] + ', ' + monthNames[month] + ' ' + date + ', ' + year

      return formatedDate;
    },
	getCookie: function(name){
	    var re = new RegExp(name + "=([^;]+)");
	    var value = re.exec(document.cookie);
	    return (value != null) ? unescape(value[1]) : null;
	},
    /**
     * [validationRules description]
     * @return {[type]} [description]
     */
    validationRules() {
      /**
       * Validate a date format. Could be dd/mm/yyyy or mm/dd/yyyy
       */
      $.validator.addMethod("dateFormat", function(value, element) {
        var dateArr = value.split('/');
        return this.optional(element) || dateArr.length === 3 ? !isNaN(parseInt(dateArr[0])) && !isNaN(parseInt(dateArr[1])) && !isNaN(parseInt(dateArr[2])) ? true : false : false;
      }, messages.ERR_INVALID_STATE);
      
   // Used by the Shopping Cart page
  	$.validator.addMethod(
  			"quantityIncrement",
  			function(value,element){
  				var $quantityIncrement = $(element).data("quantity-increment");

  				var quantityIncrement = 1; //default quantityIncrement is always 1 (a whole number)
  				if(typeof $quantityIncrement == undefined || !$quantityIncrement) {
  					return true;
  				}
  				var qty = parseInt($quantityIncrement);
  				if(qty) {
  					quantityIncrement = qty;
  				}
  				if(value%quantityIncrement != 0) {
  					return false;
  				}
  				return true;
  			}
  	);
      
      COSTCO.ScheduledDeliverable.validationRules.phone();
      
      $.validator.addMethod("emptyGiftMessage", function(value, element) {
      	$('label[for=giftMessageRequired]').removeClass('hide');
        $('.gift-message-required-text').closest('.edit').children('button[id^=addGiftMessageButton_]').addClass('gift-message-required-text-error');
        setTimeout(function() {$('.gift-message-required-text').closest('.edit').children('button[id^=addGiftMessageButton_]').focus()},200);
        $('label[for=giftMessageRequired]').attr("role","alert");
      	$('span[id=giftMessageRequired-error]').css("padding-left","11px");
      	$('span[id=giftMessageRequired-error]').attr("role","alert");
    	  return false;
      }, messages.CHECKOUT_DELIVERY_GiftMsg_Empty_Error);      
	  $.validator.addMethod("giftMessageRequired", function(value, element) {
    	  if(!value.includes("unsupported") && !value.includes("optional") && value.includes("_empty")){
    		  $('div.gift-message-data > div.edit > span.gift-message-required-text').html('<div class="error">'+messages.CHECKOUT_DELIVERY_GiftMsg_Empty_Error+'</div>');
    		  return false;
    	  }
    	  else{
    		  return true;
    	  }
      },"");
      $.validator.addMethod("alphaNum", function(value, element) { 
      return this.optional(element) || /^[a-zA-Z0-9\u00C0-\u017F.,!?''"()\r\n\s]+$/i.test(value);
         }, messages.CHECKOUT_DELIVERY_GiftMessageValidation);
    },
    /**
     * messageParamSubstitute expects a variable number of parameters that will replace (right to left) the {#} portions of the message.
     * First parameter to the function is the message with the substitute sections
     * followed by corresponding number of arguments to do replacement on 
     */
    messageParamSubstitute:  function(msg) {
    	if(arguments.length <= 1) {
    		return msg;
    	}
    	var regEx = /({[0-9]+})/;
    	var argsArray = Array.prototype.slice.call(arguments);
    	var cntr;
    	for(cntr=1; cntr < argsArray.length; cntr++) {
    		msg = msg.replace(regEx,argsArray[cntr]);
    	}
    	return msg;
    },
    /**
     * This is a decorator function that is used inline for order item
     * validation. This allows you to validate a single input in the case
     * where you'd like to just validate one input, or ALL validate-able inputs
     * using validate_inputs.
     * @param  {Function} callback The function to be called after successful
     *                             validation.
     * @param  {string}   rule     OPTIONAL: The specific rule to validate
     *                             if we're dealing with just one input
     * @param  {array}    callbackParams Args passed to callback                           
     * @return {void}
     */
    validate: function(callback, rule, callbackParams, errorPlacement) {
      // No getting around this. You need input wrapped in form.
      var $form = $('#ShopCartForm');
      // This would correlate with where we called this method from. If we're
      // calling this inline ".call(this)", "this" would represent the input
      var $input = $(this);
      // The function we use to add rules to dynamic inputs
      var validate_inputs = COSTCO.OrderItems.validate_inputs;
      // The set of rules used that get passed to $.fn.validate
      var rules_config_obj = COSTCO.OrderItems.rules_config_obj($input);
      checkout_helper._dynamic_validate({
        form: $form,
        input: $input,
        validate_inputs: validate_inputs,
        rule: rule,
        rules_config_obj: rules_config_obj,
        callback: callback,
        errorPlacement: function(error, element) {
            if(element.attr("name").startsWith("date_")) {
              error.appendTo(element.parent());
            }  else if(typeof element.attr("data-itemtype") !== 'undefined' && element.attr("data-itemtype") !== false && (element.attr("data-itemtype").startsWith("variableQuantity"))){ 
                error.insertAfter(element.parent().parent());      
             } else {  
                error.insertAfter(element.parent());
             }
          },
        callbackParams: callbackParams
      });
      
      
	    //go to the first visible and non-empty error on the page if there is one
	  	if($('#isBDAppVar').val() == 'BD') {
	  		if($('.datepickererror').not(':empty').length > 0  && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE){
	     		$('html, body').animate({scrollTop: $('[name=' + $('.datepickererror').not(':empty').attr('for') + ']').offset().top -50}, 500);
	     		$('#deldatepicker').focus();
	         } 
	  	} else {      
	  		var statusCode = $('#statusCode').val();
	  		if($('#hasPickUpError').val() == "true" || $('label.error').not(':empty').length > 0 && $('[name=' + $('label.error').not(':empty').attr('for') + ']').length > 0) {
                //$('html, body').animate({ scrollTop: $('[name=' + $('label.error').not(':empty').attr('for') + ']').offset().top - 50 }, 500)
              $('html, body').animate({ scrollTop: $('.error').offset().top}, 'slow'); //recreating scroll-top
                if (statusCode != null && statusCode != undefined && statusCode != "" && statusCode != 200) {
                  COSTCO.util.announceSRMessage(messages.ERR_PICKUP_SERVICE);
              }else if($('#hasPickUpError').val() == "true" ){
            	  if($('[id^=mdo-pickUp-unAvailable]').length > 0){
            		  COSTCO.util.announceSRMessage(messages.ERR_MDO_PICKUP_UNAVAILABLE_CART_HEADER);
            	  }
            	  else{
            		  COSTCO.util.announceSRMessage(messages.ERR_PICKUP_UNAVAILABLE_CART_HEADER);
            	  }
              }
            }else if($('[id^=error_pickup_wio_disabled_]').length > 0){
                $('html, body').animate({ scrollTop: $('.error').offset().top}, 'slow'); //recreating scroll-top
              COSTCO.util.announceSRMessage(messages.ERR_PICKUP_WIO_DISABLED_CART_HEADER);
          }
	  	}
    },
    nonTaxableOptionHandler: function(event) {
    	let id=event.name;
        let nonTaxableOption = (event.type === 'checkbox') ? event.checked : (event.value === "yes");
        if (nonTaxableOption) {
        	let radio = $("#ShopCartForm input[name^='resaleChecked_']");
        	for (var i = 0; i < radio.length; i++) {
                if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
                    let value = radio[i].checked;             
                    if (!value) {
                        $("#ShopCartForm input:checkbox[name^='resaleChecked_']")[i].checked = true;
                        COSTCO.OrderItems.resaleOptionHandler(radio[i],false);
                    }
                } else {
                    let value =  $(radio[i]).val();
    				if (value == "yes") {
    					$("#ShopCartForm input:radio[name^='resaleChecked_']")[i].checked = true;
    					COSTCO.OrderItems.resaleOptionHandler(radio[i],false);
    				}
    			}
			}
            $('#' + event.id).removeAttr("data-bi-tc");
            if (checkoutPage && checkoutPage == 'review') {
              $('#' + event.id).attr("data-bi-tc", "ui:Checkout | Select All Items as Non-Taxable");
            } else {
              $('#' + event.id).attr("data-bi-tc", "ui:Cart | Select All Items as Non-Taxable");
            }
        	OrderItems.resale_update(radio);
    		COSTCO.util.announceSRMessage(messages.ITEMS_SELECTED_RESALE);
        } else {
        	let radio = $("#ShopCartForm input[name^='resaleChecked_']");
    		for (var i = 0; i < radio.length; i++) {
               if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
                   let value =  radio[i].checked;
                   let isTobaccoProduct = radio[i].dataset.istobaccoproduct;
                   if (value && isTobaccoProduct !== "1") {
                       $("#ShopCartForm input:checkbox[name^='resaleChecked_']")[i].checked = false;
                       COSTCO.OrderItems.resaleOptionHandler(radio[i],false);
                   }
               } else {
                   let value =  $(radio[i]).val();
                   let id=radio[i].name;
                   let orderItem = id.split('_')[1];
                   let isTobacco = $("#tobaccoProduct_"+orderItem).val();
                   if((isTobacco != 1 && value == "no") || (isTobacco == 1 && value == "yes")){
                	   $("#ShopCartForm input:radio[name^='resaleChecked_']")[i].checked = true;
                	   COSTCO.OrderItems.resaleOptionHandler(radio[i],false);
                   }
               }
            }
            
              $('#' + event.id).removeAttr("data-bi-tc");
              if (checkoutPage && checkoutPage == 'review') {
                $('#' + event.id).attr("data-bi-tc", "ui:Checkout | De-Select All Items as Non-Taxable");
              } else {
                $('#' + event.id).attr("data-bi-tc", "ui:Cart | De-Select All Items as Non-Taxable");
              }
    		OrderItems.resale_update(radio);
            COSTCO.util.announceSRMessage(messages.ITEMS_DESELECTED_RESALE);
        }
    },
    resaleOptionHandler: function(e,updateEach) {
      let id=e.name;
      let resaleOption = (e.type === 'checkbox') ? e.checked : (e.value === "yes");
      let resaleInput = 'resaleFlag_'+id.split('_')[1];
      let flagValue;
      let attributeAnalytics;
      if (resaleOption) {
	       flagValue = id.split('_')[1] + "_1";
	       if (checkoutPage && checkoutPage == 'review') {
	         attributeAnalytics = "ui:Checkout | Non-Taxable | Select Product";
	       } else {
	         attributeAnalytics = "ui:Cart | Non-Taxable | Select Product";
	       }
	    } else {
	       flagValue = id.split('_')[1] + "_0";
	       if (checkoutPage && checkoutPage == 'review') {
	         attributeAnalytics = "ui:Checkout | Non-Taxable | De-Select Product";
	       } else {
	         attributeAnalytics = "ui:Cart | Non-Taxable | De-Select Product";
	       }
	    }
	    $('#ShopCartForm').find('#' +resaleInput).val(flagValue);
	    $('#ShopCartForm').find('#' + id).removeAttr("data-bi-tc");
        $('#ShopCartForm').find('#' + id).attr("data-bi-tc", attributeAnalytics);
	    if(updateEach){
	    	OrderItems.resale_update(e);
	    }
    } ,
    nonTaxableAllChecked: function() {
      let counter = 0;
      var resaleItems = $('#ShopCartForm').find('input[name="resaleCheckedIds"]') || [];
      if (resaleItems.length > 0) {
        for (let i = 0 ; i < resaleItems.length ; i++) {
          let isChecked = resaleItems[i].value.split('_')[1];
          if (isChecked == 0) {
            counter++
          }
        }
        if ($('#resaleAllChecked').length > 0) {
          if (counter > 0) {
            $('#resaleAllChecked').prop('checked', false);
          } else {
            $('#resaleAllChecked').prop('checked', true);
          }
        }
      } else {
        $('#nonTaxableAllCheckbox').addClass('hide');
      }
    },
    resale_update: function(input) {
        // Input injector intially sets ajaxFlag to true in the ShopCartForm,
        // but subsequent calls need to ensure it is set
        // true because ajax_update_post_done sets it false.
        $('#ShopCartForm input[name=ajaxFlag]').val(true);
        checkout_helper.ajax_update_state({
          url: '/AjaxResaleUpdate',
          method: "POST",
          data: $('#ShopCartForm').serialize(),
          ajax_replace_content: function(response_obj, mergedOptions, defaultOptions) {
            defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
          },
          ajax_update_post_done: function(response_obj, mergedOptions, defaultOptions) {
            COSTCO.Header.miniShopCartRefresh();
            $('#ShopCartForm input[name=ajaxFlag]').val(false);
            COSTCO.OrderItems.init();
            $('#' + input.id).focus();
          },
          inputContainer: input
        });
      },
    /**
     * All of the potentail rules to pass to $.fn.validator. These are
     * "order item" specific.
     * @param input input quantity value element reference
     * @return {object}     The object with all of the rules attached as
     *                      properties.
     */
    rules_config_obj: function(input) {
      var rules = {};
      let unitOfMeasure = COSTCO.Product.getUnitOfMeasure(input);
 	  let increment = COSTCO.Product.getQuantityStep(input, unitOfMeasure);
      if ($('#isBDAppVar').val() == 'BD') {
	      rules.quantity = {
	        required: true,
            min: 0,
	        digits: true,
	        quantityIncrement: true,
	        messages: {
            required: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY,
              min: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_INVALID_QTY.replace("{0}", increment),              
	          maxlength: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_HIGHER_QTY_2.replace("{0}", COSTCO.Product.maxQuantity()),
            digits: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY,
	          quantityIncrement : function(params, element) {
	        	  let message = "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_CART_MSG_QTY_INC_BD;
	        	  return OrderItems.messageParamSubstitute(message, increment);
				}
	        }
      }
      }else{
    	  rules.quantity = {
	        required: true,
            min: 0,
          	max: Number($('#cartTotalLimitBC').val()),
	        digits: true,
	        messages: {
            required: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY,
	          min: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_INVALID_QTY.replace("{0}", COSTCO.Product.getQuantityStep(input)),
	          max: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_HIGHER_QTY_2.replace("{0}", COSTCO.Product.maxQuantity()),
	          maxlength: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_ADD_TO_CART_HIGHER_QTY_2.replace("{0}", COSTCO.Product.maxQuantity()),
            digits: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY
	        }
	      }
      }
      rules.pad = {
        required: true,
        messages: {
          required: messages.SHIP_SELECT_PRE_DEL_DATE
        }
      }
      
      rules.protectionPlanQuantity = {
        required: true,
        digits: true,
        max: function(element) {
          let parentOrderItemQty = $(element).closest('.order-item').find('input[id^="quantity_"]').val();
          return parseInt(parentOrderItemQty);
        },
        messages: {
          required: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY,
          digits: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY,
          max: "<p class=\"sr-only\">" + messages.ERROR + "</p>" + messages.ERR_INVALID_QTY
        }
      }
      
      if (COSTCO.util.getLangId() == -25) {
        rules.pad.dateFormat = true;
        rules.pad.messages.date = messages.SHIP_SELECT_PRE_DEL_DATE;
      } else {
        rules.pad.date = true;
        rules.pad.messages.date = messages.SHIP_SELECT_PRE_DEL_DATE;
      }
      
      // Parts and services
      rules.scheduledDelivery = {};
      rules.scheduledDelivery.contactPhone = {
        required: true, contactPhone:true,
        messages: {
          contactPhone: messages.ERR_INVALID_PHONE1
        }
      }
      rules.scheduledDelivery.deliveryDate = {
		  required: true
      }
      rules.giftMessageRequired = {
      	emptyGiftMessage: true
      }    
      return rules;
    },
    
    cartKitsBundleRemove : function(removeOrderitemsId,quantityId, isPharmacy, prescriptionId,oldQtyval){
    	var remove_html = '';
    	var item_names = [];
    	let callerElement = event.target;
    	removeOrderitemsId.forEach(function(removeOrderitemsId) {
    		var item_name = $('#product-name_' + removeOrderitemsId).text();
    		item_names.push(item_name);
    	});
    	var item_name_kits = "";
    	for (var i = 0; i < item_names.length; i++) {
    		item_name_kits += "<li>" + item_names[i] + "</li><br>";
    	}
    	COSTCO.dialog.returnFocusOnCallerElement(callerElement);
    	remove_html += COSTCO.util.tmpl('tmpl_cart_remove_all_associated_items_popup', { item_name_kits: item_name_kits });
    	let modalSettings = {
				modalLabel: messages.REMOVE_ITEM_MODAL_ALERT,
				title:  messages.REMOVE_ITEM_POPUP,
 	            body:  remove_html,
 	            primary:messages.CART_POPUP_REMOVE_ITEMS,
 	            secondary:  messages.CART_POPUP_CANCEL,
 	             primary_event: function(){
 	            	 $('#' + quantityId).val(0);
 	            	 COSTCO.OrderItems.quantity_update(quantityId, isPharmacy, prescriptionId);
 	            }, onshown: function() {
 	            	$('button[automation-id=closeModalButton]').focus();
 	            },secondary_event: function(){
 	            	COSTCO.dialog.close();
 	            	COSTCO.OrderItems.notSoldUrl="";
 	            	if( typeof oldQtyval !== 'undefined'){
 	            		$('#' + quantityId).val(oldQtyval);
 	            	}
 	            }, onclose: function(e){
 	            	COSTCO.dialog.returnFocusOnCallerElement(callerElement);
 	            	COSTCO.OrderItems.notSoldUrl="";
 	            	if( typeof oldQtyval !== 'undefined'){
 	            		$('#' + quantityId).val(oldQtyval);
 	            	}
 	            },

    	};
    	COSTCO.dialog.showModal(modalSettings);
    },
    /**
     * If I intend to validate all of the inputs associated with order items,
     * I pass my rules config obj and use each rule associatd with the input.
     * I want to use the rules_config_obj.quantity rule with input.quantity.
     * @param  {object} rules_config_obj The rules object
     * @return {void}
     */
    validate_inputs: function(rules_config_obj) {
      $('input[type=tel].quantity').each(function(i, input) {
        $(input).rules("add", rules_config_obj.quantity)
      });
      // Add all PAD required items and check if at least one shipping option
      // was selected.
      $('.delivery-option-radios').each(function(i, delivery_radios) {
        if (checkout_helper.is_pad_required(delivery_radios) || checkout_helper.is_pad_selected(delivery_radios)) {
          var $input = $(delivery_radios).parents('.delivery-options').find('input.date-input');
          $input.rules("add", rules_config_obj.pad);
        }
      });
      
      
      $('input[id^="contactPhone"]').each(function(i, input) {
          $(input).rules("add", rules_config_obj.scheduledDelivery.contactPhone)
      });
      
      $('input[id^="deliveryDate"]').each(function(i, input) {
    	  $(input).rules("add", rules_config_obj.scheduledDelivery.deliveryDate)
      });
      
      //if there are any inputs with giftMessageRequired = true, then add rule
      $('input[name=giftMessageRequired]').each(function(i, input) {
      	
      		$(input).rules('add', rules_config_obj.giftMessageRequired);
      	
      });
    },
    /**
     * Holds the available ship dates for order items that have selected
     * PAD as their delivery option.
     * @type {Object}
     */
    ship_dates: {},
    /**
     * The .co-info element represents a tooltip. Eco-fees,
     * plain packaging, etc.
     * @return {void}
     */
    tooltips: function() {
    	COSTCO.util.accesible_popover($('.co-info, .co-help'));
      $('.a11y-tooltip').popover();
    },
    popovers: function() {
        $('.help-icon').popover({
          trigger: 'focus',
          placement: 'bottom',
        });
        $('.help-icon').popover();
      },
    /**
     * Simply submit the shop cart form. Used as a callback function for
     * COSTCO.OrderItems.validate. Inlined in CartBody.jsp
     */
    submit_cart: function() {
      var products = [];
      var noOfItems = $('#order-items').find('.order-item').length;
      //STRY0182081 changes starts
      //Holds the flag to check whether the page holds valid ship mode id or not.
      var hasValidShipmodeId = true;
      for (var i = 1; i <= noOfItems; i++) {
        var orderItemId = $('#orderItem_'+i).val();
        var shipmodeId = ($('#orderitem_shipmodedetails_'+orderItemId) != null)? $('#orderitem_shipmodedetails_'+orderItemId).val():null;
        var isOrderItemShipModeListEmpty = ($('#isOrderItemShipModeListEmpty_'+orderItemId) != null)? $('#isOrderItemShipModeListEmpty_'+orderItemId).val():false;
        //Check if the shipmodeId is undefined or shimodelist is empty, then set to false and show the error message.
        if ((shipmodeId == null || typeof shipmodeId === 'undefined' || shipmodeId == "" || isOrderItemShipModeListEmpty) && $('#isBDAppVar').val() == 'BC' ) {
        		hasValidShipmodeId = false;
        }
        $('#shipMode_'+orderItemId).val(shipmodeId);
        var quantity = $('#quantity_'+i).val();
        var partNumber =  $('.order-item')[i-1].dataset.orderitemnumber
        products.push({
          qty : quantity,
          partNumber : partNumber
        });
      }
      $('body').trigger("costco.item.qty.updated", [products]);
      if(hasValidShipmodeId && COSTCO.OrderItems.validateScheduledDeliveryDate() && COSTCO.OrderItems.validateScheduledDeliveryDateEmpty()
    		  && $('#hasPickUpError').val() != 'true'){
    	  document.ShopCartForm.submit();
    	  if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true') {
        	  if (typeof adobeProductData != 'undefined' && typeof adobeAnalyticsCommonData != 'undefined' && typeof contextVariables != 'undefined') {
        		  COSTCO.AdobeEvents.initEventIfLoggedIn('commerce.productListViews', adobeProductData, adobeAnalyticsCommonData, contextVariables);
        	  }
    	  }
      } else if (!hasValidShipmodeId) {
    	  //Check if the ship mode id is false
    	  //Show the error message at the page level, stating there is an invalid shippment assigned to a product.
		  var errLoc = "#errquantity_";
		  $(errLoc).addClass('critical-notification');
          $(errLoc).html('<p class="sr-only">' + messages.ERROR + '</p>').show();
          $(errLoc).html('<p>' + messages.ERR_INVALID_SHIPPING_METHOD_CART + '</p>').show();
      }
      //STRY0182081 changes ends
    },
    
    /**
     * This function will validate whether all the order items have valid shipping method associated to it or not.
     * Created for : STRY0182081
     */
    validateShipMode: function(showItemErrMsg) {
  	  	//Fetch the no of items in the cart.
    	var noOfItems = $('#order-items').find('.order-item').length;
    	//Iterate through each item and check for the ship mode id is present or not.
    	for (var i = 1; i <= noOfItems; i++) {
    		var orderItemId = $('#orderItem_' + i).val();
    		var shipmodeId = ($('#orderitem_shipmodedetails_'+orderItemId) != null)? $('#orderitem_shipmodedetails_'+orderItemId).val():null;
    		var isOrderItemShipModeListEmpty = ($('#isOrderItemShipModeListEmpty_'+orderItemId) != null)? $('#isOrderItemShipModeListEmpty_'+orderItemId).val():null;
    		
    		//Check if the shipmodeId is undefined or shipmodeList is empty, then set to false and show the error message.
    		if ((shipmodeId == null || typeof shipmodeId === 'undefined' || shipmodeId == "" || isOrderItemShipModeListEmpty) && $('#isBDAppVar').val() == 'BC'){
    				if (typeof showItemErrMsg != 'undefined' && showItemErrMsg) {
    					//Show the error message for each item which has invalid shipping method.
    					//Populate the shipMode_cart_error_{orderItemId} section in the cart page with the content from shipMode_error_section_${orderItemId}
    					var shipModeErrSec = $('#shipMode_error_section_'+orderItemId).html();
    					$('#shipMode_cart_error_'+orderItemId).html(shipModeErrSec);
    				} else {
        				//Skip the check for the rest of the items and return the flag status.
        				return false;
    				}
    		}
    	}
    	return true;
    },
    /**
     * Method to check if the Calendar date is a valid one
     */
    validateScheduledDeliveryDate: function(){
    	var valid=true;
    	  var isInValidDeliveryCalendar= $('#scheduledDeliveryDateInvalid').val();
    	  if( isInValidDeliveryCalendar === 'undefined'){
    		  valid=true;
    	  }else if(isInValidDeliveryCalendar =="true" ){
    		  $( ".date-input-field.error").focus();
    		  valid=false;
    	  }
    	  return  valid;
    },
    /**
     * Method to check if the Calendar field has a value
     */
    validateScheduledDeliveryDateEmpty: function(){
    	var valid=true;
    	  var isDateEmpty= $('#noDeliveryDate').val();
    	  if( isDateEmpty === 'undefined'){
    		  valid=true;
    	  }else if(isDateEmpty =="true" ){
    		  $('.date-input-field').addClass("error");
    		  $('.select-delivery-date').removeClass("hidden");
    		  $( ".date-input-field.error").focus();
    		  valid=false;
    	  }
    	  return  valid;
    },
    /**
     * Method to check if the Calendar field has a value
     */
    validateAddressAvailable: function(){
    	var valid=true;
    	  var isAddressEmpty= $('#noValidAddress').val();
    	  if( isAddressEmpty === 'undefined'){
    		  valid=true;
    	  }else if(isAddressEmpty =="true" ){
    		  $('.edd-address-error-text').removeClass('hidden');
    		  $('.edd-address-button').addClass('edd-global-zip-error');
    		  $( ".edd-address-button")[0].scrollIntoView();
    		  valid=false;
    	  }
    	  return  valid;
    },
    
    /**
     * check_quantity: client side check for cart quantities. function: test if
     * all the quantity field in shopping cart is correct, else stop form
     * submission.
     * @param {function} ajax_callback An optional callback function that tells
     *                                 check_quantity to use this instead of
     *                                 using a form submit after it validates.
     */
    check_quantity: function(ajax_callback) {
      var noOfItems = $('.order-item').length;
      var flag = false;
      var check = {};
      for (var i = 1; i <= noOfItems; i++) {
        if ($("#quantity_" + i).length != 0) {
          check = jQuery.trim($("#quantity_" + i).val());
        }
        if (check.length != 0 && !/^[0-9]+(\.[0]{1,2})?$/.test(check)) {
          flag = true;
          $("span.server-error").hide();
          $("div.check").hide();
          var errLoc = "#errquantity_";
          $(errLoc).html('<p class="sr-only">' + messages.ERROR + '</p>').show();
          $(errLoc).html('<p>' + messages.ERR_ADD_TO_CART_INVALID_QTY + '</p>').show();
          $('html, body').animate({
            scrollTop: $(errLoc).offset().top
          }, 'fast');
          break;
        }
      }
      if (!flag && !ajax_callback) {
        $(errLoc).html("").hide();
        document.ShopCartForm.submit();
      } else if (!flag && typeof ajax_callback == "function") {
        ajax_callback();
      }
    },
    /**
     * The inline event handler for the edit links associated with
     * the quantities of each order item in the order items table.
     * @param  {object} event The type of event mapped to the inline event handler
     * @return {void}
     */
    edit_quantity: function(event) {
      var id = $(this).data('id');
      $(this).addClass('hide');
      $('span[data-id=' + id + ']').addClass('hide');
      $('input[id =' + id +']').removeClass('hide');
      $('input[id =' + id +']').focus();
      $('.update[data-id=' + id + ']').removeClass('hide');
    },
    reset_delivery_options: function() {
      
      COSTCO.OrderItems.validate.call();
      
      $('.delivery-options.grey-box').not('.exclude').addClass('hide');
      $('.delivery-options-selected.grey-box').not('.exclude').removeClass('hide');
      
      if($('label.error').not(':empty').length > 0 && $('[name=' + $('label.error').not(':empty').attr('for') + ']').length > 0) {
    	  alert();
      	var lineItem = $("label.error")
			for (m=0; m < lineItem.length; m++) {
				var itemId = lineItem[m].htmlFor.includes('date_') ? lineItem[m].htmlFor.replace('date_','') : ""
				$('.delivery-options-selected[data-orderitem=' + itemId + ']').addClass('hide');
				$('.delivery-options[data-orderitem=' + itemId + ']').removeClass('hide');
			}
      }
    },
    /**
     * Inline event handler for the deliver options edit link. Hides the
     * "Selected" block and shows radio options available for selection.
     * @return {void}
     */
    edit_delivery_options: function() {
      if ($(this).hasClass('edit')) {
        // Hide the "selected" block and show the list of radio options
    	
        COSTCO.OrderItems.reset_delivery_options();
    	
        var selected = $(this).parents('.delivery-options-selected'),
          orderitem_id = selected.data('orderitem');
        selected.addClass('hide');
        $('.delivery-options[data-orderitem=' + orderitem_id + ']').removeClass('hide');
        $('.delivery-options[data-orderitem=' + orderitem_id + ']').find(':checked').focus();
        
        
        
      }
    },

    /**
     * Pops a modal for the delivery option details
     * @param  {string} title_id   ID of the title of the product to be used
     *                             as the title of the modal.
     * @param  {string} clauses_id ID of the list of clauses to display in the
     *                             body of the modal
     * @return {void}
     */
    delivery_details: function(title_id, clauses_id) {

      let callerElement = event.target;

      COSTCO.dialog.createExtDialogBox({
        title: messages.DELIVERY_DETAILS,
        body: $('#' + clauses_id).html(),
        primary: messages.JS_DIALOG_OK
      });
      COSTCO.dialog.returnFocusOnCallerElement(callerElement);
    },
    /**
     * Pops a modal for the pickup option details
     * @param  {string} title_id   ID of the title of the product to be used
     *                             as the title of the modal.
     * @param  {string} clauses_id ID of the list of clauses to display in the
     *                             body of the modal
     * 
     * @param  {string} pick_clauses_id ID of the list of clauses to display in the
     *                             body of the modal
     * @return {void}
     */
    pickup_and_delivery_details: function(title_id, clauses_id, pick_clauses_id) {
      let callerElement = event.target;
      let addHeading = messages.DELIVERY_DETAILS_HEADING+$('#' + clauses_id).html();
      let concatenateText = addHeading+$('#' + pick_clauses_id).html();
      COSTCO.dialog.createExtDialogBox({
        title: messages.DELIVERY_PICKUP_DETAILS,
        body: concatenateText,
        primary: messages.JS_DIALOG_OK
      });
      COSTCO.dialog.returnFocusOnCallerElement(callerElement);
    },
    /**
     * This function checks if the item to be removed is a membership card and
     * if a user does not have a memebrship already and then
     * it calls COSTCO.Checkout.openRemoveWarningModal if both conditions are true
     */
   delegate_remove_action: function(isMembershipItem, isRenew, orderItemId, countMembershipItemInCart) {
      let isMember = (COSTCO.util.getMemberCookie()['costcoMember'] != 'undefined' && COSTCO.util.getMemberCookie()['costcoMember'] != null) ? COSTCO.util.getMemberCookie()['costcoMember'] : false;

      if(isMembershipItem && countMembershipItemInCart === 1 &&(isRenew || !isMember)) {
		  COSTCO.Checkout.openRemoveWarningModal(isRenew, orderItemId);
      } else {
    	  COSTCO.OrderItems.remove_item(orderItemId);
      }
    },
    
  delegate_remove_action_v2: function(isMembershipItem, isRenew, orderItemId, orderId, catEntryId, countMembershipItemInCart, isPharmacy, prescriptionId, lastItemInCart) {
     
	  var itemwithSameBundleId =[];
	  	var notSoldeItem =[];
	  	var removeOrderitemsId =[];
	  	let delegateRemoveItemsParam = {};
	  	COSTCO.OrderItems.notSoldUrl="";
	  	var isNotSoldItem=$("#notSoldSeperatelyItem_"+orderItemId).val()=="true"? true:false;
	  	if(undefined != $("#notSoldSeperatelyBundleId_"+orderItemId).val() && !isNotSoldItem){
	  		var bundleId= $("#notSoldSeperatelyBundleId_"+orderItemId).val();
	  		$('.notSoldBundil').each(function() {
	  			var test=this;
	  			if(bundleId== $(this).val()){
	  			var OtherbundleitemIdArray=	$(this).attr('id').split("_");
	  			if(undefined != OtherbundleitemIdArray[1] && null !=OtherbundleitemIdArray[1]){
	  				itemwithSameBundleId.push(OtherbundleitemIdArray[1]);
	  				var isNotSoledSeperatlyItem=$("#notSoldSeperatelyItem_"+OtherbundleitemIdArray[1]).val()=="true"? true:false;
	  				if(isNotSoledSeperatlyItem){
	  					notSoldeItem.push(OtherbundleitemIdArray[1]);
	  				}
	  			}
	  		}
				});
	  		if(itemwithSameBundleId.length !=0 && notSoldeItem.length !=0){
	  			var normalItemLength =itemwithSameBundleId.length - notSoldeItem.length;
	  			if(normalItemLength ==1){
	  				for ( var i = 0;i < notSoldeItem.length; i++ ) {
	  					removeOrderitemsId.push(notSoldeItem[i]);
	  					var count=i+2;
	  					let delegateRemoveitem = 'orderItem_'+count;
	  					delegateRemoveItemsParam[delegateRemoveitem] = notSoldeItem[i];
	  					var catentryId=$("#notSoldSeperateCatenId_"+notSoldeItem[i]).val();
	  					let catentry= 'catalogEntryId_'+count;
	  					delegateRemoveItemsParam[catentry] = catentryId;
	  					let qty= 'quantity_'+count;
	  					delegateRemoveItemsParam[qty] = 0;
	  					COSTCO.OrderItems.notSoldUrl=COSTCO.OrderItems.notSoldUrl+"&orderItem_"+count+"="+notSoldeItem[i]+"&quantity_"+count+"=0&catalogEntryId_"+count+"="+catentryId;
	  				}
	  				 
	  			}
	  				
	  		}
	  	}
	  
	  let isMember = (COSTCO.util.getMemberCookie()['costcoMember'] != 'undefined' && COSTCO.util.getMemberCookie()['costcoMember'] != null) ? COSTCO.util.getMemberCookie()['costcoMember'] : false;
      //Invalidating prestored EDD response for OrderItemID
      var calendarResponse = $('#calendarServiceResponse').val();
      if(calendarResponse!= undefined){
      document.getElementById("calendarServiceResponse").value ="";
      apiAlreadyCalled = undefined;
      }
      if(isMembershipItem && countMembershipItemInCart === 1 &&(isRenew || !isMember)) {
		  COSTCO.Checkout.openRemoveWarningModal_v2(isRenew, orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
      } else {
    	  if(undefined != COSTCO.OrderItems.notSoldUrl && COSTCO.OrderItems.notSoldUrl !="" ){
          	 COSTCO.OrderItems.cartKitsBundleDelegateRemove(delegateRemoveItemsParam,removeOrderitemsId,orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
           }
           if(undefined == COSTCO.OrderItems.notSoldUrl || COSTCO.OrderItems.notSoldUrl =="" ){
         	  COSTCO.OrderItems.remove_item_v2(orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
           }
       }
     },  
    /**
     * 
     */
   
    
    cartKitsBundleDelegateRemove : function(delegateRemoveItemsParam,removeOrderitemsId,orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart){
    	var remove_html = '';
    	var item_names = [];
    	let callerElement = event.target;
    	removeOrderitemsId.forEach(function(removeOrderitemsId) {
    		var item_name = $('#product-name_' + removeOrderitemsId).text();
    		item_names.push(item_name);
    			});
    	var item_name_kits = "";
    	for (var i = 0; i < item_names.length; i++) {
    		item_name_kits += "<li>" + item_names[i] + "</li><br>";
    	}
    	remove_html += COSTCO.util.tmpl('tmpl_cart_remove_all_associated_items_popup', { item_name_kits: item_name_kits });
    	COSTCO.dialog.returnFocusOnCallerElement(callerElement);
    	let modalSettings = {
	 	            modalLabel: messages.REMOVE_ITEM_MODAL_ALERT,
	 	            title:  messages.REMOVE_ITEM_POPUP,
	 	            body:  remove_html,
	 	            primary:messages.CART_POPUP_REMOVE_ITEMS,
	 	            secondary:  messages.CART_POPUP_CANCEL,
	 	            primary_event: function(){
	 	            	COSTCO.OrderItems.remove_delegate_item_v2(delegateRemoveItemsParam,orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart);
	 	        								
	 	        	}, onshown: function() {
	 	        		$('button[automation-id=closeModalButton]').focus();
	 	        	}, secondary_event: function(){
	 	        		COSTCO.dialog.close();
	 	        		COSTCO.OrderItems.notSoldUrl="";
	 	        	}, onclose: function(e){
	 	        		COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	 	        		COSTCO.OrderItems.notSoldUrl="";
	 	        	},
	 	};
    	COSTCO.dialog.showModal(modalSettings);
    },
    	remove_item: function(orderItemId){
    	    	COSTCO.OrderItems.setCookie("cartTotalCookie","0.00");
    	    	var removeURL = $('input[name=removeURL_' + orderItemId+']').val();
    	    	$form = $('<form></form>');
    	    	$form.append("<input type='hidden' name='authToken' value='"+COSTCO.Checkout.getAuthToken()+"' />");
    	    	$form.attr('action', removeURL);
    	    	$form.attr('method', 'post');
    	    	$form.appendTo('body').submit();
    	    },
    	    
    	    remove_item_v2: function(orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart){
    	    	        COSTCO.OrderItems.setCookie("cartTotalCookie","0.00");
    	    	        let calledEDDAfterRemoval = false;
    	    	            let params = {
    	    	                    ajaxFlag: true,
    	    	                    isRestrictedPostalCode: false,
    	    	                    actionType: 'delete',
    	    	                    orderId: orderId,
    	    	                    orderItemId: orderItemId,
    	    	                    catEntryId: catEntryId,
    	    	                    isPharmacy: isPharmacy,
    	    	                    prescriptionId: prescriptionId,
    	    	                    lastItemInCart: lastItemInCart

    	    	            };
    	    	            COSTCO.AjaxModular.ajax_update_state({
    	    	                method: 'POST',
    	    	                url: '/AjaxModularManageShoppingCartCmd',
    	    	                data: params,
    	    	                dataType: 'json',
    	    	                done: function(data, textStatus, jqXHR, options) {
    	    	                    COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
    	    	                    if (data.error !== undefined && (data.error.application.length > 0
    	    	                            || data.error.exception.length >0)) {
    	    	                        OrderItems.displayOrderErrors(data);
    	    	                    } else {
    	    	                        COSTCO.Header.miniShopCartRefresh();
    	    	                        COSTCO.OrderItems.addQuantityEventHandlers();
    	    	                        if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
    	    	                            COSTCO.Global.datePickerEventHanler();
    	    	                        }
    	    	                    }
    	    	                    if(data.payload.data.successMessage !== undefined) {
    	    	                        // announce success message to screen reader
    	    	                        checkout_helper.addScreenReaderAnnouncement(data.payload.data.successMessage);
    	    	                    }
    	    						if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true' && checkoutPage == 'cart') {
	    	    	 					if (typeof contextVariables != 'undefined') {
	    	    		 					$('body').find('script[id="'+$('[data-orderitemid="'+orderItemId+'"]').first().attr('data-orderitemnumber')+'"]').remove();
	    	    	 					}
    	    						}
    	    	                    //this payload will come from checkout page on removing last item
    	    	                    //on shipping options
    	    	                    if(data.payload.data.viewTaskName === 'AjaxModularDefaultView') {
    	    	                        window.location.href = '/CheckoutCartView';
    	    	                    }
    	    	                    COSTCO.OrderItems.init();
    	    	                    //EDD service is called on init
    	    	                    calledEDDAfterRemoval = true;
    	    	                },
    	    	                always: function() {
    	    	                    if($('#deldatepicker').length > 0) {
    	    	                        COSTCO.OrderItems.delDatePicker();
    	    	                        COSTCO.OrderItems.updateShipmodeDetails();
    	    	                    }
    	    	                    $('.co-help').popover();
    	    	                    if(!calledEDDAfterRemoval){
            	                        COSTCO.EDDService.callEddService();
    	    	                    }
    	    	                }
    	    	            });

    	    	    },
    
    remove_delegate_item_v2: function(delegateRemoveItemsParam,orderItemId, orderId, catEntryId, isPharmacy, prescriptionId, lastItemInCart){
    	COSTCO.OrderItems.setCookie("cartTotalCookie","0.00");
    	
        	let params = {
        			ajaxFlag: true,
        			isRestrictedPostalCode: false,
        			actionType: 'delete',
        			orderId: orderId,
        			orderItemId:orderItemId,
        			orderItem_1:orderItemId,
        			catEntryId:catEntryId ,
        			catalogEntryId_1: catEntryId,
        			quantity_1: 0,
        			isPharmacy: isPharmacy,
        			prescriptionId: prescriptionId,
        			lastItemInCart: lastItemInCart
        			
        			
        	};
        	
        	let delegateRemoveCombinedParams = Object.assign(params, delegateRemoveItemsParam);
        	
        	COSTCO.AjaxModular.ajax_update_state({
        		method: 'POST',
        		url: '/AjaxModularManageShoppingCartCmd',
        		data:delegateRemoveCombinedParams,
        		dataType: 'json',
        		done: function(data, textStatus, jqXHR, options) {
        			COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
        			if (data.error !== undefined && (data.error.application.length > 0
        					|| data.error.exception.length >0)) {
        				OrderItems.displayOrderErrors(data);
        			} else {
        				COSTCO.Header.miniShopCartRefresh();
        				COSTCO.OrderItems.addQuantityEventHandlers();
        				if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
        					COSTCO.Global.datePickerEventHanler();
        				}
        			}
        			if(data.payload.data.successMessage !== undefined) {
        				// announce success message to screen reader
        				checkout_helper.addScreenReaderAnnouncement(data.payload.data.successMessage);
        			}
        			//this payload will come from checkout page on removing last item
        			//on shipping options
        			if(data.payload.data.viewTaskName === 'AjaxModularDefaultView') {
        				window.location.href = '/CheckoutCartView';
        			}
        			COSTCO.OrderItems.init();
        		},
        		always: function() {
        			if($('#deldatepicker').length > 0) {
            			COSTCO.OrderItems.delDatePicker();
            			COSTCO.OrderItems.updateShipmodeDetails();
        			}
				$('.co-help').popover();
				 COSTCO.EDDService.callEddService();
        		}
        	});
        	 COSTCO.dialog.close();
        	 COSTCO.OrderItems.notSoldUrl="";
    },
    /**
     * Adds the protection plan to the current order
     * @param  {int} catEntryId   		catEntryId of the item to add to cart
     * @param  {int} parentOrderItemId	orderItemId of the parent item
     * @return {void}
     */
    addProtectionPlan: function(element, catEntryId, parentOrderItemId, orderId, addressId) {
    	// After the AJAX update, focus is returned to this element
    	let focusId = element && element.id;
    	
    	let params = {
    			ajaxFlag: true,
    			isRestrictedPostalCode: false,
    			actionType: 'add',
    			catEntryId: catEntryId,
    			quantity: $('[name=protectionPlanQuantity_' + catEntryId + '_' + parentOrderItemId + ']').val(),
    			catalogEntryId_1: catEntryId,
    			quantity_1: $('[name=protectionPlanQuantity_' + catEntryId + '_' + parentOrderItemId + ']').val(),
    			parentOrderItemId: parentOrderItemId,
    			orderId: orderId,
    			isProtectionPlan: true,
    			addressId: addressId
    	};
        
        COSTCO.AjaxModular.ajax_update_state({
    		method: 'POST',
            url: '/AjaxModularManageShoppingCartCmd',
            data: params,
            dataType: 'json',
            done: function(data, textStatus, jqXHR, options) {
            	COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
            	if (data.error !== undefined && (data.error.application.length > 0
    					|| data.error.exception.length >0)) {
            		let parentOrderItemId = data.payload.data.parentOrderItemId;
    				let itemErrorContainer = $('div[data-parentorderitemid=' + parentOrderItemId + ']');
    				OrderItems.displayOrderErrors(data, itemErrorContainer);
    			} else {
    				COSTCO.Header.miniShopCartRefresh();
    				$(element).prop('checked', true);
    			}
            	COSTCO.OrderItems.updateShipModeToPickUp(false);
            	COSTCO.EDDService.callEddService();
            },
            complete: function() {
              if (focusId) {
                setTimeout(function () {
                  let $el = $('#' + focusId);
                  if ($el.length) {
                    $el.focus();
                  }
                }, 0);
              }
            }
    	});
    },
    /**
     * Removes the protection plan from the current order
     * @param  {int} orderId   			orderId of the order to remove the protection plan from
     * @param  {int} orderItemId   		orderItemId of the protection plan to remove
     * @param  {int} parentOrderItemId	orderItemId of the parent item
     * @return {void}
     */
    removeProtectionPlan: function(element, orderId, orderItemId, parentOrderItemId) {
    	// After the AJAX update, focus is returned to this element
    	let focusId = element && element.id;
    	let params = {
    			ajaxFlag: true,
    			isRestrictedPostalCode: false,
    			actionType: 'delete',
    			orderId: orderId,
    			orderItemId: orderItemId
    			
    	};
    	COSTCO.AjaxModular.ajax_update_state({
    		method: 'POST',
    		url: '/AjaxModularManageShoppingCartCmd',
    		data: params,
    		dataType: 'json',
    		done: function(data, textStatus, jqXHR, options) {
    			COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
    			if (data.error !== undefined && (data.error.application.length > 0
    					|| data.error.exception.length >0)) {
    				let parentOrderItemId = data.payload.data.parentOrderItemId;
    				let itemErrorContainer = $('div[data-parentorderitemid=' + parentOrderItemId + ']');
    				OrderItems.displayOrderErrors(data, itemErrorContainer);
    			} else {
    				COSTCO.Header.miniShopCartRefresh();
    				$(element).prop('checked', false);
    			}
    		},
            complete: function() {
              if (focusId) {
                setTimeout(function () {
                  let $el = $('#' + focusId);
                  if ($el.length) {
                    $el.focus();
                  }
                }, 0);
              }
            }
    	});
    },
    /**
     * Replaces an existing protection plan in the current order.
     * The function performs a two-step operation:
     * 1) Removes the currently selected protection plan via AJAX.
     * 2) On successful removal, adds the new protection plan using COSTCO.OrderItems.addProtectionPlan.
     * @param {HTMLElement} element
     * @param {string} orderId
     * @param {string} orderItemId
     * @param {string} catEntryId
     * @param {string} parentOrderItemId
     * @param {string} addressId
     */
    replaceProtectionPlan: function(element, orderId, orderItemId, catEntryId, parentOrderItemId, addressId) {
      // Remove existing protection plan
      COSTCO.AjaxModular.ajax_update_state({
        method: 'POST',
        url: '/AjaxModularManageShoppingCartCmd',
        data: {
          ajaxFlag: true,
          isRestrictedPostalCode: false,
          actionType: 'delete',
          orderId: orderId,
          orderItemId: orderItemId,
        },
        dataType: 'json',
        done: function(data, textStatus, jqXHR, options) {
          if (data.error !== undefined && (data.error.application.length > 0
              || data.error.exception.length > 0)) {
            COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
            let parentOrderItemId = data.payload.data.parentOrderItemId;
            let itemErrorContainer = $('div[data-parentorderitemid=' + parentOrderItemId + ']');
            OrderItems.displayOrderErrors(data, itemErrorContainer);
          } else {
            // Add new protection plan and keep the page busy
            options.keepBusy = true;
            COSTCO.OrderItems.addProtectionPlan(element, catEntryId, parentOrderItemId, orderId, addressId);
          }
        }
      });
    },
    displayOrderErrors: function(data, itemErrorContainer) {
    	
    	if (typeof itemErrorContainer !== "undefined" && itemErrorContainer.length > 0) {
    		
    		itemErrorContainer.empty();
			
			if (data.error.application !== undefined) {
				$.each(data.error.application, function(index, errorMessage) {
					itemErrorContainer.append(errorMessage);
				});
			}
			if (data.error.exception !== undefined) {
				$.each(data.error.exception, function(index, errorMessage) {
					itemErrorContainer.append(errorMessage);
		    	});
			}
			itemErrorContainer.removeClass('hide');
    	}
		
		COSTCO.util.notification.displayNotification(COSTCO.util.notification.type.ERROR, [data.error.application], true, '#notification-message');
    },
    setCookie: function(cookieName, cvalue) {
    	console.log("COOKIE REMOVED");
        document.cookie = cookieName + "=" + cvalue + ";";
    },
    order_prepare: function() {
    	var error_container = $('.error.check').length > 0 ? '.error.check' : '.order-error';
    	console.log("Invoke Order Prepare");
    	checkout_helper.ajax_update_state({
    	       url: '/order-prepare',
    	       method: "POST",
    	       data: $('#ShopCartForm').serialize(),
    	       error_container: error_container,
    	       ajax_replace_content: function(response_obj, mergedOptions, defaultOptions) {
    	          defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
    	        },
    	        ajax_update_post_done: function(response_obj, mergedOptions, defaultOptions) {
    	          // Refresh the cart icon's number to reflect the adjusted quantity.
    	          COSTCO.Header.miniShopCartRefresh();
    	          COSTCO.OrderItems.init();
    	          COSTCO.dialog.close();
    	        }
    	      });
    },
    /**
     * Makes a request to /order-quantity-update which wraps
     * ManageShoppingCartCmdImpl. This will update the quantity of the items
     * requested and then return a json response with html to inject
     * representing the new order items and order total.
     * @return {void}
     */
    quantity_update: function(input, isPharmacy, prescriptionId) {
      var error_container = $('.error.check').length > 0 ? '.error.check' : '#errquantity_';
      let orderItemIndex = 0;
      if(Array.isArray(input)){
    	  orderItemIndex = input[0].replace("quantity","");
      } else {
    	  orderItemIndex = input.replace("quantity","");
      }
      let orderItemIndexRegExp = new RegExp(orderItemIndex, 'g');
      let activeElement = document.activeElement.getAttribute("id");
      let inputContainer = undefined;
      if(checkoutPage == 'cart' || costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
    	  inputContainer = input;
      }
      else {
    	  let inputId = input.id;
    	  let inputContainerArr = $('.edit').filter('[data-id='+inputId+']');
    	  for(i=0; i<inputContainerArr.length; i++) {
    		  if($(inputContainerArr[i]).attr('data-max-screen') && COSTCO.util.isMaxScreen($(inputContainerArr[i]).data('max-screen'))) {
    			  inputContainer=inputContainerArr[i];
    			  break;
    		  }
    		  else if($(inputContainerArr[i]).attr('data-min-screen') && COSTCO.util.isMinimumScreen($(inputContainerArr[i]).data('min-screen'))) {
    			  inputContainer=inputContainerArr[i];
    			  break;
    		  }
    	  }
      }
      
      //On review page, since there are two quantity inputs for each item (desktop and mobile/tablet),
      //we need to disable the input not being used so it won't be included in formdata
      
      if(!costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE){
      if (checkoutPage == 'review') {
	      if (COSTCO.util.getScreenType() == 'DESKTOP' || COSTCO.util.getScreenType() == 'TABLET-LANDSCAPE') {
	    	  $('input[id^=quantity_]').not('[id$=DESKTOP]').attr('disabled', 'disabled');
	      }
	      else {
	    	  $('input[id^=quantity_][id$=DESKTOP]').attr('disabled', 'disabled');
	      }
      }
      }
      
      COSTCO.util.input_injector('#ShopCartForm', {
        actionType: 'update',
        ajaxFlag: 'true',
        requesttype: 'ajax',
        isPharmacy: (typeof isPharmacy === "undefined") ? false : isPharmacy,
        prescriptionId: (typeof prescriptionId === "undefined") ? "" : prescriptionId
      });
      // Input injector intially sets ajaxFlag to true in the ShopCartForm,
      // but subsequent calls to quantity_update need to ensure it is set
      // true because ajax_update_post_done sets it false.
      $('#ShopCartForm input[name=ajaxFlag]').val(true);
      let reqData = $('#ShopCartForm [name]').not("#order-items :input").serialize() + '&' + $("#order-item" + orderItemIndex + " :input").serialize();
      reqData = reqData.replaceAll(orderItemIndex,"_1");
      if(undefined != COSTCO.OrderItems.notSoldUrl && COSTCO.OrderItems.notSoldUrl !="" ){
    	  reqData=reqData+""+COSTCO.OrderItems.notSoldUrl;
      }
      checkout_helper.ajax_update_state({
        url: '/order-quantity-update',
        method: "POST",
        //data: $('#ShopCartForm').serialize(),
        data: reqData,
        page: (typeof checkoutPage === "undefined") ? "" : checkoutPage,
        error_container: error_container,
        done: function(data, textStatus, jqXHR, options) {
            try {
                let response_obj = typeof(data) === 'object' ? data : JSON.parse(data);
                
                if (response_obj.error && response_obj.error.application.indexOf(messages.EMPTY_CART)== 0) {
                  document.location.href = "/CheckoutCartView";
                } else {
                  COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
                }
              } catch (e) {
                console.error(e);
              }
            },
        ajax_replace_content: function(response_obj, mergedOptions, defaultOptions) {
          if(response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
        	  response_obj.error.application.push(response_obj.metadata.quantityUpdatedForCashCardPaymentErr)
          }
          defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
        },
        ajax_update_post_done: function(response_obj, mergedOptions, defaultOptions) {
          // Refresh the cart icon's number to reflect the adjusted quantity.
          COSTCO.Header.miniShopCartRefresh();
          $('#ShopCartForm input[name=ajaxFlag]').val(false);
          COSTCO.OrderItems.init();
    	  if(typeof COSTCO.CreditCard !== 'undefined'){
    		  COSTCO.CreditCard.initComplete = false;
    		  COSTCO.CreditCard.init();
    	  }
    	  
    	  // add ada message, after the quantity is updated
    	  let  estimatedTotalLabel;
    	  
    	  if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
    	  	estimatedTotalLabel = $('.estimated-total-label');
    	  	if (!COSTCO.util.isBusinessDelivery()){
    	  		COSTCO.OrderItems.setDeliveryDateView();
    	  	}
    	  } else {
    	  	estimatedTotalLabel = $('#estimated-total-label');
    	  }

        let estimatedTotalValue = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && checkoutPage === 'review' ? $('.surchargeOrderTotal') : $('#order-estimated-total');  
        if (estimatedTotalLabel.length > 0 && estimatedTotalValue.length > 0) {
          checkout_helper.addScreenReaderAnnouncement(estimatedTotalLabel.html() + ' ' + estimatedTotalValue.html());
        }
    	  
        },
        always: function(){
	    	COSTCO.Checkout.ajax_update_default_always(inputContainer);
	    	//remove disabled attr on any hidden inputs that got disabled
	    	$('input[id^=quantity_]').removeAttr('disabled');
	    	if(typeof TokenGateway != 'undefined'){
	    		TokenGateway.refreshGateway();
	    	}	
	    	COSTCO.OrderItems.popovers();
	    	COSTCO.preauthchargesmodal.init();
	    	COSTCO.OrderSummaryCart.measurementGuideCheckboxesOnOff();

          // Sync attr 'value' and field value in quantities on Cart page, in case of back-end rejection of change
          if (checkoutPage == 'cart' || checkoutPage == 'review') {
            $('[id^=quantity_]').each(function(index, element) {
              if ($(element).val() != $(element).attr('value')) {
                $(element).val($(element).attr('value'));
              }
            });
          	$('#' + activeElement).focus(); 
          }
          
          if(checkoutPage == 'review'){
          	if(inputContainer[0] != undefined && inputContainer.value != 0){ 
          		$('#' + activeElement).focus(); 
        	  }
          }
          COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
        },
        complete: function() {
          // Set focus to COSTCO.AjaxModular.pendingFocusId element, if it is set
          let focusId = COSTCO.AjaxModular.pendingFocusId;
          COSTCO.AjaxModular.pendingFocusId = null;
          if (focusId) {
            setTimeout(function() {
              let $el = $('#' + focusId);
              if ($el.length) {
                $el.focus();
              }
            }, 0)
          }
        },
        inputContainer: inputContainer
      });
      COSTCO.dialog.close();
      COSTCO.OrderItems.notSoldUrl="";
    },
    //Method to update all the quntity fields on update of one quantity
    onchange_update: function(obj,qtyup,quant){
    	var qty=obj.value;    	
    	$('input[id='+obj.id+']').val(qty);
    	COSTCO.OrderItems.validate.call(obj,qtyup,quant);
    },
    /**
     * Take global errors and place them in-line
     * @return {void}
     */
    placeGlobalCartErrorsInLine: function(response_obj) {
    	
    	//function will place error message in-line and deal with CSS
    	function placeErrorInLine(itemNumber, errorMsg){
		  var lineItem = $("div[data-orderitemnumber]")
		  //For each order item number
		  for (c=0; c < lineItem.length; c++) {
			  var itemNumberTmp = $(lineItem[c]).data("orderitemnumber")
			  //Order item container
			  if ( itemNumberTmp == itemNumber ){
				  //Place error message in all containers
				  //$(lineItem[c]).find('.critical-notification').html(errorMsg.replace(/''/g, '\'') )
				  $(lineItem[c]).find('.critical-notification').each(function(index, element){
					  if(undefined !== element.id && element.id.indexOf('notSoldSepLineItemError') != -1){
						 $(element).addClass("hide");
					  } else {
						  $(element).html(errorMsg.replace(/''/g, '\'') );
					  }
				  });
				  //Deal with containers
				  var errorContainer = $(lineItem[c]).find('.critical-notification');
				  //Do this for Cart View Only
				  if (window.location.href.indexOf('CheckoutCartView')>-1 || window.location.href.indexOf('CheckoutCartDisplayView')>-1
						  && !costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE){
					  $(errorContainer[0]).addClass('hidden-xs hidden-sm hidden-md')
					  $(errorContainer[1]).addClass('hidden-lg hidden-xl')
				  }
				  //Do this for Review Page only
				  if (window.location.href.indexOf('CheckoutReviewView')>-1){
					  $('#errquantity_').removeClass('error')
					  $('#errquantity_').addClass('critical-notification')
				  }
				  //Show time ready!
				  $(lineItem[c]).find('.critical-notification').each(function(index, element){
					  if(undefined !== element.id && element.id.indexOf('notSoldSepLineItemError') != -1){
						  $(element).addClass("hide");
					  } else {
						  $(element).removeClass('hide');
					  }
				  });	 
				  //$(lineItem[c]).find('.critical-notification').removeClass('hide')
				  $('#errquantity_').removeClass('hide')
			  }
		  }
    	}
    	
    	//Places errors in-line that show on the page before any ajax call
    	if (typeof(response_obj) == "undefined"){
        	//get all global error messages
    		var errorTop = $('.errorTop')
    		for (i=0; i < errorTop.length; i++) {
    			//for each error message parse the partnumber - this is where it gets weird
    			var lineItem = $("div[data-orderitemnumber]")
    			for (m=0; m < lineItem.length; m++) {
    				var item = $(lineItem[m]).data("orderitemnumber")
    				var errorMessage = $(errorTop[i]).html();
    				item = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE ? " " + item : item;
    				var found = errorMessage.search(item);
    				if (found != -1){
    					placeErrorInLine(item,errorMessage);
    				}
    			}
    		}
    		$('#errquantity_').hide()
    	}else{
    		//Places errors in-line after ajax call
    		for (i=0; i < response_obj.error.application.length; i++) {
            	var lineItem = $("div[data-orderitemnumber]")
            	for (m=0; m < lineItem.length; m++) {
            		var item = $(lineItem[m]).data("orderitemnumber")
            		var errorMessage = response_obj.error.application[i];
    				var found = errorMessage.search(item);
    				if (found != -1){
    					placeErrorInLine(item,errorMessage);
    				}
            	}
    		}
    		$('#errquantity_').show()
    	}
    },

    /**
     * Save for later operations
     */
    saveForLater : {
      save: function(catentryId, orderItemId) {
        OrderItems.saveForLater.ajaxCallSFL(catentryId, 'save', orderItemId);
        OrderItems.saveForLater.announceSrMessageForSflAction(messages.SFL_ITEM_SAVED_FOR_LATER);
      },
      remove: function(catentryId) {
        OrderItems.saveForLater.ajaxCallSFL(catentryId, 'remove');
        OrderItems.saveForLater.announceSrMessageForSflAction(messages.SFL_REMOVED_FROM_THE_CART);
      },
      moveToCart: function(catentryId) {
    	COSTCO.util.notification.clearNotification('#errquantity_');
        OrderItems.saveForLater.ajaxCallSFL(catentryId, 'move_to_cart');
        OrderItems.saveForLater.announceSrMessageForSflAction(messages.SFL_MOVED_TO_THE_CART);
      },
      ajaxOpenPage: function(pageNumberToGo) {
        checkout_helper.ajax_update_state({
          url: '/AjaxGetSFLItemsCmd',
          method: "POST",
          data: {
            pageNumber: pageNumberToGo
          },
          ajax_update_post_done: function(response_obj, mergedOptions, defaultOptions) {
            $('html, body').scrollToElem($('#order-items-sfl'), 100);
            OrderItems.tooltips();
          }
        });
      },
      ajaxCallSFL: function (catentryId, action, orderItemId = '') {
    	  if (typeof $('#calendarServiceResponse').val() !== 'undefined') {
         		document.getElementById("calendarServiceResponse").value = "";
         		}
             apiAlreadyCalled = undefined;
        let error_container = '#errquantity_';
        checkout_helper.ajax_update_state({
          error_container : error_container,
          url: '/AjaxSaveForLaterCmd',
          method: "POST",
          data: {
            catentryId: catentryId,
            action: action,
            orderItemId: orderItemId 
           },
           ajax_replace_content: function(response_obj, mergedOptions, defaultOptions) {
               defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
               COSTCO.Header.miniShopCartRefresh();
               COSTCO.OrderItems.init();
           },
           ajax_update_post_done: function(response_obj, mergedOptions, defaultOptions) {
        	   $('.co-help').popover('destroy');
               COSTCO.OrderItems.tooltips();
               
             },
             ajax_handle_errors: function(response_obj, mergedOptions, defaultOptions) {
            	 let exception = response_obj.error.exception || [];
                 let error_html = '';
                 if (exception.length > 0) {
                   error_html += '<p>'+exception[0].errorMessage+'</p>';
           }
                 let error = $(error_container);
                 if (error_html.trim() != '') {
                	 error.append("<p class=\"sr-only\">" + messages.ERROR + "</p>");
                	 error.append(error_html);
                	 error.addClass('critical-notification');
               	  if(mergedOptions.not_critical_notification !== undefined && mergedOptions.not_critical_notification) {
               		error.removeClass('critical-notification');
               	  }
               	  COSTCO.util.announceSRMessage(messages.ERROR + "&nbsp" + error_html);
                 } 
             }
        });       
      },
      /**
       * Announces to SR user when SFL action happened.
       * Finds nearest product title and use it as parameter
       * for announceSRMessage function
       */
      announceSrMessageForSflAction: function(srMessage) {
          let productDescription = $(event.currentTarget).closest('.order-item').find('.sfl-item-desc a').text();
          if(productDescription){
              let srMessageForAnnouncing = srMessage.replace("{0}", productDescription);
              COSTCO.util.announceSRMessage(srMessageForAnnouncing);
          }
      },
    },
	 
    /**
     * Plain packaging for items. Save or delete operations. Use with
     * PlainPackaging.jsp
     * @return {void}
     */
    plain_packaging: function() {
      let data = $(this).parents('.plain-packaging-data'),
        op = data.find('input[name=op]');
      $(this).prop('checked') ? op.val('save') : op.val('delete');
      $(this).prop('disabled', true); // probably need to disable place order too?
      COSTCO.util.ajax({
        url: '/ManagePlainPackaging',
        method: 'POST',
        dataType: 'json',
        input: this,
        data: data.find('input').serializeArray(),
        always: function(data, textStatus, jqXHR, options) {
          $(options.input).prop('disabled', false);
        }
      })
    },
    /**
     * This is THE gift message functionality. It is to be used with
     * ItemGiftMessage.jsp which includes some necessary inputs (in addition
     * to the inputs within the modal html) used to POST to /ManageGiftMessage.
     * @return {void}
     */
    gift_message: function() {
      var action = $(this).data('action'),
        title = action == 'edit' ? messages.CHECKOUT_DELIVERY_EditGiftMessage : messages.Shipping_Gift_Message,
        gift_container = $(this).parents('.gift-message-container'),
        orderItemId = gift_container.data('orderitem'),
        address_id = gift_container.data('addressid'),
        is_self_address = gift_container.data('selfaddress'),
        recipient_name = action == 'edit' ? gift_container.find('.recipient-name').text() : '',
        your_name = action == 'edit' ? gift_container.find('.your-name').text() : '',
        gift_message = action == 'edit' ? gift_container.find('.gift-message').text() : '';
        var gift_form_title;    	
        if($('input[name="giftMessageCondition_'+orderItemId+'"]').val() == "required_empty"){
        	gift_form_title = messages.RWD_GIFT_MSG_REQUIRED_SUBTITLE;
        }
        else{
        	gift_form_title = messages.RWD_GIFT_SUBTITLE;
        }        
      COSTCO.dialog.createExtDialogBox({
        title: title,
        body: COSTCO.util.tmpl('tmpl_gift_form', {
          orderItemId: orderItemId,
          gift_form_title: gift_form_title,
          address: gift_container.find('.address').html(),
          recipient_name: recipient_name,
          your_name: your_name,
          is_self_address: is_self_address,
          gift_message: gift_message,
          // Remove link is hidden if we're a new gift message
          hide: action == 'edit' ? '' : 'hide',
          // Used to set gift_operation on remove gift message link
          delete_op_name: '\'delete\'',
          // Get the order items that share the same address id
          // to display in the modal.
          order_items: (function() {
            var html = "";
            $('.gift-message-container[data-addressid=' + address_id + ']').each(function(i, elem) {
              var order_item = $(elem).parents('.order-item'),
                src = order_item.find('.item-thumbnail img').attr('src'),
                title = order_item.find('.product-title a').text();
              html += COSTCO.util.tmpl('tmpl_gift_order_item', {
                src: src,
                title: title
              })
            })
            return html;
          })()
        }),
        secondary: messages.JS_DIALOG_CANCEL,
        primary: messages.PRIMARYMEMBER_MEMBERSHIP__Save_ButtonText,
        // Save Gift Message
        primary_event: function() {
          if ($('#gift-message').valid()) {
            // If gift message form is valid, perform a save operation
            COSTCO.OrderItems.gift_operation.call(this, 'save');
          }
        }.bind(orderItemId)
      });
      // Templating (pre)appends whitespace in the textarea. Lets get rid of it.
      $('#giftMessage').text($('#giftMessage').text().trim());
      // Start the interactive character counting for he gift message.
      checkout_helper.character_count($('#gift-count'), $('#giftMessage'));
      //Validate the inputs before doing anything

      $('#gift-message').validate({
        focusInvalid: false,
        rules: {
          recipientName: {
            required: true,
            alphaNum: true,
          },
          fromName: {
              required: true,
              alphaNum: true,
            },
          giftMessage: {
            required: true,
            alphaNum: true
          }
        },
        messages: {
          recipientName: {
             required: messages.CHECKOUT_DELIVERY_RecipientFirstNameRequired,
             alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
          },
          fromName: {
              required: messages.CHECKOUT_DELIVERY_YourNameRequired,
              alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
          },
          giftMessage: {
            required: messages.CHECKOUT_DELIVERY_GiftMessageRequired,
             alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
          }
        },
        invalidHandler: COSTCO.util.invalid_handler
      });
    },
    /**
     * This is the version 2 of method for handling gift messages
     * It is responsible for opening gift message modal and presenting
     * all neccesary information regarding gift message,
     * for example,
     * for which item(s) if linked particular gift message,
     * on which address are those(that) item(s) sent,
     * etc.
     * @see #gift_message
     * @return {void}
     */
    gift_message_v2: function() {
        let callerElement = event.target;
        var action = $(this).data('action'),
          title = action == 'edit' ? messages.CHECKOUT_DELIVERY_EditGiftMessage : messages.Shipping_Gift_Message,
          gift_container = $(this).parents('.gift-message-container'),
          orderItemId = gift_container.data('orderitem'),
          address_id = gift_container.data('addressid'),
          is_self_address = gift_container.data('selfaddress'),
          to_recipient = action == 'edit' ? gift_container.find('.to-recipient').text() : '',
          your_name = action == 'edit' ? gift_container.find('.your-name').text() : '',
          gift_message = action == 'edit' ? gift_container.find('.gift-message').text() : '';
          var gift_form_title;
          if($('input[name="giftMessageCondition_'+orderItemId+'"]').val() == "required_empty"){
            gift_form_title = messages.RWD_GIFT_MSG_REQUIRED_SUBTITLE;
          }
          else{
	        gift_form_title = messages.RWD_GIFT_ADD_MESSAGE_MODAL_INFO;
          }
        COSTCO.dialog.createExtDialogBox({
          title: title,
          body: COSTCO.util.tmpl('tmpl_gift_form_v2', {
            orderItemId: orderItemId,
            gift_form_title: gift_form_title,
            recipient_first_title: messages.GFORM_RCP_FIRST_NAME,
            address: gift_container.find('.address').html(),
            to_recipient: to_recipient,
            your_name: your_name,
            is_self_address: is_self_address,
            gift_message: gift_message,
            // Remove link is hidden if we're a new gift message
            hide: action == 'edit' ? '' : 'hide',
            // Used to set gift_operation on remove gift message link
            delete_op_name: '\'delete\'',
            // Get the order items that share the same address id
            // to display in the modal.
            order_items: (function() {
              var html = "";
              $('.gift-message-container[data-addressid=' + address_id + ']').each(function(i, elem) {
                var order_item = $(elem).parents('.order-item'),
                  src = order_item.find('.item-thumbnail img').attr('src'),
                  title = order_item.find('.product-title a').text();
                  alt = order_item.find('.product-title').text().trim();
                html += COSTCO.util.tmpl('tmpl_gift_order_item', {
                  src: src,
                  title: title,
                  alt: alt
                })
              })
              return html;
            })()
          }),
          secondary: messages.JS_DIALOG_CANCEL,
          primary: messages.PRIMARYMEMBER_MEMBERSHIP__Save_ButtonText,
          // Save Gift Message
          primary_event: function() {
            if ($('#gift-message').valid()) {
              // If gift message form is valid, perform a save operation
              COSTCO.OrderItems.gift_operation.call(this, 'save');
            }
          }.bind(orderItemId)
        });
        // Templating (pre)appends whitespace in the textarea. Lets get rid of it.
        $('#giftMessage').text($('#giftMessage').text().trim());
        // Start the interactive character counting for he gift message.
        checkout_helper.character_count($('#gift-count-v2'), $('#giftMessage'));
        // Validate the inputs before doing anything
        $('#gift-message').validate({
          focusInvalid: false,
          rules: {
        	toRecipient: {
        		required: true,
        		alphaNum: true
        	},
        	fromName: {
        		required: true,
        		alphaNum: true
        	},
        	giftMessage: {
        		required: true,
        		alphaNum: true
        	}
          },
          messages: {
        	toRecipient: {
        		required: messages.CHECKOUT_DELIVERY_RecipientNameRequired,
        		alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
        	},
        	fromName: {
        		required: messages.CHECKOUT_DELIVERY_YourNameRequired,
        		alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
        	},
        	giftMessage: {
        		required: messages.CHECKOUT_DELIVERY_GiftMessageRequired,
        		alphaNum: messages.CHECKOUT_DELIVERY_GiftMessageValidation
        	}
          },
          invalidHandler: COSTCO.util.invalid_handler
        });
          $('#gift-message').find('.input-outline').each(function() {
              if ($(this).val().length !== 0) {
            	  $('#gift-message').find('label[for=' + $(this).attr('id') + ']').addClass('active');
              }
          });
          $('#costcoModalBtn2').removeClass('btn-primary');
          $('#costcoModalBtn2').addClass('primary-button-v2');
          $('.costcoModalBtn1').removeClass('btn-tertiary');
          $('.costcoModalBtn1').addClass('secondary-button-v2');
          COSTCO.dialog.returnFocusOnCallerElement(callerElement);
      },
    /**
     * [gift_operation description]
     * @param  {[type]} operation [description]
     * @return {[type]}           [description]
     */
    gift_operation: function(operation, orderItemId) {
      var orderItemId = typeof orderItemId === 'number' ? orderItemId : this,
        gift_container = $('.gift-message-container[data-orderitem=' + orderItemId + ']'),
        error_container = gift_container.find('.error-container');
      // Close modal
      $('.costcoModalBtn1').first().click();
      // Set the operation
      gift_container.find('input[name=op]').val(operation);
      // Get the serialized data necessary for the POST
      var data = gift_container.find('input').add('#gift-message input, #gift-message textarea')
      // Send it over the wire
      checkout_helper.ajax_update_state({
        error_container: error_container,
        method: 'POST',
        url: '/ManageGiftMessage',
        data: data.serializeArray(),
        dataType: 'json',
        always: function(){
        	COSTCO.EDDService.callEddService();
        	if((checkoutPage === 'cart' || checkoutPage === 'review')) {
    			var pickUpAPIResp = $('#pickUpAPIResponses').val();
        		if (pickUpAPIResp != undefined && pickUpAPIResp != null && pickUpAPIResp != '') {
        			COSTCO.OrderItems.repaintPickUpMolecule(JSON.parse(pickUpAPIResp), true, true);
        		}
        		COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
        	}
        }
      })
    },
    shippingSelector: '.shipping-cost[data-orderitemid="{0}"][data-shipmodeid="{1}"]',
    shipMethodSelector: '.individualShipBlock[data-orderitem="{0}"][data-shipmodeid="{1}"]', 
    reset_shipping_cost_display: function() {
      $(".shipping-cost").html("");
    },
    display_shipping_cost: function display_shipping_cost(orderItemId, shippingMethod) {
	      var shippingAmount = 0;
	      if (shippingMethod && !shippingMethod.isGroceryItem) {
	        var id = shippingMethod.id;
	        var amount = shippingMethod.amount;
	        var error = shippingMethod.error;
	        var selector = COSTCO.util.messageFormat(COSTCO.OrderItems.shippingSelector, orderItemId, id);
	        var shippingContainerColl = $(selector);

          if(shippingMethod.autoUpgradeShipModeDesc ){
            let shippingDescContainer = $('#shipMode-desc-'+orderItemId+'-'+shippingMethod.id);
            if(shippingDescContainer.length) shippingDescContainer.text(shippingMethod.autoUpgradeShipModeDesc);
          }

	        if (shippingContainerColl.length > 0) {
	          if (error != null && error > 0) {
	            COSTCO.OrderItems.display_error(orderItemId, costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE ? shippingMethod.detailedErrorMessage : shippingMethod.errorMessage);
	          } 
	          else {
	        	  var formattedQuery = COSTCO.util.messageFormat(COSTCO.OrderItems.error_query, orderItemId);
	        	  let elem;
	        	  if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	        		elem = $(formattedQuery).parents().closest("ul").find(".critical-notification");  
	        	  } else {
	        		elem = $(formattedQuery);  
	        	  }
	        	  let html = elem.html();
	        	  if(typeof(html) !== "undefined" && html.trim().length === 0){
	        		  elem.addClass('hide'); 
	        	  }
	        	  
		          let processedAmount = amount;
		          //For loop needed as warehouse pickup shipping will have the same orderItemId and shipModeId
		          //as the default ship mode [first ship mode]
	        	  for(x=0; x<shippingContainerColl.length; x++){
	        		  let shippingContainer = $(shippingContainerColl[x]);
	        		  //If warehouse pickup item shipping charge is waived then override amount to 0
	        		  if(amount == 0 || shippingContainer.data('warehousepickup') == 1) {
	        			  if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE 
	        					  && shippingContainer.hasClass('calendar-arrival')) {
	        				  shippingContainer.html(messages.RWD_INCLUDED);
	        				  $(shippingContainer).attr('id','calendar-arrival_'+ orderItemId);
	        			  } else {
	        			  shippingContainer.html(": " + messages.RWD_SHIPPING_AND_HANDLING_INCLUDED);
	        			  }
	        			  processedAmount = 0;
	        		  }
	        		  else {
	        			  shippingContainer.html(": " + COSTCO.util.formatMoney(amount, true));
	        		  }
	        		  if (shippingContainer.data('shipchecked') == true) {
	        			  shippingAmount = processedAmount;
	  	      	      }
	        	  }
	           }
	        }
	      } else if (shippingMethod && shippingMethod.isGroceryItem) {
	    	  shippingAmount = shippingMethod.amount;
	      }
	      return shippingAmount;
	    },
    error_query: costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE ? '.delivery-options[data-orderitem={0}]' : '.order-item[data-orderitemid={0}] .critical-notification',
	display_error: function(orderItemId, message) {
	  let formattedQuery = COSTCO.util.messageFormat(COSTCO.OrderItems.error_query, orderItemId);
	  let elem;
	  if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
		elem = $(formattedQuery).parents().closest("ul").find(".critical-notification");  
	  } else {
		elem = $(formattedQuery);  
	  }
	  if (elem.length == 0) {
		return;
	  }
	  let html = elem.html().trim();
	  if (html) {
		try{
		  html = html.replace(new RegExp(message, 'g') , "");
		  if(html) {
			html = html + "<br>" + message;  
		  } else {
			html = message;  
		  }
		}catch(e){    		  
		  console.log(e);
		}
	  } else {
		html = message;
	  }
	  
	  let decodedHTML = COSTCO.util.get_decoded_html(html);
	  
	  elem.html(decodedHTML).removeClass('hide');
	},
    /**
     * [update_shipmode description]
     * Call the ajax update state to re-initialize any tooltips we may have
     * @param  {[type]} shipModeId  [description]
     * @param  {[type]} orderItemId [description]
     * @param  {[type]} padDate     [description]
     * @param  {boolean} singleShipModeUpdate [this param tells ShippingCalculationCodeCalculateCmd that only this orderitem need be send to OMS for ship charge calculation]
     * @return {[type]}             [description]
     */
    update_shipmode: function(shipModeId, orderItemId, padDate, skipCallEddService) {
      var is_selected = $(this).data('checked');
      /*Check whether warehouse pickup is selected*/
      var divId = $(this).attr('id');
      var error_container = $('.error.check').length > 0 ? '.error.check' : '#errquantity_';
      if (!is_selected) { // Update the shipmode.
    	let inputContainer = undefined;
    	if(checkoutPage == 'review') {
    		$('#markShipChargeChange').val('true');
        }
        if (checkoutPage == 'cart' || (checkoutPage == 'review' && costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE)) {
  		  inputContainer = padDate ? $('input[value=' + shipModeId + ']') : $(this);
        } else {
  		  inputContainer = $('.delivery-options-selected[data-orderitem='+orderItemId+']').find('.edit')[0];
        }
        $('#pick_up_text_'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
        var delivery_options = $(this).parents('.delivery-options');
        
        var estimatedDeliveryDate = '';
        
        var deliveryCharge = $('.shipping-cost[data-shipmodeid='+shipModeId+'][data-orderitemid='+orderItemId+']').html();
        if (deliveryCharge!=null)
        	deliveryCharge = deliveryCharge.replace("$", "").replace(":","").trim();
        
       
        // if we have estimated delivery dates on the page, place them in a variable and 
        // pass them to the CostcoItemUpdateShipModeCmd so they can be written to the database
        if (typeof $(delivery_options).find('.edd-non-formatted-date_'+shipModeId+'_'+orderItemId+'')[0] !== 'undefined') {
        	estimatedDeliveryDate = $(delivery_options).find('.edd-non-formatted-date_'+shipModeId+'_'+orderItemId+'')[0].value;
        }        
        
        var page = (typeof checkoutPage !== "undefined") ? checkoutPage : 'cart';
        var hasOrderLineError = false;
        var ifAnyPickupError= false;
        let freeGiftShipMode = document.getElementsByName('freeGiftShipMode');
        let freeGiftShipModeArray = [];
        if(freeGiftShipMode !== undefined) {
            for(var i=0; i<freeGiftShipMode.length; i++) {
               freeGiftShipModeArray.push(freeGiftShipMode[i].value);
        	}
        }
        var pickUpAPIResp = '';
        var mdmAPIResp = '';
        var switchToPickUp = false;
        if(divId == 'ship-mode-radio-warehouse-pickup_'+orderItemId || divId == 'ship-mode-radio-ltl-pickup_'+orderItemId) {
        	pickUpAPIResp = $('#pickUpAPIResponses').val();
        	switchToPickUp = true;
        }
        if(divId == 'ship-mode-radio-ltl-pickup_'+orderItemId){
        mdmAPIResp = $('#mdmApiResponses').val();
        }
        checkout_helper.ajax_update_state({
          error_container: error_container,
          page: page,
          url: '/CostcoOrderItemUpdateShipModeCmd',
          method: 'POST',
          data: [{
            name: "shipModeId",
            value: shipModeId || ""
          }, {
            name: "orderItemId",
            value: orderItemId || ""
          }, {
        	name: "singleShipModeUpdate",
        	// ALM28937 setting singleShipModeUpdate as false
            value: false || ""
	      },{
	        name: "padDate",
	        value: padDate || ""
	      },{
	    	name: "estimatedDeliveryDate",
	    	value: estimatedDeliveryDate || ""
          },{
	    	name: "deliveryCharge",
	    	value: deliveryCharge || ""
          },{
            name: "freeGiftShipMode",
            value: JSON.stringify(freeGiftShipModeArray) || ""
          },{
              name: "pickUpAPIResponses",
              value: pickUpAPIResp
            },{
                name: "mdmApiResponses",
                value: mdmAPIResp
              }],
          always: function(){
        	COSTCO.Checkout.ajax_update_default_always(inputContainer);
        	COSTCO.OrderItems.tooltips();
        	COSTCO.preauthchargesmodal.init();
        	if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
        		COSTCO.OrderItems.addQuantityEventHandlers();
        		COSTCO.Global.datePickerEventHanler();
        		}
        	// Returns a focus to checked radio button
        	$('#' + inputContainer.attr('id')).parent().focus();
        	if(!skipCallEddService) {
        		COSTCO.EDDService.callEddService();
        	}
        	var pickUpAPIResp = $('#pickUpAPIResponses').val()
        	var isSwitchToDelivery = !switchToPickUp;
      	  	if(pickUpAPIResp != undefined && pickUpAPIResp != null && pickUpAPIResp != '') {
      	  		COSTCO.OrderItems.repaintPickUpMolecule(JSON.parse(pickUpAPIResp), true, true, isSwitchToDelivery, orderItemId);
      	  	}
      	  	COSTCO.OrderItems.displayGlobalPickUpAlerts(false, true);
      	  	/** if mdo pickup is selected */
      	  	if(divId == 'ship-mode-radio-ltl-pickup_'+orderItemId){
      	  		COSTCO.OrderItems.handleErrorDisplayForMdo();
      	  	}
          },
          ajax_update_post_done: function(response_obj, mergedOptions, defaultOptions) {
        	// Narvar check EDD when user changes ship mode (orderitems.js)
        	  COSTCO.Header.startEDDMutationObserver();
    	  },
    	 inputContainer: inputContainer
        });
      }
    },
    
    /** To not to display errors On Load of cart page for mdo items ALM54165*/
    handleErrorDisplayForMdo: function() {
            if ($("#contractErrContainer").length > 0 && $("#contractErrContainer").is(':visible')) {
                $("#contractErrContainer").addClass('hide');
            }
            if ($("#lineItemError").length > 0 && $("#lineItemError").is(':visible')) { 
                $("#lineItemError").addClass('hide');
        } 
    },
    
   /* To display Freight Savings On Load of cart page*/
    refreshFreightSavings: function() {
    	   let orderId = $('[name=orderId]').val();
	      return COSTCO.util.ajax({
	          method: 'POST',
	          url: '/AjaxRefreshFreightSavingsCmd',
	          dataType: 'json',
	          data: [{
	          	          name: "orderId",
	          	          value: orderId || ""
	          	        }],
	        })
	        .done(COSTCO.util.safe(function(data, textStatus, jqXHR) {
	        	OrderItems.initalloadCompleted=true;
	        	 if( data.totalFreightSavingsAjax === 'undefined' || data.totalFreightSavingsAjax === null || data.totalFreightSavingsAjax === '' || data.totalFreightSavingsAjax >=0) {
	        		 $("#totalFreightSavingsOutput").addClass('hide');
		        	 $("#freightsavingHeading").addClass('hide');
		        	 if(checkoutPage === 'cart'){
		        		 var numPrice =$("#order-estimated-total").text().replace('$', '').replace(',','');
		        		 total = COSTCO.Product.formatMoney(parseFloat(numPrice)-parseFloat(orderStatic.totalFreightSavings));
		        		 $("#order-estimated-total").text("$"+total);
		        		 $("#order-estimated-total-mobile").text("$"+total);
		        	 }else if(checkoutPage ==='review'){
		        		 var numPrice =$("#outstandingPrincipal").val().replace('$', '').replace(',','');
		        		 total = COSTCO.Product.formatMoney(parseFloat(numPrice)-parseFloat(orderStatic.totalFreightSavings));
		        		 $("#orderTotalOutput").html("$"+total);
		        		 $("#outstandingPrincipal").val(total.replace(',',''));
		        		 $("#currentOrderTotal").val(total.replace(',',''));
		        		 $("#order-estimated-total-checkout-mobile").text("$"+total);
		        	 }
		        	 orderStatic.totalFreightSavings = data.totalFreightSavingsAjax;
	        	} else if( data.totalFreightSavingsAjax != orderStatic.totalFreightSavings && checkoutPage === 'cart'){
	        		  var numPrice =$("#order-estimated-total").text().replace('$', '').replace(',','');
	        		  var freightDiff = parseFloat(data.totalFreightSavingsAjax)-parseFloat(orderStatic.totalFreightSavings);
	        		  total = COSTCO.Product.formatMoney(parseFloat(numPrice)+parseFloat(freightDiff));
	        		  $("#order-estimated-total").text("$"+total);
	        		  $("#order-estimated-total-mobile").text("$"+total);
	        		  var freightvalue ="-$"+COSTCO.Product.formatMoney(-(data.totalFreightSavingsAjax));
	        		  $("#totalFreightSavingsOutput").html(freightvalue); 
	        		  $("#totalFreightSavingsOutput").removeClass('hide');
	        		  $("#freightsavingHeading").removeClass('hide');
	        		  orderStatic.totalFreightSavings = data.totalFreightSavingsAjax;
	        	}else if(checkoutPage ==='review' && data.totalFreightSavingsAjax != orderStatic.totalFreightSavings){
	        		  var freightDiff = parseFloat(data.totalFreightSavingsAjax)-parseFloat(orderStatic.totalFreightSavings);
	        		  var numPrice =$("#outstandingPrincipal").val().replace('$', '').replace(',','');
	        		  total = COSTCO.Product.formatMoney(parseFloat(numPrice)+parseFloat(freightDiff));
	        		  $("#orderTotalOutput").html("$"+total);
	        		  $("#outstandingPrincipal").val(total.replace(',',''));
		        	  $("#currentOrderTotal").val(total.replace(',',''));
	        		  $("#order-estimated-total-checkout-mobile").text("$"+total);
	        		  var freightvalue ="-$"+COSTCO.Product.formatMoney(-(data.totalFreightSavingsAjax));
	        		  $("#totalFreightSavingsOutput").html(freightvalue); 
	        		  $("#totalFreightSavingsOutput").removeClass('hide');
	        		  $("#freightsavingHeading").removeClass('hide');
	        		  orderStatic.totalFreightSavings = data.totalFreightSavingsAjax;
	        	}
	        }), 'COSTCO.OrderItems.refreshFreightSavings')
	        // unexpected error flow
	        .fail();
  },
    /**
     * Function use to set orderitem as warehousepickup order
     * Upon success of setting the command redirect to warehouse selection
     */
    set_warehouse_pickup: function(orderItemId, shipModeId, fromPage){
    	console.log('Set order item id to '+orderItemId);
    	console.log('Set ship mode id to '+shipModeId);
    	console.log(wcs.langId);
    	
    	var redirectUrl = '/WarehousePickupLocatorView';
    	redirectUrl += '?storeId='+wcs.storeId;
    	redirectUrl += '&catalogId='+wcs.catalogId;
    	redirectUrl += '&langId='+wcs.langId;
    	redirectUrl += '&orderitemId='+orderItemId;
    	redirectUrl += '&shipModeId='+shipModeId;
    	redirectUrl += '&fromPage='+fromPage
    	redirectUrl += '&checkoutPage='+checkoutPage;
    	
    	window.location.href = redirectUrl;
    	
    },
    /**
     * [date_picker_radio description]
     * @return {[type]} [description]
     */
    date_picker_radio: function() {
      var orderItemId = $(this).parents('.delivery-option-radios').data('orderitem');
      $('input.date-input[data-orderitem=' + orderItemId + ']').trigger('click')
    },
    prescriptionDetailPopUp: function(prescriptionId,patientId) {
      var prescriptionId1 = $("input[name=" + prescriptionId + "]").val();
      $.ajax({
        url: prescriptionDetailUrl,
        dataType: 'json',
        data: {
          shopperId:patientId,
          prescriptionId: prescriptionId1
        },
        cache: false,
        success: COSTCO.OrderItems.prescriptionDetailPopUpSuccess,
        error: function(xhr, ajaxOptions, thrownError) {
          console.log(xhr + " " + ajaxOptions + " " + thrownError);
        }
      });
    },
    prescriptionDetailPopUpSuccess: function(data){
    	 let prescriptionDetail = $.parseJSON(DOMPurify.sanitize(data.prescriptionDetail));
         let centralFill = $.parseJSON(DOMPurify.sanitize(data.centralFill));
         let disableAutoRefill = DOMPurify.sanitize(data.disableAutoRefill);
         COSTCO.OrderItems.buildPrescriptionDetail(prescriptionDetail, centralFill, disableAutoRefill);
         return false;
    },
    buildPrescriptionDetail: function(details, centralFill, disableAutoRefill) {
      var DELIVERY_PREFERENCE = 'Self Checkout';
      var template = COSTCO.util.tmpl('tmpl_rx_popup_v2', {});
      $template = $(template);
      var fullName = COSTCO.util.replaceSpecialChars(details.firstName) + " " + COSTCO.util.replaceSpecialChars(details.lastName);
      $template.find("#detail-patient").html(fullName);
      $template.find("#detail-prescriptionId").html(details.rx);
      if (details.orderNumber == 0) {
        details.orderNumber = '';
      }
      $template.find("#detail-costcoOrder").html(details.orderNumber);
      $template.find("#detail-status").html(details.status);
      $template.find("#detail-medication").html(details.prescriptionName);
      $template.find("#detail-quantity").html(details.quantity);
      $template.find("#detail-refillsLeft").html(details.refillsLeft);
      var autoRefill = "NO";
      if (details.autoRefill == 1) {
        autoRefill = "YES";
      } else if (details.autoRefill == 3) {
        autoRefill = "<a href='javascript:noRefillPopup(false);'>N/A</a>";
      }
      if (disableAutoRefill == true) autoRefill = "<a href='javascript:noRefillPopup(true);'>N/A</a>";
      $template.find("#detail-autoRefill").html(autoRefill);
      $template.find("#detail-deliveryPreference").html(details.deliveryPreference);
      if (details.deliveryPreference == DELIVERY_PREFERENCE) {
        details.shipMethod = '';
      }
      $template.find("#detail-shippingOption").html(details.shipMethod);
      var physicianDetail = "";
      if (details.physicianName != "" || details.physicianCity != "" || details.physicianState != "" || details.physicianPhone != "") {
        physicianDetail = details.physicianName + ", " + details.physicianCity + ", " + details.physicianState + ", " + details.physicianPhone;
      }
      $template.find("#detail-physician").html(physicianDetail);
      var price = "";
      if (details.price != "") {
        price = "$" + details.price;
      }
      $template.find("#detail-price").html(price);
      $template.find("#detail-centralFillName").html(centralFill.name);
      $template.find("#detail-centralFillStreet").html(centralFill.street);
      var cityStZip = centralFill.city + ", " + centralFill.state + " " + centralFill.zip;
      $template.find("#detail-centralFillCityStZip").html(cityStZip);
      $template.find("#detail-centralFillPhone").html("Phone: " + centralFill.phone);
      $template.find("#detail-centralFillFax").html("Fax: " + centralFill.fax);
      options = {
        body: $template,
        title: "Prescription Details",
        primary: "OK"
      }
      COSTCO.dialog.showAndHideModal(options);
    },
    /**
     * [date_picker description]
     * @return {[type]} [description]
     */
    date_picker: function() {
      var o = COSTCO.OrderItems,
        orderItemId = $(this).data('orderitem'),
        shipModeId = $('.pad input[data-orderitem=' + orderItemId + ']').val(),
        langId = COSTCO.util.getLangId();
      // Select the PAD radio associated with the input
      $('.delivery-option-radios[data-orderitem=' + orderItemId + '] .pad input').prop('checked', true);

      // Added the below line to fix STRY0154849 Costco.com/.ca PAD date_picker inoperable after initialization
      if( $(this).hasClass('datepicker-initialized') )
            $(this).removeClass('datepicker-initialized');
    
      if (typeof o.ship_dates[orderItemId] == "undefined" || !$(this).hasClass('datepicker-initialized')) {
        COSTCO.util.ajax({
          url: '/CostcoMultiShippingCmd',
          method: 'GET',
          dataType: 'json',
          input: this,
          data: {
            listPreferredDates: true,
            shipOrderItemNum: orderItemId,
            shipModeId: shipModeId,
            shipAddressId: $(this).data('addressid')
          },
          done: function(data, textStatus, jqXHR, options) {
            if (data && data.shipDates) {
              var orderItemId = $(options.input).data('orderitem');
              o.ship_dates[orderItemId] = data.shipDates.map(function(date_str) {
                return {
                  date_obj: new Date(date_str),
                  date_str: date_str
                }
              });
              //Fixing datepicker for ADA users to pick only available shipping dates
              let enabledDates = function() {
                let availableDates= [];
                o.ship_dates[orderItemId].forEach(function(allowed_obj) {
                if (allowed_obj.date_str) {
                  let formatedDate = allowed_obj.date_obj.toJSON().split("T")[0];
                  let availableFormatedDate = formatedDate.split('-')[1] + '/' + formatedDate.split('-')[2] + '/' + formatedDate.split('-')[0];
                  availableDates.push(availableFormatedDate); 
                }
              });
              return availableDates;
              }
              $(options.input).datepicker({
                todayHighlight: true,
                autoclose: true,
                orientation: "auto right",
                format: langId == -1 || langId == -24 ? "mm/dd/yyyy" : "dd/mm/yyyy",
                language: langId == -1 || langId == -24 ? "en" : "fr",
                showOnFocus: false,
                datesEnabled: enabledDates()
              }).on('changeDate', function(e) {
                // The change event needs the date string to pass to the server.
                var date_str = "",
                  selected_date = e.date;
                this.allowed_objs.forEach(function(allowed_obj) {
                  var date_obj = allowed_obj.date_obj;
                  if (selected_date.getDate() == date_obj.getDate() && selected_date.getMonth() == date_obj.getMonth() && selected_date.getFullYear() == date_obj.getFullYear()) {
                    date_str = allowed_obj.date_str;
                    return;
                  }
                })
                COSTCO.OrderItems.update_shipmode(shipModeId, orderItemId, date_str);
              }.bind({ // Bind an object to the function's "this" context so we can reference this fields for "changeDate"
                allowed_objs: o.ship_dates[orderItemId],
                orderItemId: orderItemId,
                shipModeId: shipModeId
              }));
              $(options.input).datepicker('show');
              $(options.input).addClass('datepicker-initialized');
            }
          }
        });
      }
    },
       
    cachedAddressData: {},
    
    updateSmsPhoneForItem: function(elem, orderItemId) {
    	var smsPhone = ""; 
		
		 $( '#smsPhoneId_' + orderItemId ).bind( "click", function() {
        	$('#smsPhoneLabel_' + orderItemId).addClass('hidden');
        	$('#smsPhoneId_' + orderItemId).removeClass('error');        	
        });   
    	
    	if($('#receiveSMS_' + orderItemId).is(':checked') || $('#receiveTireNotification_' + orderItemId).is(':checked')) {
    		smsPhone = $('#smsPhoneId_' + orderItemId).cleanVal();
    		if(smsPhone.length < 10 || parseInt(smsPhone) == 0) {
    			$('#smsPhoneLabel_' + orderItemId).addClass('error');
    			$('#smsPhoneLabel_' + orderItemId).removeClass('hidden');
    			$('#smsPhoneId_' + orderItemId).addClass('error');
    			$('#smsPhoneId_' + orderItemId).focus();    			
    			return;
    		}
    		$('.smsPhoneBlock').removeClass('hidden');
    	} else {
    		$('.smsPhoneBlock').addClass('hidden');
    	}
      	
    	var data = [
    	  {
            name: "smsPhone",
            value: smsPhone || ""
          }, 
          {
            name: "orderItemId",
            value: orderItemId || ""
          }];
    	let focusedItemId = $(elem).attr('id');
    	if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE){
    		this.ajaxSmsPhoneUpdateV2(data);
    	}else{
    		this.ajaxSmsPhoneUpdate(data, focusedItemId);
    	}	
    },
    
    updateSmsPhoneForOrder: function(elem, orderId, preserveAddressData) {
    	var smsPhone = ""; 
    	if($('#receiveSMS_' + orderId).is(':checked')) {
    		$('.smsPhoneBlock').removeClass('hidden');
    		smsPhone = $('#smsPhoneId_' + orderId).cleanVal();
    		if(smsPhone.length < 10 || parseInt(smsPhone) == 0) {
    			$('#smsPhoneLabel_' + orderId).addClass('error');
    			$('#smsPhoneLabel_' + orderId).removeClass('hidden');
    			$('#smsPhoneId_' + orderId).addClass('error');
    			$('#smsPhoneId_' + orderId).focus();
    			return;
    		}
    	} else {
    		$('.smsPhoneBlock').addClass('hidden');
    		$('#smsPhoneId_' + orderId).val("");
    	}

        var data = [{
            name: "smsPhone",
            value: smsPhone || ""
          }, {
            name: "orderId",
            value: orderId || ""
          }];
        let focusedItemId = $(elem).attr('id');
        if(typeof preserveAddressData !== 'undefined' && preserveAddressData) {
        	COSTCO.OrderItems.cachedAddressData.first = $('#firstId').val()
        	COSTCO.OrderItems.cachedAddressData.last = $('#lastId').val()
        	COSTCO.OrderItems.cachedAddressData.company = $('#companyId').val()
        	COSTCO.OrderItems.cachedAddressData.line1 = $('#address1Id').val()
        	COSTCO.OrderItems.cachedAddressData.line2 = $('#address2Id').val()
        	COSTCO.OrderItems.cachedAddressData.zip = $('#postalId').val()
        	COSTCO.OrderItems.cachedAddressData.city = $('#cityId').val()
        	COSTCO.OrderItems.cachedAddressData.state = $('#stateId').val()
        	COSTCO.OrderItems.cachedAddressData.country = $('#countryId').val()
        	COSTCO.OrderItems.cachedAddressData.phone = $('#phoneId').val()
        	COSTCO.OrderItems.cachedAddressData.email = $('#emailId').val()
        	COSTCO.OrderItems.cachedAddressData.addressType = $('#save-address-inline').is(':checked') ? '' : 'T'
        	COSTCO.OrderItems.cachedAddressData.isPrimary = $('#set-default-inline').is(':checked') ? '1' : '0'	
        }
        this.ajaxSmsPhoneUpdateV2(data, focusedItemId);
    },

    /**
     * Updates Contact Information phone number for Tires
     * @param {String}	orderId The OrderId
     * @return void
     */
    updateSmsPhoneForTiresOrder: function(orderId,form,smsOptedIn) {
    	
    	let smsPhone = "";
    	let isTireOptedIn = true; 
    	
    	if(form !=null){
    		if(typeof form.id !== 'undefined' && form.id !== '' && (form.id).includes('tires-mobile-phone-input')) {    	
        		form = $("[id^='tires-mobile-phone-input']");
        		if(smsOptedIn != undefined && smsOptedIn == "true"){
        			let placeholder = "input[id=tireSmsCheckPhoneId_" + orderId + "]";
        			if($(placeholder)!= undefined && $(placeholder).prop('checked')){    				
        				smsPhone = $('#tiresSmsPhoneId_' + orderId).val();
        			}else{
        				isTireOptedIn = false;        				
        			}
        		}
        	}else if(typeof form.id!== 'undefined' && form.id!== '' &&  form.id === 'ShopCartForm') {
    			form = $("[id=ShopCartForm]");
    			smsPhone = $('#tiresSmsPhoneId_' + orderId).val();
    		} 
        	
    		if(!COSTCO.OrderSummary.smsValidator.isValid(form, "[id^=edit-tires-contact-information-phone] input[id^=tiresSmsPhoneId_]")) {
    			return;
    		}	
    	}
    				
    	let data = [{
    		name: "smsPhone",
    		value: smsPhone || ""
    	}, {
    		name: "orderId",
    		value: orderId || ""
    	}, {
    		name: "checkoutPage",
    		value: checkoutPage
    	}, {
    		name: "isTire",
    		value: true
    	},{
    		name: "isTireOptedIn",
    		value: isTireOptedIn
    	}];
    	this.ajaxSmsPhoneUpdateV2(data);
    },
    
    clearFieldForOrder: function (orderItemId, typeOfOrder) {

    	var placeholder1 = "";
    	var placeholder2 = "";
    	var placeholder3 = "";
    	var placeholder4 = ""; 

    	switch(typeOfOrder) {
    	  case 'RegularOrder':
    	    placeholder1 = "#contact-information-phone";
    	    placeholder2 = "#edit-contact-information-phone";
    	    placeholder3 = "input[id=smsPhoneId_" + orderItemId + "]";
    	    placeholder4 = "#sms-agreement-info";
    	    break;    	 
    	  case 'TiresOrder':
    		placeholder1 = "#tires-contact-information-phone";
      	    placeholder2 = "#tireSmsOptInNotification";
      	    placeholder3 = "input[id=tiresSmsPhoneId_" + orderItemId + "]";
      	    placeholder4 = "#tire-sms-agreement-info";
      	    break;  
    	  default:
    	    console.log("COSTCO - Irregular order type");
      }

      $(placeholder3).focus();

      $(placeholder3).val("");
  		let form = null;

	  	if($("[id=mobile-phone-input_"+ orderItemId +"]").length > 0) {
				form = $("[id=mobile-phone-input_"+ orderItemId +"]");
		} 


    },
   
    /**
     * this method will update sms phone on every order item from order
     * that is sms enabled
     */
    updateSmsPhoneForOrder_v2: function(orderId, smsOptedIn) {
    	
    	let smsPhone = "";
		let form = null;
		let isOptedIn = true; 
		
    	if($("[id=mobile-phone-input_"+ orderId +"]").length > 0) {
			form = $("[id=mobile-phone-input_"+ orderId +"]");
		}    	
    	
    	if(smsOptedIn != undefined && smsOptedIn == "true"){
    		if(!COSTCO.OrderSummary.smsValidator.isValid(form, "#smsPhoneId_"+ orderId)) {
    			return;
    		}
			let placeholder = "input[id=smsCheckPhoneId_" + orderId + "]";
			if($(placeholder)!= undefined && $(placeholder).prop('checked')){
				smsPhone = $('#smsPhoneId_' + orderId).val();
			}else{
				isOptedIn = false;				
			}
		}else{
			isOptedIn = false;				
		}
    	let data = [{
    		name: "smsPhone",
    		value: smsPhone || ""
    	}, {
    		name: "orderId",
    		value: orderId || ""
    	}, {
    		name: "checkoutPage",
    		value: checkoutPage
    	}, {
    		name: "isTire",
    		value: false
    	},
    	{
    		name: "isOptedIn",
    		value: isOptedIn
    	}];
		this.ajaxSmsPhoneUpdateV2(data);
    },
    /**
     * This function is used to add/update sms Phone for smsEnabled items 
     */
    updateSmsPhoneForItem_v2: function(orderItemId,orderItemIds,orderId) {
    	
    	let smsPhone = $('#smsPhoneId_' + orderItemId).val();
    	let form = null;
    	
    	if($("[id=ShopCartForm]").length > 0) {
			form = $("[id=ShopCartForm]");
		}
    	
    	if(!COSTCO.OrderSummary.smsValidator.isValid(form, "#smsPhoneId_"+ orderItemId)) {
			return;
		}
		   	
    	let data = [{
          name: "smsPhone",
          value: smsPhone || ""
        }, {
          name: "orderItemId",
          value: orderItemId || ""
        }, {
          name: "checkoutPage",
          value: 'review'
        }, {
          name: "orderItemIds",
          value: orderItemIds        
        }, {
          name: "isOptedIn",
          value: true        
        }, {
          name: "orderId",
          value: orderId || ""        
         }];
    	this.ajaxSmsPhoneUpdateV2(data);
    },
    
    ajaxSmsPhoneUpdateV2: function(data) {
      COSTCO.AjaxModular.ajax_update_state({
          url: 'CostcoOrderItemUpdateSmsPhoneCmd',
          method: 'POST',
          dataType: 'json',
          data: data,
          scrollToError: false,
          done: function(data, textStatus, jqXHR, options) {
            COSTCO.AjaxModular.ajax_update_default_done(data, textStatus, jqXHR, options);
            COSTCO.OrderItems.tooltips();
          },
          always: function(){
        	  if($(".multi-address-box").length > 0){
                  COSTCO.EDDService.callEddService();
                  COSTCO.ShippingCosts.displayTotals();
              }
          }
     });
  },
  /**
   * Method to call the AjaxLTLSelectedDeliveryDateUpdateCmd to save the selected date to DB
   */
  ajaxCalendarDataUpdate: function(data) {
	  if(data.mode=='SELECTED'){
		  var timeSlot = null;
			 for(var item of globalCalendarMap.keys()){
				 if(item.trim() === data.currentId){
					timeSlot = globalCalendarMap.get(item).get(data.dateFormatted); 
					if(null !== timeSlot && !Array.isArray(timeSlot)){
					  timeSlot = timeSlot.split();
					  data.selectedTimeSlot = timeSlot[0];
					}
					break;
				  }
			  }
			  if(undefined !== timeSlot && null !== timeSlot ){
				COSTCO.OrderItems.displayCalendarTimeSlots(timeSlot,data.orderItemId,data.dateFormatted, data.selectedTimeSlot,data.currentId); 
			  }
	  }else{
		  COSTCO.EDDService.stringifyJsonData(data);
	      
	  }
	  data.orderId = $('[name=orderId]').val();
	  COSTCO.AjaxModular.ajax_update_state({
		url: '/AjaxLTLSelectedDeliveryDateUpdateCmd',
		method: 'POST',
		data: data,
		scrollToError: false,
		done: function(textStatus, jqXHR, options) {
			if(data.mode=='SELECTED'){
					if(null !== data.listOfFulfilledOrderIds){
						var listOdIds = data.listOfFulfilledOrderIds.split(",");
			  			for(i=0;i<listOdIds.length;i++){
			  				COSTCO.EDDService.createCalendarInput(data,listOdIds[i].trim());
			  			}
					}
					
		    }
			/* following block introduced as part of kits and bundle.
			 *to display freight saving on initial load after edd sync
			 *  */
			if (costcoStoreFeatures.FEIGHTSAVINGS_FEATURE_ENABLE === true && (checkoutPage === 'cart' || checkoutPage ==='review')) {
          	  COSTCO.OrderItems.refreshFreightSavings();
            }
	    }
	});
  },
    ajaxSmsPhoneUpdate : function(data, focusItemId) {
    	$.ajax({
        	url: '/CostcoOrderItemUpdateSmsPhoneCmd',
        	method: 'POST',
        	data: data,
        	timeout: 15000
        }).done(function(smsPhoneUpdateObj){
        	 console.log('SMS phone Updated Successfully ');
        }).fail(function(smsPhoneUpdateObj) { 
            // Error Calling SMS update Service
      	  console.log('Error Updating the phone for SMS ');
        });
    },
    
    updateSetDefaultShippingAddress: function(addressId) {
    	
    	if($('#setDefault_' + addressId).is(':checked')) { 
    		$('#setDefault_' + addressId).prop('checked', false)
	        COSTCO.dialog.createExtDialogBox({
	            title: messages.JS_CHANGE_DEFAULT_ADDRESS_TITLE,
	            body: $('#tmpl_default_address_info_dialog').html(),
	            primary: messages.JS_DIALOG_ACCEPT,
	            primary_event: function() {
	            	$('#setDefault_' + addressId).prop('checked', true)
	            	$('#costcoModal').modal('hide');
	            	$("input[name='setAsDefaultShippingAddress']").map(function(){$(this).val($('#setDefault_' + addressId).is(':checked'))});
	            	COSTCO.CAddressBook.setDefault(addressId, function(){$('#setDefault_' + addressId).closest('div').addClass('hide')})
	            },
	            secondary: messages.JS_DIALOG_CANCEL,
	          });
    	} else {
    		$("input[name='setAsDefaultShippingAddress']").map(function(){$(this).val($('#setDefault_' + addressId).is(':checked'))});
    	}
    },
    
    updateSetDefaultBillingAddress: function(addressId) {
    	if($('#CheckoutPaymentForm').length){
    		$("#CheckoutPaymentForm input[name='setAsDefaultBillingAddress']").val($('#setDefault_' + addressId).is(':checked'));
    	}
    	if($('#CheckoutReviewForm').length){
    		$("#CheckoutReviewForm input[name='setAsDefaultBillingAddress']").val($('#setDefault_' + addressId).is(':checked'));
    	}
    	if($('#setDefault_' + addressId).is(':checked')) {
    		if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE === true) {
    			$('#address-block-billing').find('#setDefault_' + addressId).attr('checked', true);
    		}
    		COSTCO.CAddressBook.setDefault(addressId, function(){
    			if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
    				$('#address-block-billing').find('#setDefault_' + addressId).closest('div').addClass('hide');
    			} else {
    				$('#setDefault_' + addressId).closest('div').removeClass('hide');
    	}
    			})
    	}
    }, 
    
    initSetDefaultAddressstate: function(state) {
    	if($('input[name^=setDefault_]').length > 0) {
    		
    		$('input[name^=setDefault_]').each(function() {
    			$(this).prop('checked', state)
    			});
    	}
    	if($("input[name='setAsDefaultShippingAddress]'").length > 0) {
    		$("input[name='setAsDefaultShippingAddress']").map(function(){$(this).val(state)});
//    		$('#setAsDefaultShippingAddress').val(state)
    	}
    },
    
    changeAddress: function(addressId, addressType) {
    	
        let callerElement = event.target;
        addressLabels.edit.primaryButton = messages.EDIT_ADDRESS_SAVE_BUTTON;
        COSTCO.CAddressSelectionDialog.showAddressSelectionDialog(addressId,addressType, undefined, undefined, undefined, 'change');
        COSTCO.dialog.returnFocusOnCallerElement(callerElement);
    },
    
    /**
     * Sends an analytics event when unavailable free gift items
     * are removed due to service area restrictions.
     */
    sendAnalyticsDataRemoveUnavailableFreeGiftItems: function() {
      window.digitalDataEvents = window.digitalDataEvents || [];
      if (checkoutPage === 'cart') {
        digitalDataEvents.push({ ui: 'Shopping Cart | Item/s unavailable for service area | Remove unavailable items' });
      } else if (checkoutPage === 'review') {
        digitalDataEvents.push({ ui: 'Checkout Flow | Item/s unavailable for service area | Remove unavailable items' });
      }
    },

    removeUnavailableItems: function(isInvalidShipModeItems){
    	var formArray = $('#ShopCartForm').serializeArray();
    	var formData = {};
    	var tempData = {};
    	for (var i = 0; i < formArray.length; i++){
    		var mapKey = formArray[i]['name'];
    		if(mapKey.indexOf('orderItem') < 0 && mapKey.indexOf('catalogEntryId') < 0 
    					&& mapKey.indexOf('quantity') < 0 && mapKey.indexOf('orderItemId') < 0){
    			formData[mapKey] = formArray[i]['value'];
    		}
    		else{
    			tempData[mapKey] = formArray[i]['value'];
    		}
    	}
    	formData['actionType'] = 'delete';
    	formData['ajaxFlag'] = true;
    	
    	//STRY0182081 changes starts
    	/*
    	 *  isInvalidShipModeItems is the flag for checking to delete only invalid shipping mode items.
    	 *  This will be set only when remove unavailable link is selected from the invalid shipping mode error message.
    	 */
    	if (typeof isInvalidShipModeItems != 'undefined' && isInvalidShipModeItems && $('#isBDAppVar').val() == 'BC') {
    		 var noOfItems = $('#order-items').find('.order-item').length;
    		 var paramCount = 1;
    		 for (var i = 1; i <= noOfItems; i++) {
		          var orderItemId = $('#orderItem_'+i).val();
		          var shipmodeId = ($('#orderitem_shipmodedetails_'+orderItemId) != null)? $('#orderitem_shipmodedetails_'+orderItemId).val():null;
		          var isOrderItemShipModeListEmpty = ($('#isOrderItemShipModeListEmpty_'+orderItemId) != null)? $('#isOrderItemShipModeListEmpty_'+orderItemId).val():false;
		          //Check if the shipmodeId is undefined, then set to false and show the error message.
		          if ((shipmodeId == null ||typeof shipmodeId === 'undefined' || shipmodeId == "" || isOrderItemShipModeListEmpty)) {
		        	formData['orderItem_' + paramCount] = orderItemId;
		          	formData['catalogEntryId_' + paramCount] = $('input[name=catalogEntryId_'+i+']').val();
		          	formData['quantity_' + paramCount] = 0;
		          	paramCount++;
		          }
	        }
    	}
    	else {
	    	var errorOrderItemsCount = formData['errorOrderItemsCount'];
	    	if(errorOrderItemsCount != undefined){    		
	    		for(var i = 1; i <= errorOrderItemsCount; i++){
	    			formData['orderItem_' + i] = formData['errorOrderItemId_' + i];
	    			formData['catalogEntryId_' + i] = tempData['catalogEntryId_' + i];
	    			formData['quantity_' + i] = 0;
	    		}
	    	}
    	}
    	//STRY0182081 changes ends
    	
    	checkout_helper.ajax_update_state({
            url: '/order-quantity-update',
            method: "POST",
            data: formData,
            error_container: $('#contractErrContainer'),
            ajax_replace_content: function(response_obj, mergedOptions, defaultOptions) {
              if (response_obj.error && response_obj.error.application.indexOf('Empty Cart') == 0) {
                document.location.href = "/CheckoutCartView";
                throw new Error('No order items. Redirecting to cart.')
              }
              defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
            },
            ajax_update_post_done: function(response_obj, mergedOptions, defaultOptions) {
              // Refresh the cart icon's number to reflect the adjusted quantity.
              COSTCO.Header.miniShopCartRefresh();
              COSTCO.OrderItems.init();
        	  if(typeof COSTCO.CreditCard !== 'undefined'){
        		  COSTCO.CreditCard.initComplete = false;
        		  COSTCO.CreditCard.init();
        	  }
            },
            always: function(){
            	if($('#contractErrContainer .errorTop').length == 0){
              	  $('#contractErrContainer').addClass('hidden');
                }
    	    	if(typeof TokenGateway != 'undefined'){
    	    		TokenGateway.refreshGateway();
    	    	}	    	
            },
            done: function(data, textStatus, jqXHR, options) {
              if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE) {
                $('#notification-message .order-error').removeClass('critical-notification');
              }
              COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
            }
        });
    },
    /**
     * updateShipmodeDetails - used to handle the shipmode logic in the cart page
     */
    updateShipmodeDetails: function() {
    	let dualContract =  COSTCO.util.isCABDStore() && undefined != $('#isStorePickupSelected').val() && null != $('#isStorePickupSelected').val() && ($('#isStorePickupSelected').val() === 'true' || $('#isLocalBuisnessDelSelected').val() === 'true');
    	if((COSTCO.util.isNdEnabled() || dualContract) && (checkoutPage === 'cart') && $('input[name="deliveryMethod"]').length>0){
	    	
    		if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	    		
	    		var shipmodeId = "";
	    		try {
	    			let target = $(event.target);
	    			shipmodeId = target.val().length > 0 ? target.val() : $(target.children().first()).val();
	    		} catch(err) {
	    			shipmodeId = $("input[name='deliveryMethod']:checked").val();
	    		}
	    		
	    		shipmodeId = shipmodeId.length > 0 ? shipmodeId : $("input[name='deliveryMethod']:checked").val();
	    		
	    	} else {
	    		var shipmodeId = $("input[name='deliveryMethod']:checked").val();
	    	}
            let shipModeDescription = ($('#shipmodeDescription').val()) ? $('#shipmodeDescription').val().toUpperCase(): "";
	    	if(shipmodeId == 10101 || shipmodeId == 11608 ){
	    		$("#deldatepicker").prop('disabled', false);
	    		$('#deldatepicker').addClass('enableDate');
	    		$('.co-calendar').addClass('enableDate');
	    		var surchargeAmount = parseInt($('#freeDeliveryOrderAmount').val());
	    		var shippingCharge = parseInt($('#toolTipDeliverySurcharge').val());
	    		var currentWhsZipCode = $.cookie('WC_BD_WHS');
	    		if (shipModeDescription === "PICK-UP" || currentWhsZipCode === '729') {
		    		$('#delivery-fee .a11y-tooltip').attr("data-content", messages.MINIMUM_ORDER_AMOUNT_TOOLTIP.replace('{0}', surchargeAmount).replace('{1}', shippingCharge));
	    		} else {
		    		$('#delivery-fee .a11y-tooltip').attr("data-content", messages.HEADER_BANNER_TOOLTIP.replace('{0}', surchargeAmount).replace('{1}', shippingCharge));
	    		}
	    		
	    		var cookieDate = COSTCO.OrderItems.getCookie("deliveryDateCookie")
	    		if(cookieDate && cookieDate!="" && cookieDate!=null){
	    			$("#deldatepicker").datepicker('setDate', new Date(cookieDate));
	    		}
	    		if(costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE && !COSTCO.util.isNdEnabled()) {
	    			$("#deldatepicker").focus();
	    		}
	    	}else{
	    		$("#deldatepicker").prop('disabled', true);
	    		$('#deldatepicker').removeClass('enableDate');
	    		$('.co-calendar').removeClass('enableDate');
	    		$("#delivery-fee .a11y-tooltip").attr("data-content",messages.HEADER_BANNER_TOOLTIP_GND);
	    		if(!costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE) {
	    			$('label[for="deldatepicker"]').css("display", "none");
		    		$("#deldatepicker").val('');
	    		} else {
	    			$("#deldatepicker").val('');
	    			$('label[for="deldatepicker"]').removeClass("active");
	    			$('#deldatepicker, label[for="deldatepicker"]').removeClass("error");
	    			$('#deliveryDatePageError').html("");
	    			$('#deliveryDatePageError').css("display", "none");
	    		}
	    		$('#ShopCartForm').find('#selDeliveryDate').val('');
	    	}
	    	
            if(shipModeDescription === messages.ACTION_ORDER_PICKUP) {
            	let minimumOrderAmount = parseInt($('#minimumOrderAmount').val());
               $("#delivery-fee .a11y-tooltip").attr("data-content",messages.MINIMUM_ORDER_AMOUNT_TOOLTIP.replace('{0}', minimumOrderAmount));
            }
	    	
	    	$('#ShopCartForm').find('#shipmodeIdBD').val(shipmodeId);
	    	COSTCO.Header.miniShopCartRefresh();
	    	COSTCO.OrderItems.hideExpressCheckout();
    	}
    },
    /**
     * Function to hide express checkout button in cart page when saved payment is ACH
     * @return {void}
     */
    hideExpressCheckout:function(){
    	var paymentType=$('#savedPaymentType').val();
    	if($('#isBDAppVar').val() == 'BD' && COSTCO.util.isNdEnabled()){
            if(paymentType == 'ACH' ){
                $('.express-checkout').removeClass('hide');
                $('.toggle-checkout').removeClass('big-green');
                $('.cont-shopping').removeClass('col-md-offset-4');
            }
        }else{
            if(paymentType == 'ACH' && (COSTCO.util.isExternalCarrierShipmode())){
                $('.express-checkout').addClass('hide');
                $('.cont-shopping').addClass('col-md-offset-4');
                $('.toggle-checkout').addClass('big-green');
            }
            else if(paymentType == 'ACH' && !COSTCO.util.isExternalCarrierShipmode()){
                $('.express-checkout').removeClass('hide');
                $('.toggle-checkout').removeClass('big-green');
                $('.cont-shopping').removeClass('col-md-offset-4');
            }
        }
    },
    /**
     * dateSelected - bind the selected date 
     */
    dateSelected:function(input){
    	var deliveryDateBD = input.value;
    	$('#ShopCartForm').find('#selDeliveryDate').val(deliveryDateBD);
    },
    createAutoRenewModal : function() {
    	COSTCO.dialog.createExtDialogBox({
    		title : messages.RENEW_UPGRADE__AutoRenewHeader,
    		body : COSTCO.util.tmpl('tmpl_auto_renew_membership_modal',{}),
    		primary : messages.CLOSE
    	});
    },
    
    /**
     * This function is used to open edit block for Contact Information Phone Number for Tire product 
     * Single shipping and Multi shipping.
     */
    editContactInformationPhone: function (orderItemId, typeOfOrder,smsOptedIn) {
      
    	var placeholder1 = "";
    	var placeholder2 = "";
    	var placeholder3 = "";
    	var placeholder4 = ""; 
    	var placeholder5 = "";
    	var placeholder6 = "";
    	let form = null;
    	
    	switch(typeOfOrder) {
    	  case 'RegularOrder':
    	    placeholder1 = "#contact-information-phone";
    	    placeholder2 = "#edit-contact-information-phone";
    	    placeholder3 = "input[id=smsPhoneId_" + orderItemId + "]";
    	    placeholder4 = "#sms-agreement-info";
    	    placeholder5 = "input[id=smsCheckPhoneId_" + orderItemId + "]";
    	    placeholder6 = "#smsOptInNotification";
    	    break;
    	  case 'OrderItem':
    		placeholder1 = "#contact-information-phone-"+orderItemId;
      	    placeholder2 = "#edit-contact-information-phone-"+orderItemId;
      	    placeholder3 = "input[id=smsPhoneId_" + orderItemId + "]";
      	    placeholder4 = "#sms-agreement-info-" + orderItemId;
      	    $('#edit-contact-information-phone-' + orderItemId + ' input[id^=smsPhoneId_]').unmask().mask('000-000-0000');
    	    break;
    	  case 'TiresOrder':
    		placeholder1 = "#tires-contact-information-phone";
      	    placeholder2 = "#edit-tires-contact-information-phone";
      	    placeholder3 = "input[id=tiresSmsPhoneId_" + orderItemId + "]";
      	    placeholder4 = "#tire-sms-agreement-info";
      	    placeholder5 = "input[id=tireSmsCheckPhoneId_" + orderItemId + "]";
      	    placeholder6 = "#tireSmsOptInNotification";
      	    break;  
    	  default:
    	    console.log("COSTCO - Irregular order type");
      }

      if(smsOptedIn != undefined && smsOptedIn === "true"){
    	  if($(placeholder5).prop('checked')){	   		  
		      $(placeholder6).removeClass('hide');
		      $(placeholder4).removeClass('hide');
		      if($(placeholder3).val() === ''){
		    	  $(placeholder2 + " " + placeholder3).focus();
		      }		      
		      if(typeOfOrder === "RegularOrder" && $(placeholder3).val() !== ''){
		    	  	 this.updateSmsPhoneForOrder_v2(orderItemId, "true");
		      	 }else if(typeOfOrder == "TiresOrder" && $(placeholder3).val() !== ''){
		      		 this.updateSmsPhoneForTiresOrder(orderItemId,form,"true");
		      	 }
	    	      
	   	 }else{	   		
	   		 $(placeholder6).addClass('hide');
	      	 $(placeholder4).addClass('hide');   
	      	 if(typeOfOrder === "RegularOrder"){
	      		 this.updateSmsPhoneForOrder_v2(orderItemId, "false");
	      	 }else if(typeOfOrder == "TiresOrder"){
	      		 this.updateSmsPhoneForTiresOrder(orderItemId,form,"false");
	      	 }
	      	
	   	 } 
      }else{
        	
          $(placeholder1).addClass('hide');
          $(placeholder2).removeClass('hide');
         
          $(placeholder2 + " " + placeholder3).focus();
          $(placeholder2 + " " + placeholder3).select();
          $(placeholder4).addClass('col-lg-6'); 
      }
    },

    changeQuantityValue: function(quantity,isIncrement) {
      let quantityId = $(quantity);
      let val = quantityId.val().length > 0 ? parseInt(quantityId.val()) : '';
      let oldQtyval = quantityId.attr('value');
      let quantityStep = COSTCO.Product.getQuantityStep(quantityId);
	  
	    	if (isIncrement === true) {
	        	val += quantityStep;
	      let residual = val % quantityStep;
	      val = val - residual;
	  }
	  if (isIncrement === false)  {
		let residual = val % quantityStep;
		if(residual == 0) {
	        	val -= quantityStep;
		} else {
			val -= residual;
	        }
	      }
	  if(val < 0){
		 quantityId.val(0);
	  }
	  else{
		 quantityId.val(val);
	  }
	       
      let callbackParams = [];
  	  callbackParams.push(quantityId.attr('id'));
  	  var QtyIndex=quantityId.attr('id');
  	  var qty= $("#"+QtyIndex).val();
  	  orderItemIndex = QtyIndex.replace("quantity","");
  	  var orderItem_id=$("#orderItem"+orderItemIndex).val();
  	  if(qty==0 && $("#notSoldSeperatelyBundleId_"+ orderItem_id).val() != undefined){
  		  COSTCO.OrderItems.removeItemUsingUpdateQty(QtyIndex,orderItem_id,false,0,oldQtyval);
  	  }else{
  		 COSTCO.OrderItems.validate.call(quantity, COSTCO.OrderItems.quantity_update, 'quantity', callbackParams);
  	  }
  	 
      COSTCO.Product.expendErrorOnQtyUnit(quantityId, 'span');
  	  //COSTCO.Product.discardInvalidQtyValues(val, quantityId,isIncrement);
      if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true'  && typeof adobeProductData != 'undefined') {
    	  adobeProductData = [];
      }
      if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true' && checkoutPage == 'cart') {
	      if (typeof contextVariables != 'undefined') {
		      let partNumber = $('[data-orderitemid="'+orderItem_id+'"]').first().attr('data-orderitemnumber');
		      let adobeProductData = eval('adobeProductData'+partNumber);
		      adobeProductData.quantity = qty;
	      }
      }
    },

    /**
     * Checking if input fields are selected
     * and set attribute aria-checked with value true/false to label
     */
    checkSelectedRadioButton: function () {
      $('[name="delivery-options-radio"]').each(function() {
          if ($(this).find('input[type=radio]').is(':checked')) {
            this.setAttribute("aria-checked", "true");
          } else {
            this.setAttribute("aria-checked", "false");
          }
       });
    },
    
    /**
     * removing item using quantity update
     * update quantity happens with 0 qty, item will be removed from order
     * @param
     */
    removeItemUsingUpdateQty: function(quantityId, orderItemId, isPharmacy, prescriptionId,oldQtyval) {
    	// For protection plan items, store the related "No Plan" radio ID
    	// to restore focus after the AJAX update
    	$noPlan = $('input[id^="noPlan_"][data-dependent-order-item-id="' + orderItemId + '"]');
    	if ($noPlan.length) {
    	  COSTCO.AjaxModular.pendingFocusId = $noPlan.attr('id');
    	}
    	var itemwithSameBundleId =[];
    	var notSoldeItem =[];
    	var removeOrderitemsId =[];
    	COSTCO.OrderItems.notSoldUrl="";
    	var isNotSoldItem=$("#notSoldSeperatelyItem_"+orderItemId).val()=="true"? true:false;
    	if(undefined != $("#notSoldSeperatelyBundleId_"+orderItemId).val() && !isNotSoldItem){
    		var bundleId= $("#notSoldSeperatelyBundleId_"+orderItemId).val();
    		$('.notSoldBundil').each(function() {
    			var test=this;
    			if(bundleId== $(this).val()){
    			var OtherbundleitemIdArray=	$(this).attr('id').split("_");
    			if(undefined != OtherbundleitemIdArray[1] && null !=OtherbundleitemIdArray[1]){
    				itemwithSameBundleId.push(OtherbundleitemIdArray[1]);
    				var isNotSoledSeperatlyItem=$("#notSoldSeperatelyItem_"+OtherbundleitemIdArray[1]).val()=="true"? true:false;
    				if(isNotSoledSeperatlyItem){
    					notSoldeItem.push(OtherbundleitemIdArray[1]);
    				}
    			}
    		}
			});
    		if(itemwithSameBundleId.length !=0 && notSoldeItem.length !=0){
    			var normalItemLength =itemwithSameBundleId.length - notSoldeItem.length;
    			if(normalItemLength ==1){
    				for ( var i = 0;i < notSoldeItem.length; i++ ) {
    					removeOrderitemsId.push(notSoldeItem[i]);
    					var count=i+2;
    					var catentryId=$("#notSoldSeperateCatenId_"+notSoldeItem[i]).val();
    					COSTCO.OrderItems.notSoldUrl=COSTCO.OrderItems.notSoldUrl+"&orderItem_"+count+"="+notSoldeItem[i]+"&quantity_"+count+"=0&catalogEntryId_"+count+"="+catentryId;
    				}
    				 
    			}
    				
    		}
    	}
    	let removedOrderItemDescription = $('#product-name_'+orderItemId).find('.title-medium');
    	if(removedOrderItemDescription !== undefined && removedOrderItemDescription.html() !== undefined){
    		COSTCO.util.announceSRMessage(messages.SFL_REMOVED_FROM_THE_CART.replace('{0}', removedOrderItemDescription.html().trim()));
    	}
    	if(undefined == COSTCO.OrderItems.notSoldUrl || COSTCO.OrderItems.notSoldUrl =="" ){
    	 $('#' + quantityId).val(0);
    	 $(`input[name=${quantityId}]`).val(0);
    	}
    	 var calendarResponse = $('#calendarServiceResponse').val();
         if(calendarResponse!= undefined){
         document.getElementById("calendarServiceResponse").value ="";
         apiAlreadyCalled = undefined;
         }
         if(undefined != COSTCO.OrderItems.notSoldUrl && COSTCO.OrderItems.notSoldUrl !="" ){
        	 COSTCO.OrderItems.cartKitsBundleRemove(removeOrderitemsId,quantityId, isPharmacy, prescriptionId,oldQtyval);
         }
         if(undefined == COSTCO.OrderItems.notSoldUrl || COSTCO.OrderItems.notSoldUrl =="" ){
        	 COSTCO.OrderItems.quantity_update(quantityId, isPharmacy, prescriptionId);
         }
         if ($("[name='adobeEventsFeatureFlagFooter']").val() == 'true' && typeof adobeProductData != 'undefined') {
        	 adobeProductData = [];
         }
    	 
    },
    
    removeBaliBlindsItemsUsingUpdateQty: function(orderItemId) {
      let removedBaliBlindsItemDescription = $('#product-name_'+orderItemId).find('.title-medium');
      if(removedBaliBlindsItemDescription !== undefined && removedBaliBlindsItemDescription.html() !== undefined){
        COSTCO.util.announceSRMessage(messages.SFL_REMOVED_FROM_THE_CART.replace('{0}', removedBaliBlindsItemDescription.html().trim()));
      }
      var formArray = $('#ShopCartForm').serializeArray();
      var formData = {};
      var tempData = {};
      for (let i = 0; i < formArray.length; i++) {
        let mapKey = formArray[i]['name'];
        if (mapKey.indexOf('orderItem') < 0 && mapKey.indexOf('catalogEntryId') < 0 
          && mapKey.indexOf('quantity') < 0 && mapKey.indexOf('orderItemId') < 0 && mapKey.indexOf('isBaliBlinds') < 0) {
            formData[mapKey] = formArray[i]['value'];
        } else {
          tempData[mapKey] = formArray[i]['value'];
        }
      }
      formData['actionType'] = 'delete';
      formData['ajaxFlag'] = true;

      var noOfItems = $('#order-items').find('.order-item').length;
      var paramCount = 1;
      for (var i = 1; i <= noOfItems; i++) {
        if (tempData['isBaliBlinds_' + i]) {
          formData['orderItem_' + paramCount] = tempData['orderItem_' + i];
          formData['catalogEntryId_' + paramCount] = tempData['catalogEntryId_' + i];
          formData['quantity_' + paramCount] = 0;
          paramCount++;
        }
      }

      checkout_helper.ajax_update_state ({
        url: '/order-quantity-update',
        method: "POST",
        data: formData,
        page: (typeof checkoutPage === "undefined") ? "" : checkoutPage,
        error_container: $('#contractErrContainer'),
        done: function(data, textStatus, jqXHR, options) {
          try {
            let response_obj = typeof(data) === 'object' ? data : JSON.parse(data);
            if (response_obj.error && response_obj.error.application.indexOf(messages.EMPTY_CART)== 0) {
              document.location.href = "/CheckoutCartView";
            } else {
              COSTCO.Checkout.ajax_update_default_done(data, textStatus, jqXHR, options);
            }
          } catch (e) {
            console.error(e);
          }
        },
        ajax_replace_content: function(response_obj, mergedOptions, defaultOptions) {
          if (response_obj.metadata && response_obj.metadata.quantityUpdatedForCashCardPaymentErr) {
            response_obj.error.application.push(response_obj.metadata.quantityUpdatedForCashCardPaymentErr);
            $('#single-page-checkout #cc-payment-block').attr('do-not-show',false);
          }
          defaultOptions.ajax_replace_content(response_obj, mergedOptions, defaultOptions);
        },
        ajax_update_post_done: function(response_obj, mergedOptions, defaultOptions) {
          // Refresh the cart icon's number to reflect the adjusted quantity.
          COSTCO.Header.miniShopCartRefresh();
          $('#ShopCartForm input[name=ajaxFlag]').val(false);
          COSTCO.OrderItems.init();
          if (typeof COSTCO.CreditCard !== 'undefined') {
            COSTCO.CreditCard.initComplete = false;
            COSTCO.CreditCard.init();
          }

          // add ada message, after the quantity is updated
          let  estimatedTotalLabel;

          if (costcoStoreFeatures.WEBSITE_REDESIGN_V2_CART_FEATURE_ENABLE === true) {
            estimatedTotalLabel = $('.estimated-total-label');
            if (!COSTCO.util.isBusinessDelivery()){
              COSTCO.OrderItems.setDeliveryDateView();
            }
          } else {
            estimatedTotalLabel = $('#estimated-total-label');
          }

          let estimatedTotalValue = costcoStoreFeatures.WEBSITE_REDESIGN_V2_CHECKOUT_FEATURE_ENABLE && checkoutPage === 'review' ? $('.surchargeOrderTotal') : $('#order-estimated-total');  
          if (estimatedTotalLabel.length > 0 && estimatedTotalValue.length > 0) {
            checkout_helper.addScreenReaderAnnouncement(estimatedTotalLabel.html() + ' ' + estimatedTotalValue.html());
          }
        },
        always: function() {
          COSTCO.Checkout.ajax_update_default_always();
          if (typeof TokenGateway != 'undefined') {
            TokenGateway.refreshGateway();
          }
          COSTCO.OrderItems.popovers();
        },
      });
    },
    
    changeProtectionPlanQuantityValue: function(quantityId, isIncrement) {
		
    	var value = $(quantityId).val();
    	if (isIncrement === true) {
    		value++;
		}
		else {
			value--;
		}
		
    	COSTCO.OrderItems.validateProtectionPlanQuantity(quantityId, value);
	},
	
	validateProtectionPlanQuantity: function(quantityId, value) {
		
		var errorPlacement = function(error, element){
			error.insertAfter($(element).parent());
		}
    	
		COSTCO.OrderItems.validate.call($(quantityId), COSTCO.OrderItems.updateProtectionPlanQuantity(quantityId, value), 'protectionPlanQuantity', errorPlacement);
	},
	
	updateProtectionPlanQuantity: function(quantityId, value) {
		
		let parentOrderItemQty = $(quantityId).closest('.order-item').find('input[id^="quantity_"]').val();
		let parentOrderItemQtyNumber = parseInt(parentOrderItemQty);
		
		if(value <= parentOrderItemQtyNumber && value > 0) {
			$(quantityId).val(value);
		}else {
			$(quantityId).val(1);
		}
	},

  toggleAgeRestrictionDeliveryTermsCheckbox: function (nameOfRestriction) {
    let orderId = $('[name=orderId]').val();
    let checkmarkObject = nameOfRestriction === 'ALCOHOL_RESTRICTION' ? $('#alcoholTerms') : $('#tobaccoTerms') ;
    let checkmark = checkmarkObject.is(':checked');
    let name = nameOfRestriction;

    let data = [{
      name: "orderId",
      value: orderId || ""
    }, {
      name: "checkmark",
      value: checkmark
    }, {
      name: "name",
      value: name
    }];

    $.ajax({
      url: '/AjaxAgeRestrictionDeliveryTermsCheckCmd',
      method: 'POST',
      data: data,
      timeout: 150000
    }).done(function() {
      console.log('Age Restriction Checkbox Updated Successfully ');
    }).fail(function() {
      console.log('Error Updating Age Restriction Checkbox ');
    });
  },
  
  /**
   * [date_picker_scheduler description]
   * @return {[type]} [description]
   */
  date_picker_scheduler: function(shipModeId) {
    var orderItems = COSTCO.OrderItems,
    langId = COSTCO.util.getLangId();
    var shipCode = $(this).data('shipcode');
    $('.delivery-option-radios[data-orderitem=' + orderItemId + '] .pad input').prop('checked', true);
    
    if( $(this).hasClass('datepicker-initialized') )
          $(this).removeClass('datepicker-initialized');
  
    if (typeof orderItems.ship_dates[orderItemId] == "undefined" || !$(this).hasClass('datepicker-initialized')) {
    	var dateList = $(this).data('datelist').replace(/^\[(.+)\]$/,'$1').split(',');
    	var shipDates=[];
    	for(i=0;i<dateList.length;i++){
    		shipDates[i] = COSTCO.util.convertDateToTimestamp(dateList[i]);
    	}
    		var commonDate = $(this).data('commondate').split('-'); 
            var orderItemId = $(this).data('orderitem');
            var currentId = "scheduler_picker_"+orderItemId+"_"+shipModeId+"_"+shipCode;
            orderItems.ship_dates[orderItemId] = shipDates.map(function(date_str) {
              return {
                date_obj: new Date(date_str),
                date_str: date_str
              }
            });
            
            
            
            //Fixing datepicker for ADA users to pick only available  dates
            let enabledDates = function() {
              let availableDates= [];
              orderItems.ship_dates[orderItemId].forEach(function(allowed_obj) {
              if (allowed_obj.date_str) {
            	let date =new Date(allowed_obj.date_obj);
            	let timeZoneCorrectDate = new Date(date.getTime() + (date.getTimezoneOffset() * 60000));
            	// East of GMT
	    	   	if (date.getTimezoneOffset() < 0) {
	    	   		timeZoneCorrectDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000));
            	}
                let formattedDate = timeZoneCorrectDate.toJSON().split("T")[0];
                let availableFormattedDate = formattedDate.split('-')[1] + '/' + formattedDate.split('-')[2] + '/' + formattedDate.split('-')[0];
                availableDates.push(availableFormattedDate); 
              }
            });
            return availableDates;
            }
            
            
            if(COSTCO.util.isCAStore() && langId === "-25" && null !== document.getElementById('for-Canada_'+currentId)){
            	var selectedDate = $(this).data('selecteddate');
            	var dateInDisplay = $(this).data('datetodisplay');
            	if(undefined!== selectedDate && selectedDate !== ""){
            		commonDate = selectedDate.split('-');
            	}
	            document.getElementById(currentId).setAttribute("value", "");
	            var labelElement = document.getElementById('for-Canada_'+currentId);
	            labelElement.innerHTML = dateInDisplay;
	            $('#for-Canada_'+currentId).removeClass('hidden');
            }
            $("#scheduler_picker_"+orderItemId+"_"+shipModeId+"_"+shipCode).datepicker({
              autoclose: true,
              defaultViewDate: {year:commonDate[0], month:commonDate[1]-1, day:commonDate[2]},
              orientation: "auto right",
              format: wcs.langId === '-25' ? 'DD. d MM, yyyy' : 'DD, MM d, yyyy',
              language: wcs.langId === '-25' ? 'fr' : 'en',
              showOnFocus: false,
              datesEnabled: enabledDates()
            }).on('changeDate', function(e) {
            	var full_date=e.date;
         	   let dateVal = full_date.getDate();
	            let month = full_date.getMonth()+1;
	            let year = full_date.getFullYear();
	            let day = full_date.getDay();
	            let formatMonth = month < 10 ? '0' + month : month;
	            let formatDay = dateVal < 10 ? '0' + dateVal : dateVal;
	            var dateFormatted = year+'-'+formatMonth+'-'+formatDay;
            	 var shipCode = $(this).data('shipcode');
            	 var orderItemId = $(this).data('orderitem');
            	 var dateList = $(this).data('datelist').replace(/^\[(.+)\]$/,'$1').split(',');
            	 var item='scheduler_picker_'+orderItemId+"_"+shipModeId+"_"+shipCode;
            	 if(!dateList.includes(dateFormatted)){
            	 $('#' + item.trim() + '_dateError').removeClass('hidden');
           	     $('#' + item.trim()).addClass('error');
                 $('#' + item.trim() + '_labelAlign').addClass('cart-calendar-label');
                 $('#scheduledDeliveryDateInvalid').val(true);
                 $('.calendar-label-active-field').addClass('hidden');
            	 }else{
            	$('.calendar-label-active-field').addClass('hidden');
  			    $('.cart-calender-label-align').removeClass('hidden');
  			    $('.date-input-field').removeClass("error");
  			    $('.select-delivery-date').addClass("hidden");
  			    $('#noDeliveryDate').val(false);
  			    $('.error-date-availability').addClass('hidden');
  			    $('.cart-calender-label-align').removeClass('cart-calendar-label');
  			    $('#scheduledDeliveryDateInvalid').val(false);
  			    if($(this).data('timeslot') !== ""){
  			    	$('#'+currentId+'_timeslot').removeClass('hidden');
  			    }
              // The change event needs the date string to pass to the server.
            
                var date_str = "",
                  selected_date = e.currentTarget.value;
                var requiredKeys = $('#orderitemAndShipModeList').val();
                if(COSTCO.util.isCAStore() && langId === "-25"){
                	 document.getElementById(currentId).setAttribute('data-selecteddate', dateFormatted);
                	 document.getElementById(currentId).setAttribute('data-datetodisplay',COSTCO.EDDService.getDateFormattedToDisplay(dateFormatted));
                }
              let data = {
            	  selectedMonth : month,
            	  selectedDay : day,
            	  selectedYear : year,
            	  selectedTimeSlot : $(this).data('timeslot'),
            	  selectedDate : dateVal,
                  selectedDeliveryDate : selected_date,
                  orderItemId: orderItemId,
                  listOfEddorderItems: $('#listOfEddItems').val(),
                  currentPage: checkoutPage,
                  requiredKeys : requiredKeys,
                  currentId :currentId,
                  dateFormatted :dateFormatted,
                  listOfFulfilledOrderIds : $(this).data('fulfilledorders'),
                  mode :'SELECTED'
                };
              
              //Ajax call to update the user selected date against all items and repaint the content to cart/review page
            	  COSTCO.OrderItems.ajaxCalendarDataUpdate(data);
            } }
            
            );
            $("#scheduler_picker_"+orderItemId+"_"+shipModeId+"_"+shipCode).datepicker('show');
            $("#scheduler_picker_"+orderItemId+"_"+shipModeId+"_"+shipCode).addClass('datepicker-initialized');
    }
  },
  /**
   * Method to get the selected date and timeslot and call the ajax to save this to DB
   */
  saveSelectedDate: function () {
	  
	  $('.calendar-time-slot-error').addClass('hidden');
	  $('#scheduledDeliveryDateInvalid').val(false);
	  $('.time-slot-span').removeClass('time-slot-span-border')
	  var date;
	  if(undefined !== $(this).data('selecteddate')){
		  date = $(this).data('selecteddate').split('-');
	  }
	  let selectedYear = date[0];
	  let selectedDate = date[2];
	  let selectedMonth = date[1];
	  let data = {
              selectedMonth : selectedMonth,
        	  selectedYear : selectedYear,
        	  selectedTimeSlot : $('input[name="userTimeSlot"]:checked').val(),
        	  selectedDate : selectedDate,
              selectedDeliveryDate : $(this).data('selecteddate'),
              orderItemId: $(this).data('orderitem'),
              listOfEddorderItems: $('#listOfEddItems').val(),
              listOfFulfilledOrderIds : $(this).data('fulfilledorders'),
              currentPage: checkoutPage
            };
	  COSTCO.OrderItems.ajaxCalendarDataUpdate(data);
  },
  
  populateMeasurementGuidesCheckboxes: function() {
  	let array = [];
  	array = JSON.parse(sessionStorage.getItem('measurementCheckboxes'));
  	
  	$(array).each(function(i, obj) {
  		$('.'+obj.id).prop('checked', obj.checked);
  	});
  },
  
  saveMeasurementGuidesCheckboxesStates: function() {
  	let measurmentCheckboxs = [];
	    $('input[id^="measuring-guides-checkbox-"]').each(function(i,value) {

		        var measurmentCheckbox = new Object();
		        measurmentCheckbox.id = value.id;            
		        measurmentCheckbox.checked = value.checked;
		        measurmentCheckboxs.push(measurmentCheckbox);
		    
	    });
        if(measurmentCheckboxs.length != 0){
            sessionStorage.setItem('measurementCheckboxes', JSON.stringify(measurmentCheckboxs));
        }
  },
  
  /**
   * Measurement Guidelines
   */
  validateMeasurementGuidesEligibility: function() {
  	let isValid = true;
  	$("#ShopCartForm .measuring-guides-checkbox").each(function() {
  		let isValidEachInput = $(this).is(":checked");
  		if(isValidEachInput) {
  			OrderItems.unhighlightMeasuringError(this);
  		} else {
  			isValid = false;
  			OrderItems.highlightMeasuringError(this);
  		} 
  	});
  	
  	return isValid;
  }, 
  
  highlightMeasuringError: function(element) {
    $(element).closest('.measuring-guides-warning').removeClass('warning').addClass('critical-notification').css('margin-bottom', '5px');
    $(element).attr('aria-invalid', 'true');
    $(element).trigger("focus");
    $(element).closest('.measuring-guides-container').find('#' + element.id + '-error').remove();
    $(element).closest('.measuring-guides-container').append('<div id="' + element.id + '-error" class="error" role="alert">' + messages.MEASUREMENT_GUIDES_CHECK_ERROR + '</label>');
    $('#' + element.id + '-error').css({ 'font-size': '14px', 'font-weight': '700' });
    $(element)[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
    
  },
  
  unhighlightMeasuringError: function(element) {
    $(element).attr('aria-invalid', 'false');
	  $(element).closest('.measuring-guides-warning').removeClass('critical-notification').addClass('warning').css('margin-bottom','5px');
	  $(element).closest('.measuring-guides-container').find('#' + element.id + '-error').remove();
  },
  
  disableShipMethodCode:function(element) {
	  $(element).hide();
  },
  
  selectCorrectShipMode : function(orderItemId,element) {
	 var selectShipMode = COSTCO.util.messageFormat(COSTCO.OrderItems.shipMethodSelector, orderItemId, element.shipModeId);
	 let checkboxSelection = $(selectShipMode).find("INPUT.shipModeId")[0];
	 let shipModeToSelect = $(selectShipMode);
	 $(checkboxSelection).prop("checked",true);
	 let elemOrderItem = $(shipModeToSelect).attr("data-orderitem");
	 COSTCO.OrderItems.update_shipmode.call($(shipModeToSelect), $(shipModeToSelect).attr("data-shipmodeid"), elemOrderItem, undefined, true);
  },
  
  //refresh header with new delivery method eligible items
  refreshHeader: function(userSelectionDeliveryMethod) {

	userSelectionDeliveryMethod = userSelectionDeliveryMethod.charAt(0).toUpperCase() + userSelectionDeliveryMethod.slice(1);
	  
	let makeAjaxCall = true;
	let currentDeliveryMethod = $('#bdaddrtype').text();
	if (currentDeliveryMethod.includes(userSelectionDeliveryMethod)) {
		makeAjaxCall = false;
	}
	if (makeAjaxCall) {
		let postData = [{
	         name: "storeId",
	         value: wcs.storeId || ""
	         }, {
	         name: "catalogId",
	         value: wcs.catalogId || ""
	         }, {
		     name: "langId",
		     value: wcs.langId || ""
	         }, {
	         name: "zipCodeFormDeliveryZipCode",
	         value: $.cookie('WC_BD_ZIP') || ""
	         }, {
	         name: "currentZipCode",
	         value: $.cookie('WC_BD_ZIP') || ""
	         }, {
	         name: "userSelectionDeliveryMethod",
	         value: userSelectionDeliveryMethod || ""
	         }, {
	         name: "checkoutPage",
	         value: "cart"
	         },{
		     name: "isInitiatedFromChangeAddressType",
		     value: "true"
		     },
	         ];
	     $.ajax(
	     {
	       url: '/AjaxBusinessDeliveryBrowse',
	       type: 'POST',
	       data: postData,
	       dataType: 'json',
	       success: function(data, textStatus, xhr) {
	         if (data.errorCode) {
	           if (data.errorCode == 2510) {// session timeout
	             document.location.href = 'Logoff?URL=ReLogonFormView&storeId='+wcs.storeId;
	             return;
	           }
	         } else {
	           // BD only: Update WC_BD_LOC cookie if ZIP is set/changed
	           if (COSTCO.util.isBusinessDelivery() && data.zipCodeBDCookieSet) {
	             if ($('#isGeocodeService').val() != "true") {
	            	 COSTCO.util.callBingAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	             } else {
	               COSTCO.util.callGeocodeApiAndUpdateBDLocationCookie($.cookie('WC_BD_ZIP'));
	             }
	             window.location.href = "/CheckoutCartView";
	           }
	         } 
	       },
	       error: function(xhr, textStatus, errorThrown) {
	    	 COSTCO.zipCodeModal.ajaxCallErrorLog(xhr,textStatus, errorThrown, true);
	       },
	     });	
   
	}
	
  },
  	/**
  	 * This method is called from JSP when shipmode swiches to pickup. Fetches OMS inventory, calls wcs to update the latest data into DB. 
  	 * @param - ordItemId
  	 * @param - isSwitchToPickUp
  	 */
  	updateShipModeToPickUp: function(isSwitchToPickUp) {
		try {
			if(checkoutPage === 'cart' || checkoutPage === 'review'){
				var requestJson = $('#pickUpRequestJson').val();
				if (requestJson !== undefined && null !== requestJson && requestJson.length > 0) {
					var costcoEnv = $('#costcoEnvironmentForEDD').val();
			        if (costcoEnv == "") {
			            costcoEnv = 'ECOM';
			        } else if (costcoEnv == "DEV") {
			            costcoEnv = 'QA3';
			        }
			        var clientIdentifier=$('#apigeeClientIdentifierHeader').val();
			        var costcoService="restInventory";
			        
			        var apiHeader = {
			    		"costco.env": costcoEnv,
		                "client-identifier" : clientIdentifier,
		                "costco.service" : costcoService
			    	};
					var requestJsonList = JSON.parse(decodeURIComponent(requestJson));
					var hasPickUpServiceError = false;
			        var pickUpApi = $('#pickUpAPIURL').val();
			        var respJson;
			        let requestObj = {};
			        for (var i=0; i<requestJsonList.length; i++) {
			        	var reqparams = requestJsonList[i];
			        	if(reqparams != undefined && reqparams != null && reqparams != '' && (reqparams.itemAddedForPickUp || isSwitchToPickUp) || (reqparams.ltlFeatureFlag && (reqparams.ltlpickupfrompdp || reqparams.ltlPickUpOnlyItem || (reqparams.ltlPickUpItem && !reqparams.whsEnabled)))) {
			        		if(!reqparams.siteControlledOnlyItem || reqparams.eddItem) {
			        			/** Call PickUp API If Item is UseWarehouseInevntory or ShipToWarehouse tagged LocationControlled or Edd Enabled */
				        		var pickUpUrl = pickUpApi + "/" + reqparams.partNumber+"?quantity="+reqparams.quantity+"&selectedWarehouse="+reqparams.selectedWarehouse+
				        	    						"&shippingCodes="+ reqparams.shipCode+"&action="+reqparams.action;
				        		respJson = COSTCO.OrderItems.invokePickUpAPI(pickUpUrl, apiHeader);
				        		if(respJson != undefined && respJson != null && respJson != '') {
				        			respJson.siteInventory = reqparams.siteInventory;
				        			respJson.siteControlledOnlyItem = reqparams.siteControlledOnlyItem;
				        			respJson.locationControlledItem = reqparams.locationControlledItem;
				        			respJson.shipToWarehouseItem = reqparams.shipToWarehouseItem;
				        			respJson.quantity = reqparams.quantity;
				        			respJson.ltlpickupfrompdp = reqparams.ltlpickupfrompdp;
				        			requestObj['orderItemId_'+reqparams.orderItemId] = respJson;
				        		} else if(!hasPickUpServiceError){
				        			/** Display PickUp Unavailable API Service error when API response is blank */
				        			hasPickUpServiceError = true;
				        			$('#pickUp-unAvailable-'+reqparams.orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW_UNAVAILABLE);
				        			$('#pickUp-tooltip-'+reqparams.orderItemId).html('');
				        			$('#pickUp-memberOnly-'+reqparams.orderItemId).html('');
				        			$('#mdo-pickUp-memberOnly-'+reqparams.orderItemId).html('');
				        			$('#mdo-pickUp-memberOnly-'+reqparams.orderItemId).html('');
				        			$('#ship-mode-radio-warehouse-pickup_'+reqparams.orderItemId).parent().find('input[type=radio]').attr('disabled', true);
				        			$('#ship-mode-radio-warehouse-pickup_'+reqparams.orderItemId).parent().find('input[type=radio]').removeAttr('checked');
				        			$('#ship-mode-radio-ltl-pickup_'+reqparams.orderItemId).parent().find('input[type=radio]').removeAttr('checked');
				        			$('#ship-mode-radio-ltl-pickup_'+reqparams.orderItemId).parent().find('input[type=radio]').attr('disabled', true);
				        		}
			        		} else {
			        			/** Setting required data to render PickUp molecule for Site controlled only item with out EDD */
			        			respJson = {
			        				"itemNumber":reqparams.partNumber,
			        				"quantity":reqparams.quantity,
			        				"eddItem":reqparams.eddItem,
				        			"siteControlledOnlyItem":reqparams.siteControlledOnlyItem,
				        			"locationControlledItem":reqparams.locationControlledItem,
				        			"siteInventory":reqparams.siteInventory,
				        			"shipToWarehouseItem":reqparams.shipToWarehouseItem
			        			};
			        			requestObj['siteControlled_'+reqparams.orderItemId] = respJson;
			        		}
			        	}
			        }
			        
			        if(requestObj != undefined && requestObj != null) {
			        	/** Set PickUp API response and other WCS attributes to hidden for using it during shipmode switch. */
		        		$('#pickUpAPIResponses').val(JSON.stringify(requestObj));
			        	if(!isSwitchToPickUp) {
			        		/** Calling functions to display pickUp molecule and call AjaxPickUpWarehouseUpdateCmd */
			        		COSTCO.OrderItems.repaintPickUpMolecule(requestObj, isSwitchToPickUp, false);
			        		COSTCO.OrderItems.callWarehousePickUpCmd(requestObj, hasPickUpServiceError);
			        	}
			        }
			        if(!isSwitchToPickUp) {
			        	/** Display global alerts and errors */
			        	COSTCO.OrderItems.displayGlobalPickUpAlerts(hasPickUpServiceError, isSwitchToPickUp);
			        }
				}
			}
		} catch(err) {
			console.log('Apigee Responses Exception Occured Due to '+err);
		}
	},
	
	/**
	 * Invokes Pickup API
	 */
	invokePickUpAPI: function(pickUpUrl, apiHeader) {
		var responseJson;
		try {
			$.ajax({
	    		url: pickUpUrl,
	            type: 'GET',
	            headers: apiHeader,
	            dataType: 'json',
	            async:false,
	            success: function (data) {
	            	responseJson = data;
	            },
	            error: function (data) {
	            	responseJson = data;
	            }
	        });
		} catch (e) {
    		console.error(e);
    	}
		return responseJson;
	},

	/**
	 * Invokes MDM API
	 */
	invokeMdmAPI: function(clientIdentifier, ltlPickupLocValue) {
		var mdmApiURL = $('#mdoMdmApiFrontend').val();
		var apiHeader = {
	    		"client-identifier": clientIdentifier
	    	};
		var constructURL = mdmApiURL + "/" +ltlPickupLocValue+".json";
		var responseJson;
		 try {
			$.ajax({
	    		url: constructURL,
	            type: 'GET',
	            headers: apiHeader,
	            dataType: 'json',
	            async:false,
	            success: function (data) {
	            	responseJson = data;
	            if(data && $.isEmptyObject(data)){
	            	responseJson = false
	            }
	            },
	            error: function (data) {
	            	responseJson = false;
	            }
	        }); 
		} catch (e) {
    		console.error(e);
    	}
		
		return responseJson;
	},
	
	/**
	 * Parse Hours and Holidays MDM API Response 
	 */
	parseMdmApiHoursAndHolidays: function(responseJson, orderItemId, isltlPickupItemSelected) {
		let doNotshowPickupHours = false;
		var pickupMdmHoursMixedCart;
	    if(checkoutPage === 'review'){
	    	if ($(".mdo-mixed-cart").is(':visible')) {
		    	pickupMdmHoursMixedCart = $("#show-mdoApi-pickUp-hours-"+orderItemId+"mixedCart");
		    	pickupMdmHoursMixedCart.empty();
		    	doNotshowPickupHours = true;
	    	}
	    }
	    // Check if mdoLocation is present
	    if (responseJson.mdoLocation) {
	    	// Check if name is present
	    	if (responseJson.mdoLocation.name) {
	    			COSTCO.OrderItems.formatAddress(responseJson);
	    		}
	        // Check if hours are present
	    	var pickupMdmHours = $("#show-mdoApi-pickUp-hours-"+orderItemId);
	       if (responseJson.mdoLocation.hours != null && responseJson.mdoLocation.hours != undefined && responseJson.mdoLocation.hours.length > 0 ) {
	     	    pickupMdmHours.empty();
	            responseJson.mdoLocation.hours.forEach(function(entry) {
	                let title = entry.title[0].value;
	                let openTime = entry.open ? COSTCO.OrderItems.formatTime(entry.open) : "Closed";
	                let closeTime = entry.close ? COSTCO.OrderItems.formatTime(entry.close) : "";
	                var showPickupMdmHours;
	                if (entry.hoursType.code === "open" && openTime && closeTime) {
	                    showPickupMdmHours = title + " " + openTime + " to " + closeTime;
	                } else if (entry.hoursType.code === "closed") {
	                    showPickupMdmHours = title + " Closed";
	                }
	                else if (entry.hoursType.code === "close" && openTime && closeTime) {
	                    showPickupMdmHours = title + " Closed";
	                }
	                // Append a new <span> with the text content to the container
	                if (showPickupMdmHours) {
						// Create a new <span> element
	                    var createWorkDaysSpan = $("<span style = 'color: #5F5F5F; font-size: 12px;font-style: normal;font-weight: 400;line-height: 20px;'></span>").text(showPickupMdmHours); 
	                  if(doNotshowPickupHours == true && doNotshowPickupHours != undefined){ 
	                	if(pickupMdmHoursMixedCart !== undefined){
	                		  pickupMdmHoursMixedCart.append(createWorkDaysSpan);
	                		if(isltlPickupItemSelected){
	                			$("#show-mdoApi-pickUp-hours-label-"+orderItemId).empty();
		                  	}
	                	  }
	                  	if(!isltlPickupItemSelected){
	                  			pickupMdmHours.append(createWorkDaysSpan.clone());
	                  		}
	                  }
	                  else{
	                	  	pickupMdmHours.append(createWorkDaysSpan);
	                	}
	                }
	            });
	        }
	       /** Show Fallback When MDM API is down  */
	        else if(responseJson.mdoLocation.hours == null || responseJson.mdoLocation.hours == undefined || responseJson.mdoLocation.hours.length == 0 ) {
	        	$('#mdmFailHoursText-'+orderItemId).removeClass('hidden');
		        $('#mdm-edd-fails-'+orderItemId).removeClass('hidden');
	        }
	        
	        // Check if holidays are present
	        if (responseJson.mdoLocation.holidays) {
	            responseJson.mdoLocation.holidays.forEach(function(holiday) {
	                let holidayName = holiday.name[0].value;
	                let holidayHoursType = holiday.holidayHoursType.code;
	                let holidayopenTime = holiday.hour && holiday.hour.open ? COSTCO.OrderItems.formatTime(holiday.hour.open) : "";
	                let holidaycloseTime = holiday.hour && holiday.hour.close ? COSTCO.OrderItems.formatTime(holiday.hour.close) : "";
	                let showPickupMdmHours
	                if(holidayHoursType === "closed") {
	                	showHolidayPickupMdmHours = holidayName + " Closed";
	                }
	                else if(holidayopenTime != "" && holidaycloseTime != ""){
	                	showHolidayPickupMdmHours = holidayName + " " + " " + holidayopenTime + " to " + holidaycloseTime;
	                }
	                else if(holidayHoursType === "open"){
	                	showHolidayPickupMdmHours = holidayName + " Open";
	                }
	                // Append a new <span>
	                var createHolidayDaysSpan = $("<span style = 'color: #5F5F5F; font-size: 12px;font-style: normal;font-weight: 400;line-height: 20px;'></span>").text(showHolidayPickupMdmHours);
	                if(doNotshowPickupHours == true && doNotshowPickupHours != undefined){ 
	                	if(pickupMdmHoursMixedCart !== undefined){
	                		pickupMdmHoursMixedCart.append(createHolidayDaysSpan);
	                		$("#show-mdoApi-pickUp-hours-label-"+orderItemId).empty();
	                	}
		                 if(!isltlPickupItemSelected){
		                  		pickupMdmHours.append(createHolidayDaysSpan.clone());
		                  		$("#show-mdoApi-pickUp-hours-label-"+orderItemId).html(messages.ORD_MARKET_DISTRIBUTION_MDO_HOURS);
		                  }
		              }
		              else{
		                	  pickupMdmHours.append(createHolidayDaysSpan);
		               }
	                
	            });
	        }
	    } else {
	        console.log("mdoLocation is not present in the response.");
	    }
	},
	/**
	 * Format time from MDM API into 12 hours clock
	 */
	formatTime: function(mdmapitime) {
	    const [hours, minutes] = mdmapitime.split(":");
	    let hoursInt = parseInt(hours);
	    const period = hoursInt >= 12 ? "PM" : "AM";
	    hoursInt = hoursInt % 12 || 12;
	    let formatedTime = hoursInt+':'+minutes+period
	    return formatedTime;
	},
	/**
	 * Format Adress from MDM API
	 */
	formatAddress: function(responseJson) {
	    if (responseJson.mdoLocation && responseJson.mdoLocation.address != null && responseJson.mdoLocation.address != undefined) {
	    	var pickupMdmLoc = $(".mdoPickupLocClass");
		    pickupMdmLoc.empty();
	    	let locationName = responseJson.mdoLocation.name[0].value.split(" ")[0];
	    	let locationNameWithText = locationName + " Costco Distribution Center";
	        let address = responseJson.mdoLocation.address;
	        let line1 = address.line1;
	        let city = address.city.charAt(0)+address.city.slice(1).toLowerCase();
	        let state = address.territory;
	        let postalCode = address.postalCode;
	        let showaddress;
	        showaddress = locationNameWithText+"<br>"+line1+"<br>"+city+", "+state+" "+postalCode;
	        var createaddressDiv = $("<div style='color: #333333; font-size: 14px; font-style: normal; font-weight: 400; line-height: 20px !important;'></div>").html(showaddress);
	        pickupMdmLoc.append(createaddressDiv);
	    }
	},

	
    /**
     * Method to call WCS command to update shipmode and inventory details.
     * @param  {string} respObj
     * @param  {string} isSwitchToPickUp
     */
    callWarehousePickUpCmd: function(respObj, hasPickUpServiceError) {
    	var mdmAPIResp ='';
    	try {
    		 mdmAPIResp = $('#mdmApiResponses').val();
	  		COSTCO.AjaxModular.ajax_update_state({
	    		method: 'POST',
	    		url: '/AjaxPickUpWarehouseUpdateCmd',
	    		data: [{
	                name: "pickUpAPIResponses",
	                value: JSON.stringify(respObj)
    			},{
	                name: "mdmApiResponses",
	                value: mdmAPIResp
    			}],
	    		done: function(data, textStatus, jqXHR, options) {
	    			console.log("Pickup API details updated to Backend")
	    		}
	    	});
    	} catch (e) {
    		console.error(e);
    	}
    },
    
    /**
     * Method to display PickUp molecule details
     */
    repaintPickUpMolecule: function(respObj, isSwitchToPickUp, shipModeSwitch, isSwitchToDelivery, updatedOrderItemId) {
    	if(respObj != undefined && respObj != null) {
	    	var keys = Object.keys(respObj);
	    	var mdmApiResponJson;
	    	var triggerMdmApiOnce = 1;
	    	var clientIdentifier=$('#wh_DetailParam_ClientId').val();
	    	for(var i=0; i<keys.length;i++){
	    		var key = keys[i];
	    		var request = {};
				var respJson =  respObj[key];
				if(key.indexOf('orderItemId_') !== -1) {
	    			var orderItemId = key.split('orderItemId_')[1];
		    	    var isBopiwItem = false;
		    	    var isStwItem = false;
		    	    var isMdoItem = false;
		    	    var isSiteControlledOnly = respJson.siteControlledOnlyItem != undefined && respJson.siteControlledOnlyItem != null && respJson.siteControlledOnlyItem;
		    	    var stw = respJson.shipToWarehouse;
		    	    var isSiteControlledAndMdoitem = false;
		    	    var ltlPickUpNode =  respJson.warehouseAvailability.ltlPickUp;
		    	    var wioError = $('[id^=error_pickup_wio_disabled_'+orderItemId+']');
		    	    var quantity = COSTCO.OrderItems.getOrderItemQuantity(orderItemId, respJson.quantity, isSwitchToPickUp);
		    	    let isltlPickupItemSelected = $('#ship-mode-radio-ltl-pickup_'+orderItemId).parent().find('input[type=radio]').attr('checked');
		    	    if(respJson.warehouseAvailability != undefined && respJson.warehouseAvailability != null && !isSiteControlledOnly) {
		    	    	/** Parse PickUp API Response and see if Items is BOPIW eligible then render PickUP molecule for BOPIW. */
	        			var bopiw = respJson.warehouseAvailability.useWarehouseInventory;
	        			var mdoAddedFromPdp = respJson.ltlpickupfrompdp;
	        			if(isSwitchToDelivery && orderItemId == updatedOrderItemId){
	        				$('#pick_up_text_'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	        			} else{
	        				$('#pick_up_text_'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_STW);
	        			}
	        			if(bopiw != undefined && bopiw != null && bopiw.buyable != undefined && bopiw.buyable != null && bopiw.buyable && quantity <= bopiw.maxUnitsAvailable 
	        					&& wioError != undefined && wioError.length < 1) {
	        				/** Display PBOPIW PickUp molecule when Buyable True and Max units available >= requested quantity */
	        				isBopiwItem = true;
	        				$('#pickUpLabel-'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	        				$('#pick_up_text_'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	        				var pickupDate = COSTCO.OrderItems.checkEDT(bopiw.orderPickup);
	        				$('#pickUp-edd-'+orderItemId).html(pickupDate);
	        				if(pickupDate == messages.ORD_WAREHOUSE_EDT_TODAY_BOPIW){
	        					$('#pickUp-edd-hours-'+orderItemId).html(messages.ORD_WAREHOUSE_EDT_TODAY_BOPIW_HOURS);
	        		        }
	        				$('#pickUp-edd-espot-'+orderItemId).addClass("hidden");
        					var oldEdd = $('#edtPickUp_'+orderItemId).val();
        					oldEdd = (oldEdd != undefined && oldEdd != null && oldEdd != '') ? oldEdd : null;
        					var newEdd = (bopiw.orderPickup != undefined &&  bopiw.orderPickup != null &&  bopiw.orderPickup != '') ? bopiw.orderPickup : null;
        					if(!isSwitchToPickUp && oldEdd != newEdd) {
	        					$('#orderDateChanged_'+orderItemId).removeClass("hidden");
	        				}
	        			} else if(!respJson.locationControlledItem && respJson.shipToWarehouseItem){
	        				var siteInventory = respJson.siteInventory;
	        				if(siteInventory != undefined && siteInventory != null 
	        						&& siteInventory != '' && siteInventory) {
	        					/** When Items is BOPIW buyable false But its STW + SiteControlled and Site Inventory is available */
	        					isBopiwItem = true;
                                COSTCO.OrderItems.showSTWPickUpEDD(orderItemId, stw, isSwitchToPickUp);
	        				} else {
	        					/** Show PickUp unavailable error when BOPIW buyable false, and SiteInventory is unavailable  */
	        					COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
	        				}
	        			}
	        			 if (ltlPickUpNode != undefined && ltlPickUpNode != null && ltlPickUpNode.buyable != undefined && ltlPickUpNode.buyable != null) {
	        				 //invoke mdm pickupapi to get open hours for the pickup location
     				         var ltlPickupLoc = ltlPickUpNode.fulfillmentCenter;
     				         var mdmApiResponJsonString = $('#mdmApiResponses').val();
     				         if(mdmApiResponJsonString != ""){
     				        	  var jsonObject = JSON.parse(mdmApiResponJsonString);
     				        	  mdmApiResponJson = jsonObject;
     				         }
     				        /** Trigger MDM API when counter is 1 Once triggered make it increment  */
     				        if(ltlPickupLoc != undefined && ltlPickupLoc.includes("-3pl") && triggerMdmApiOnce == 1){
     				        	 var ltlPickupLocValue = ltlPickupLoc.split("-")[0];
     				        	 if(mdmApiResponJson == undefined || mdmApiResponJson.mdoLocation.mdoId != ltlPickupLocValue){
     				        		mdmApiResponJson = COSTCO.OrderItems.invokeMdmAPI(clientIdentifier, ltlPickupLocValue);
         				         	triggerMdmApiOnce++;
     				        	 }
     				         }
     				        if(mdmApiResponJson != null && mdmApiResponJson != undefined && mdmApiResponJson != false){
     				        	$('#mdmApiResponses').val(JSON.stringify(mdmApiResponJson));
     				        	COSTCO.OrderItems.parseMdmApiHoursAndHolidays(mdmApiResponJson, orderItemId, isltlPickupItemSelected);
     				        }else{
     				        	/** Show Fallback When MDM API is down  */
     				        	$('#mdmFailHoursText-'+orderItemId).removeClass('hidden');
     				        	$('#mdm-edd-fails-'+orderItemId).removeClass('hidden');
     				        	if(checkoutPage === 'review'){
     				        		if ($(".mdo-mixed-cart").is(':visible')){
     				        			$("#show-mdoApi-pickUp-hours-label-"+orderItemId).empty();
     				        		}
     				        	}
     				        }
	        				if(ltlPickUpNode.buyable && quantity <= ltlPickUpNode.maxUnitsAvailable 
		        					&& wioError != undefined && wioError.length < 1) {
	        						isMdoItem = true;
			        				$('#mdoLabel-'+orderItemId).html(messages.ORD_MARKET_DELIVERY_LABEL_MDO);
			        				var pickupDate = COSTCO.OrderItems.checkEDT(ltlPickUpNode.orderPickup, true);
			        				if(mdmApiResponJson != null && mdmApiResponJson != undefined && mdmApiResponJson != false){
			        					$('#mdo-pickUp-edd-'+orderItemId).html(messages.ORD_MARKET_DELIVERY_ESTIMATED_LABEL_MDO+" "+ pickupDate); 
			        				}
		        					$('#mdo-text-'+orderItemId).html(messages.ORD_MARKET_DISTRIBUTION_LABEL_MDO); 
		        					var oldEdd = $('#mdoEdtPickUp_'+orderItemId).val();
		        					oldEdd = (oldEdd != undefined && oldEdd != null && oldEdd != '') ? oldEdd : null;
		        					var newEdd = (ltlPickUpNode.orderPickup != undefined &&  ltlPickUpNode.orderPickup != null &&  ltlPickUpNode.orderPickup != '') ? ltlPickUpNode.orderPickup : null;
		        					if(!isSwitchToPickUp && oldEdd != newEdd && $('[id^=ship-mode-radio-ltl-pickup_'+orderItemId+']').length > 0) {
		        						$('#orderDateChanged_'+orderItemId).removeClass("hidden");
			        				}
		        				}
	        				else {
	        					if(isltlPickupItemSelected){
	        					/** Show PickUp unavailable error when BOPIM buyable false */
	        					COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);}
	        				}
	        			} else if (ltlPickUpNode == undefined || ltlPickUpNode == null || ltlPickUpNode.buyable == undefined || ltlPickUpNode.buyable == null) {
	        				/** isStwItem and isBopiwItem are default to false **/
	        				if(isStwItem && isBopiwItem && isltlPickupItemSelected){
	        				/** Show PickUp unavailable error when BOPIM added from pdp and if ltlpickup json is null in response*/
        					COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	        				}
	        			}
	        		}
	        		if(!isBopiwItem && !isltlPickupItemSelected && respJson.shipToWarehouseItem && stw != undefined && stw != null && respJson.locationControlledItem) {
	        			if(stw.availability != undefined && stw.availability != null && 
	        				(stw.availability == 'INSTOCK' || stw.availability == 'LOWSTOCK')) {
	        				/** Display pickup molecule when item is not eligible for BOPIW, But Shiptowarehouse available and its InStock or LowStock */
	        				isStwItem = true;
	        				COSTCO.OrderItems.showSTWPickUpEDD(orderItemId, stw, isSwitchToPickUp);
	        			} else {
	        				if(isltlPickupItemSelected && !isMdoItem) {
	        					/** Show PickUp unavailable error when BOPIM buyable false, and ShipToWarehouse OOS  */
	        					COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	        				} else {
		        				/** Show PickUp unavailable error when BOPIW buyable false, and ShipToWarehouse OOS  */
		        				$('#pick_up_text_'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
		        				COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
	        				}
	        			}
	        		}
	        		/** to check if the item is site controlled with ltlpickup and mdopickup selected */
	        		if (isSiteControlledOnly &&  ltlPickUpNode != undefined && ltlPickUpNode != null && ltlPickUpNode.buyable != undefined && ltlPickUpNode.buyable != null && isSiteControlledOnly) 
	        		{
	        			var ltlPickupLoc = ltlPickUpNode.fulfillmentCenter;
				         var mdmApiResponJsonString = $('#mdmApiResponses').val();
				         if(mdmApiResponJsonString != ""){
				        	  var jsonObject = JSON.parse(mdmApiResponJsonString);
				        	  mdmApiResponJson = jsonObject;
				         }
				        /** Trigger MDM API when counter is 1 Once triggered make it increment  */
				        if(ltlPickupLoc != undefined && ltlPickupLoc.includes("-3pl") && triggerMdmApiOnce == 1){
				        	 var ltlPickupLocValue = ltlPickupLoc.split("-")[0];
				        	 if(mdmApiResponJson == undefined || mdmApiResponJson.mdoLocation.mdoId != ltlPickupLocValue){
				        		mdmApiResponJson = COSTCO.OrderItems.invokeMdmAPI(clientIdentifier, ltlPickupLocValue);
    				         	triggerMdmApiOnce++;
				        	 }
				         }
				        if(mdmApiResponJson != null && mdmApiResponJson != undefined && mdmApiResponJson != false){
				        	$('#mdmApiResponses').val(JSON.stringify(mdmApiResponJson));
				        	COSTCO.OrderItems.parseMdmApiHoursAndHolidays(mdmApiResponJson, orderItemId, isltlPickupItemSelected);
				        }else{
				        	/** Show Fallback When MDM API is down  */
				        	$('#mdmFailHoursText-'+orderItemId).removeClass('hidden');
				        	$('#mdm-edd-fails-'+orderItemId).removeClass('hidden');
				        	if(checkoutPage === 'review'){
				        		if ($(".mdo-mixed-cart").is(':visible')){
				        			$("#show-mdoApi-pickUp-hours-label-"+orderItemId).empty();
				        		}
				        	}
				        }
        				if(ltlPickUpNode.buyable && quantity <= ltlPickUpNode.maxUnitsAvailable 
	        					&& wioError != undefined && wioError.length < 1) {
	        					isMdoItem = true;
		        				$('#mdoLabel-'+orderItemId).html(messages.ORD_MARKET_DELIVERY_LABEL_MDO);
		        				var pickupDate = COSTCO.OrderItems.checkEDT(ltlPickUpNode.orderPickup, true);
		        				if(mdmApiResponJson != null && mdmApiResponJson != undefined && mdmApiResponJson != false){
		        					$('#mdo-pickUp-edd-'+orderItemId).html(messages.ORD_MARKET_DELIVERY_ESTIMATED_LABEL_MDO+" "+ pickupDate); 
		        				}
	        					$('#mdo-text-'+orderItemId).html(messages.ORD_MARKET_DISTRIBUTION_LABEL_MDO);
	        					var oldEdd = $('#mdoEdtPickUp_'+orderItemId).val();
	        					oldEdd = (oldEdd != undefined && oldEdd != null && oldEdd != '') ? oldEdd : null;
	        					var newEdd = (ltlPickUpNode.orderPickup != undefined &&  ltlPickUpNode.orderPickup != null &&  ltlPickUpNode.orderPickup != '') ? ltlPickUpNode.orderPickup : null;
	        					if(!isSwitchToPickUp && oldEdd != newEdd && $('[id^=ship-mode-radio-ltl-pickup_'+orderItemId+']').length > 0) {
	        						$('#orderDateChanged_'+orderItemId).removeClass("hidden");
		        				}
	        					if (isSiteControlledOnly && isltlPickupItemSelected) {
	        						isSiteControlledAndMdoitem = true;
	        					}
	        				}
        				else {
        					if(isltlPickupItemSelected){
        					/** Show PickUp unavailable error when BOPIM buyable false */
        					COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);}
        				}
	        		} 
	        		else if(!isltlPickupItemSelected && ltlPickUpNode != undefined && ltlPickUpNode.buyable != undefined && ltlPickUpNode.buyable){
	        			if($('[id^=ship-mode-radio-ltl-pickup_'+orderItemId+']').length > 0){
	        				var pickupDate = COSTCO.OrderItems.checkEDT(ltlPickUpNode.orderPickup, true);
	        				if(mdmApiResponJson != null && mdmApiResponJson != undefined && mdmApiResponJson != false){
	        				$('#mdo-pickUp-edd-'+orderItemId).html(messages.ORD_MARKET_DELIVERY_ESTIMATED_LABEL_MDO+" "+ pickupDate); }

	        			}
	        		}
	        		
	        		else if ((ltlPickUpNode == undefined || ltlPickUpNode == null || ltlPickUpNode.buyable == undefined || ltlPickUpNode.buyable == null) && isltlPickupItemSelected) {
	    					COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	        			}
	        		else if(isSiteControlledOnly && !isSiteControlledAndMdoitem) {
		        			var siteInventory = respJson.siteInventory;
		    				if(siteInventory != undefined && siteInventory != null && siteInventory != '' && siteInventory) {
		        				isStwItem = true;
		        				/** Display pick up molecule as available when STW + SiteControlled Item when Site Inventory is available */
		        				COSTCO.OrderItems.showSTWPickUpEDD(orderItemId, stw, isSwitchToPickUp);
		    				} else {
			    					/** Show PickUp unavailable error when BOPIW buyable false, and ShipToWarehouse OOS  */
			        				COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
		    					}
		        			}
	        		
	        		if(!isMdoItem){
	        			if(isltlPickupItemSelected && !isMdoItem){
	        				/** Show PickUp unavailable error when item is not satsfied for BOPIM PickUp Availability  */
	        				COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
	        			}
	        		}
	        		if(!isBopiwItem && !isStwItem) {
	        			/** Show PickUp unavailable error when item is not satsfied for BOPIW or STW PickUp Availability  */
	        			if(!respJson.shipToWarehouseItem){
	        				$('#pick_up_text_'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	        			}
	        			COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
	        		} else {
	        			const whsActive = $('#warehouseActive_' + orderItemId).val();
	        			if (whsActive === "true") {
	        			    $('#error_pickup_unavailable_' + orderItemId).addClass('hidden');
	        			} else {
	        			    COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
	        			}
	        		}
		    	} else if(key.indexOf('siteControlled_') !== -1) {
		    		/** This block executes when Item is STW + SiteControlled and no EDD */
		    		var siteInventory = respJson.siteInventory;
		    		var orderItemId = key.split('siteControlled_')[1];
		    		if(shipModeSwitch){
		    			if(isSwitchToDelivery && orderItemId == updatedOrderItemId){
	        				$('#pick_up_text_'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW);
	        			} else if(!isSwitchToDelivery && orderItemId == updatedOrderItemId){
	        				$('#pick_up_text_'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_STW);
	        			}
		    		}else{
		    			$('#pick_up_text_'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_STW);
		    		}
		    		
    				if(siteInventory != undefined && siteInventory != null 
    						&& siteInventory != '' && siteInventory) {
    					/** Display PickUp molecule as available when site inventory is InStock */
    		    		COSTCO.OrderItems.showPickUpEDD(orderItemId, null, messages.EDD_ESTIMATED_PICKUP);
    		    		$('#ship-mode-radio-warehouse-pickup_'+orderItemId).parent().find('input[type=radio]').removeAttr('disabled');
    				} else {
    					if(isltlPickupItemSelected && !isMdoItem) {
    						/** Show Mdo PickUp available error when SiteInevntory is OOS */
        					COSTCO.OrderItems.showMdoPickUpUnAvailable(orderItemId, shipModeSwitch);
        				} else {
	    					/** Show PickUp unavalable error when SiteInevntory is OOS */
	        				COSTCO.OrderItems.showPickUpUnAvailable(orderItemId, shipModeSwitch);
        				}
        			}
		    	}
	    	}
    	}
    	COSTCO.Header.popovers();
    },

	/**
     * Method to format Date
     */
	checkEDT: function(dateValue, showEddDate) {
		let date = new Date(dateValue);
		let splitDate = dateValue.split('-');
        let year = splitDate[0];
        let month = splitDate[1] - 1;
        let day = splitDate[2];
        let langId = COSTCO.util.getLangId();
        let daysOfWeek;
        let monthName;
        let dateFormat;
		let today = new Date();
		let tomorrow = new Date();
		var edt = "";
		tomorrow.setDate(tomorrow.getDate() + 1);
		showEddDate = showEddDate ? showEddDate:false;
		if(!showEddDate){
			if (date.toDateString() === today.toDateString()) {
				edt = messages.ORD_WAREHOUSE_EDT_TODAY_BOPIW;
		    } else if (date.toDateString() === tomorrow.toDateString()) {
		    	edt = messages.ORD_WAREHOUSE_EDT_TOMORROW_BOPIW;
		    } else {
		    	if(langId === '-25'){
		    		edt = new Date(dateValue).toLocaleDateString('fr-CA',{weekday: 'long', month : 'long', day:'numeric', year:'numeric'});
		          }else{
		        	  edt = new Date(dateValue).toLocaleDateString('en-US',{weekday: 'long', month : 'long', day:'numeric', year:'numeric'}); 
		          }
		    }
		} else {
			if(langId === '-25'){
	    		edt = new Date(dateValue).toLocaleDateString('fr-CA',{weekday: 'long', month : 'long', day:'numeric', year:'numeric'});
	          }else{
	        	  edt = new Date(dateValue).toLocaleDateString('en-US',{weekday: 'long', month : 'long', day:'numeric', year:'numeric'}); 
	          }
		}
		return edt;
	},
	
	/**
	 * Method to display PickUp EDD values in the PickUp molecule for STW items.
	 */
	showSTWPickUpEDD: function(orderItemId, stw, isSwitchToPickUp) {
		var eddValue = null;
		var oldEdd = $('#edtPickUp_'+orderItemId).val();
		oldEdd = (oldEdd != undefined && oldEdd != null && oldEdd != '') ? oldEdd : null;
		var newEdd = (stw != undefined && stw != null && stw.estimatedDeliveryDate != undefined 
				&& stw.estimatedDeliveryDate != null && stw.estimatedDeliveryDate != '') ? stw.estimatedDeliveryDate : null;
		if(!isSwitchToPickUp && oldEdd != newEdd) {
			$('#orderDateChanged_'+orderItemId).removeClass("hidden");
		}
		if(newEdd != null) {
			eddValue = COSTCO.OrderItems.checkEDT(newEdd, true);
		}
		COSTCO.OrderItems.showPickUpEDD(orderItemId, eddValue, messages.EDD_ESTIMATED_PICKUP);
	},
	
	/**
	 * Method to display PickUp EDD values in the PickUp molecule.
	 */
	showPickUpEDD: function(orderItemId, edd, pickUpLabel) {
		if(edd != undefined && edd != null && edd != '') {
            $('#pickUp-edd-'+orderItemId).html(edd);
            $('#pickUp-edd-espot-'+orderItemId).addClass("hidden");
        } else {
            $('#pickUp-edd-'+orderItemId).addClass('hidden');
            $('#pickUp-edd-espot-'+orderItemId).removeClass('hidden');
        }
		$('#pickUpLabel-'+orderItemId).html(pickUpLabel);
		$('#carrier-details-'+orderItemId).removeClass('hidden');
	},
	
	/**
	 * Method to display pickup un-available error. 
	 */
	showPickUpUnAvailable: function(orderItemId, shipModeSwitch) {
		var pickUpRadio = $('#ship-mode-radio-warehouse-pickup_'+orderItemId).parent().find('input[type=radio]');
		if(!shipModeSwitch || (pickUpRadio != undefined && pickUpRadio != null && pickUpRadio.is(':checked') && shipModeSwitch)) {
			$('#error_pickup_unavailable_'+orderItemId).removeClass("hidden");
			$('#pickUp-unAvailable-'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW_UNAVAILABLE);
			$('#pickUp-tooltip-'+orderItemId).html('');
			$('#pickUp-memberOnly-'+orderItemId).html('');
			$(pickUpRadio).attr('disabled', true);
			$(pickUpRadio).removeAttr('checked');
		}
	},
	
	/**
	 * Method to display mdo pickup unavailable
	 */
	showMdoPickUpUnAvailable: function(orderItemId, shipModeSwitch) {
		var pickUpRadio = $('#ship-mode-radio-ltl-pickup_'+orderItemId).parent().find('input[type=radio]');
		if(!shipModeSwitch || (pickUpRadio != undefined && pickUpRadio != null && pickUpRadio.is(':checked') && shipModeSwitch)) {
			$('#mdo_error_pickup_unavailable_'+orderItemId).removeClass("hidden");
			let getProductlink = $('#mdo_product_link_'+orderItemId).val();
			let getStoreText = $('#mdo_error_pickup_unavailable_'+orderItemId).html();
			let storetextWithProductLink = getStoreText.replace('{0}', getProductlink);
			$('#mdo_error_pickup_unavailable_'+orderItemId).html(storetextWithProductLink);
			$('#mdo-pickUp-unAvailable-'+orderItemId).html(messages.ORD_WAREHOUSE_PICKUP_LABEL_BOPIW_UNAVAILABLE);
			$('#mdo-pickUp-tooltip-'+orderItemId).html('');
			$('#mdo-pickUp-memberOnly-'+orderItemId).html('');
			$('#mdoLabel-'+orderItemId).html('');
			$('#mdo-pickUp-hours-'+orderItemId).html('');
			$('#mdo-text-'+orderItemId).addClass("hidden");
			$('#carrier-details-'+orderItemId).addClass("hidden");
			$(pickUpRadio).attr('disabled', true);
			$(pickUpRadio).removeAttr('checked');
		}
	},
	
	/**
	 * Method to get orderitem level quantity 
	 */
	getOrderItemQuantity: function(orderItemId, quantity, isSwitchToPickUp) {
		var itemQuantity;
		if(!isSwitchToPickUp) {
			itemQuantity = quantity;
		}
		
		if(isSwitchToPickUp || itemQuantity == undefined || itemQuantity == null) {
			var noOfItems = $('#order-items').find('.order-item').length;
	    	var ordItemQuantity = {};
	    	for (var i = 1; i <= noOfItems; i++) {
	    		var ordItemId = $('#orderItem_' + i).val();
	    		if(orderItemId == ordItemId) {
	    			itemQuantity = $('#quantity_' + i).val();
	    			break;
	    		}
	    	}
		}
    	return itemQuantity;
	}
	
}
  if (typeof window.COSTCO === 'undefined') {
    window.COSTCO = new Object();
  }

  typeof window.COSTCO.Global == 'undefined' ?
    document.addEventListener('OrderItemsLoaded', OrderItems.loaded, false) :
    OrderItems.loaded();

  window.COSTCO.OrderItems = OrderItems;

  return OrderItems;
})


// WEBPACK FOOTER //
// ./js/checkout/orderitems.js